import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AnyFormValue: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AccountAndUserDetailsScreen = {
  __typename?: 'AccountAndUserDetailsScreen';
  /** Will probably be deprecated. Hintay lang sa announcmenet */
  custom_fields?: Maybe<Array<Maybe<AccountAndUserDetailsScreenCustomField>>>;
  form_tab?: Maybe<AccountAndUserDetailsScreenFormTab>;
  form_tabs?: Maybe<Array<Maybe<AccountAndUserDetailsScreenFormTab>>>;
  user_info?: Maybe<PassUserInfo>;
  user_profile?: Maybe<PassUserProfile>;
};


export type AccountAndUserDetailsScreenForm_TabArgs = {
  id: Scalars['ID']['input'];
};

export type AccountAndUserDetailsScreenCustomField = {
  __typename?: 'AccountAndUserDetailsScreenCustomField';
  /**
   * Based on [Records API values](https://docs.google.com/document/d/1IAfbu-lG1SvCLGmilBfQ__fcvylYalCZMpxsPAnAY2Y/edit#heading=h.63wepr9qcwq1)
   *
   * Values:
   *
   * - pending
   * - rejected
   * - approved
   */
  approval_status?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  input_name?: Maybe<Scalars['String']['output']>;
  /**
   * Mostly based on standard [HTML input types](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input)
   *
   * Standard HTML input types:
   *
   * - text
   * - email
   * - checkbox
   * - password
   * - radio
   * - number
   * - file
   * - date
   * - time
   * - datetime-local
   *
   * Non standard HTML input types:
   *
   * - select
   * - textarea
   *
   *
   * Deprecated
   * -
   */
  input_type?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** For approval status */
  needs_approval?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** EXPERIMENT: What if sobrang tailor fit sa UI yung fields instead na susundin yung API objects mula sa microservices? */
export type AccountAndUserDetailsScreenFormSubmissionSummary = {
  __typename?: 'AccountAndUserDetailsScreenFormSubmissionSummary';
  approval_status?: Maybe<Scalars['String']['output']>;
  date_created?: Maybe<Scalars['String']['output']>;
  /** File description/s if available based on uploaded files */
  file_description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** This will be customized depedning on need */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** This will be based on First Record Field that has 'title' or 'name' in the name */
  title?: Maybe<Scalars['String']['output']>;
};

export type AccountAndUserDetailsScreenFormTab = {
  __typename?: 'AccountAndUserDetailsScreenFormTab';
  form_items?: Maybe<Array<Maybe<AccountAndUserDetailsScreenCustomField>>>;
  form_submission_summaries?: Maybe<Array<Maybe<AccountAndUserDetailsScreenFormSubmissionSummary>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AccountAndUserDetailsScreenFormTabResult = {
  __typename?: 'AccountAndUserDetailsScreenFormTabResult';
  form_submission_summary?: Maybe<AccountAndUserDetailsScreenFormSubmissionSummary>;
};

export type AccountAndUserDetailsScreenFormTabSubmit = {
  form_fields?: InputMaybe<Array<InputMaybe<AccountAndUserDetailsScreenFormTabSubmitFormFields>>>;
  form_tab_id: Scalars['ID']['input'];
};

export type AccountAndUserDetailsScreenFormTabSubmitFormFields = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['AnyFormValue']['input']>;
};

export type AccountDetailsUpdate = {
  current_password?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  password_confirmation?: InputMaybe<Scalars['String']['input']>;
};

export type AccountProfileUpdate = {
  custom_fields?: InputMaybe<Scalars['JSONObject']['input']>;
  family_name?: InputMaybe<Scalars['String']['input']>;
  given_name?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLogScreen = {
  __typename?: 'ActivityLogScreen';
  log_groups?: Maybe<Array<Maybe<ActivityLogScreenLogGroup>>>;
};

export type ActivityLogScreenLogGroup = {
  __typename?: 'ActivityLogScreenLogGroup';
  log_items?: Maybe<Array<Maybe<ActivityLogScreenLogGroupItem>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogScreenLogGroupItem = {
  __typename?: 'ActivityLogScreenLogGroupItem';
  cover_uri?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use other fields instead */
  resource?: Maybe<Resource>;
  resource_uuid?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  verb?: Maybe<Scalars['String']['output']>;
};

export type AssessmentViewScreen = {
  __typename?: 'AssessmentViewScreen';
  course_block_uuid?: Maybe<Scalars['String']['output']>;
  exam?: Maybe<Exam>;
  exam_item_set?: Maybe<ExamItemSet>;
  exam_timeslot?: Maybe<ExamTimeslot>;
  exam_timeslot_uuid?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Resource>;
  resource_uuid?: Maybe<Scalars['String']['output']>;
};

export type AssessmentViewScreenAssessmentResponseResult = {
  __typename?: 'AssessmentViewScreenAssessmentResponseResult';
  responses?: Maybe<Array<Maybe<ExamResponse>>>;
  submission_info?: Maybe<SubmissionInfo>;
};

export type AssessmentViewScreenAssessmentSubmitResult = {
  __typename?: 'AssessmentViewScreenAssessmentSubmitResult';
  /**
   * Get freedom wall item responses for the given exam item uuid.
   *
   * This will be null if no exam item uuid is provided.
   */
  freedomwall_exam_item_responses?: Maybe<Array<Maybe<ExamResponse>>>;
  submission_result?: Maybe<ExamSubmission>;
};


export type AssessmentViewScreenAssessmentSubmitResultFreedomwall_Exam_Item_ResponsesArgs = {
  freedomwall_exam_item_uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type AssessmentViewScreenAssessmentSubmitResultV2 = {
  __typename?: 'AssessmentViewScreenAssessmentSubmitResultV2';
  course_block_submission_result?: Maybe<CourseBlockUuidUserStatusSubmission>;
  submission_result?: Maybe<ExamSubmission>;
};

export type BlockDetails = {
  __typename?: 'BlockDetails';
  required_for_certificate?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BrowserTitleBar = {
  __typename?: 'BrowserTitleBar';
  favicon_uri?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  pwa?: Maybe<PwaIcons>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Cast = {
  __typename?: 'Cast';
  attributes?: Maybe<CastAttributes>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CastAppearance = {
  __typename?: 'CastAppearance';
  background_color?: Maybe<CastColor>;
  background_image?: Maybe<Scalars['String']['output']>;
  font_family?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  foreground_color?: Maybe<CastColor>;
};

export type CastAttributes = {
  __typename?: 'CastAttributes';
  allow_guest_login?: Maybe<Scalars['Boolean']['output']>;
  auth?: Maybe<CastAttributesAuth>;
  cast_icon?: Maybe<CastAttributesIcon>;
  claim_guest_account_message?: Maybe<Scalars['String']['output']>;
  deactivated_users_group_id?: Maybe<Scalars['String']['output']>;
  default_group_id?: Maybe<Scalars['String']['output']>;
  default_login_as_guest?: Maybe<Scalars['Boolean']['output']>;
  home_screen?: Maybe<Scalars['String']['output']>;
  initial_block_id?: Maybe<Scalars['String']['output']>;
  logout_after_x_seconds?: Maybe<Scalars['String']['output']>;
  logout_prompt_after_x_seconds?: Maybe<Scalars['String']['output']>;
  required_user_profile_attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  search_slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CastAttributesAuth = {
  __typename?: 'CastAttributesAuth';
  client_id?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CastAttributesIcon = {
  __typename?: 'CastAttributesIcon';
  pwa?: Maybe<PwaIcons>;
  web?: Maybe<CastAttributesIconTypes>;
};

export type CastAttributesIconTypes = {
  __typename?: 'CastAttributesIconTypes';
  banner?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  hero?: Maybe<Scalars['String']['output']>;
  nav?: Maybe<Scalars['String']['output']>;
};

export type CastBlock = {
  __typename?: 'CastBlock';
  attributes?: Maybe<CastBlockAttributes>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CastBlockAttributes = {
  __typename?: 'CastBlockAttributes';
  id?: Maybe<Scalars['ID']['output']>;
  properties?: Maybe<CastBlockAttributesProperties>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CastBlockAttributesProperties = CastBlockPropertiesButtonSearch | CastBlockPropertiesCarousel | CastBlockPropertiesCatalog | CastBlockPropertiesCategory | CastBlockPropertiesCourseStatus | CastBlockPropertiesDirectory | CastBlockPropertiesEmbed | CastBlockPropertiesMarkdown | CastBlockPropertiesNotSupported;

export type CastBlockListScreen = {
  __typename?: 'CastBlockListScreen';
  cast?: Maybe<Cast>;
  cast_blocks?: Maybe<Array<Maybe<CastBlock>>>;
  cast_screen?: Maybe<CastScreen>;
  id?: Maybe<Scalars['ID']['output']>;
};


export type CastBlockListScreenCast_BlocksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CastBlockPropertiesButtonSearch = {
  __typename?: 'CastBlockPropertiesButtonSearch';
  _dummy?: Maybe<Scalars['String']['output']>;
  appearance?: Maybe<CastBlockPropertiesButtonSearchAppearance>;
  id?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CastBlockPropertiesButtonSearchAppearance = {
  __typename?: 'CastBlockPropertiesButtonSearchAppearance';
  base?: Maybe<CastAppearance>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CastBlockPropertiesCarousel = {
  __typename?: 'CastBlockPropertiesCarousel';
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<CastBlockPropertiesCarouselItems>>>;
};

export type CastBlockPropertiesCarouselItems = {
  __typename?: 'CastBlockPropertiesCarouselItems';
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CastBlockPropertiesCatalog = {
  __typename?: 'CastBlockPropertiesCatalog';
  appearance?: Maybe<CastBlockPropertiesCatalogAppearance>;
  id?: Maybe<Scalars['ID']['output']>;
  layout?: Maybe<CastBlockPropertiesCatalogLayout>;
  limit?: Maybe<Scalars['Int']['output']>;
  resource_collection?: Maybe<ResourceCollection>;
  resources?: Maybe<Array<Maybe<Resource>>>;
  uuid?: Maybe<Scalars['ID']['output']>;
};


export type CastBlockPropertiesCatalogResourcesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CastBlockPropertiesCatalogAppearance = {
  __typename?: 'CastBlockPropertiesCatalogAppearance';
  base?: Maybe<CastAppearance>;
  card_header?: Maybe<CastAppearance>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CastBlockPropertiesCatalogLayout = {
  __typename?: 'CastBlockPropertiesCatalogLayout';
  id?: Maybe<Scalars['ID']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CastBlockPropertiesCategory = {
  __typename?: 'CastBlockPropertiesCategory';
  collection_uuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  collections?: Maybe<Array<Maybe<ResourceCollection>>>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CastBlockPropertiesCourseStatus = {
  __typename?: 'CastBlockPropertiesCourseStatus';
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CastBlockPropertiesDirectory = {
  __typename?: 'CastBlockPropertiesDirectory';
  base_path?: Maybe<Scalars['String']['output']>;
  directory?: Maybe<Array<Maybe<CastBlockPropertiesDirectoryPaths>>>;
  id?: Maybe<Scalars['ID']['output']>;
  resources?: Maybe<Array<Maybe<Resource>>>;
};

export type CastBlockPropertiesDirectoryPaths = {
  __typename?: 'CastBlockPropertiesDirectoryPaths';
  id?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type CastBlockPropertiesEmbed = {
  __typename?: 'CastBlockPropertiesEmbed';
  id?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CastBlockPropertiesMarkdown = {
  __typename?: 'CastBlockPropertiesMarkdown';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CastBlockPropertiesNotSupported = {
  __typename?: 'CastBlockPropertiesNotSupported';
  _dummy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CastColor = {
  __typename?: 'CastColor';
  alpha?: Maybe<Scalars['Float']['output']>;
  blue?: Maybe<Scalars['Float']['output']>;
  green?: Maybe<Scalars['Float']['output']>;
  red?: Maybe<Scalars['Float']['output']>;
};

export type CastIcon = {
  __typename?: 'CastIcon';
  material?: Maybe<Scalars['String']['output']>;
  sf_symbols?: Maybe<Scalars['String']['output']>;
};

export type CastScreen = {
  __typename?: 'CastScreen';
  attributes?: Maybe<CastScreenAttributes>;
  blocks?: Maybe<Array<Maybe<CastBlock>>>;
  id?: Maybe<Scalars['String']['output']>;
};

export type CastScreenAttributes = {
  __typename?: 'CastScreenAttributes';
  cast_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CasticulateEdge = {
  __typename?: 'CasticulateEdge';
  data?: Maybe<Scalars['JSONObject']['output']>;
  from_node?: Maybe<CasticulateNode>;
  from_node_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  to_node?: Maybe<CasticulateNode>;
  to_node_id?: Maybe<Scalars['String']['output']>;
  triggers?: Maybe<Array<Maybe<CasticulateTrigger>>>;
};

export type CasticulateGraph = {
  __typename?: 'CasticulateGraph';
  edges?: Maybe<Array<Maybe<CasticulateEdge>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nodes?: Maybe<Array<Maybe<CasticulateNode>>>;
  possible_routes?: Maybe<Array<Maybe<Array<Maybe<CasticulateNode>>>>>;
};

export type CasticulateIdsInput = {
  casticulate_uuid: Scalars['ID']['input'];
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  course_uuid?: InputMaybe<Scalars['String']['input']>;
  resource_uuid?: InputMaybe<Scalars['String']['input']>;
};

export type CasticulateLayout = {
  __typename?: 'CasticulateLayout';
  html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CasticulateNode = {
  __typename?: 'CasticulateNode';
  data?: Maybe<Scalars['JSONObject']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_end_node?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `template` instead */
  layout?: Maybe<CasticulateLayout>;
  slide_type?: Maybe<Scalars['String']['output']>;
  template?: Maybe<CasticulateTemplate>;
};

export type CasticulatePath = {
  __typename?: 'CasticulatePath';
  edge?: Maybe<CasticulateEdge>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CasticulateState = {
  __typename?: 'CasticulateState';
  data?: Maybe<Scalars['JSONObject']['output']>;
  has_state?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CasticulateTemplate = {
  __typename?: 'CasticulateTemplate';
  html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  template_type?: Maybe<Scalars['String']['output']>;
};

export type CasticulateTrigger = {
  __typename?: 'CasticulateTrigger';
  action?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ref_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CasticulateViewScreen = {
  __typename?: 'CasticulateViewScreen';
  casticulate_graph?: Maybe<CasticulateGraph>;
  casticulate_state?: Maybe<CasticulateState>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CatalogListScreen = {
  __typename?: 'CatalogListScreen';
  cast_block?: Maybe<CastBlock>;
  id?: Maybe<Scalars['ID']['output']>;
  resource_collection?: Maybe<ResourceCollection>;
  resource_collection_uuid?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Maybe<Resource>>>;
};

export type CheckoutCreateResult = {
  __typename?: 'CheckoutCreateResult';
  checkout_token?: Maybe<PayCheckoutToken>;
};

export type ChildDomainOutline = {
  __typename?: 'ChildDomainOutline';
  applications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  indicators?: Maybe<Array<Maybe<TrainingIndicatorPoints>>>;
  modified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  total_points?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Course = {
  __typename?: 'Course';
  allowed_actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  are_user_sections_complete?: Maybe<Scalars['Boolean']['output']>;
  courses_this_is_a_prerequisite_for?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cover_uri?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enrolled_schedules?: Maybe<Array<Maybe<CourseSchedule>>>;
  enrollment_info?: Maybe<EnrollmentInfo>;
  has_user_completed?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_accessible?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Computed value
   *
   * True if allowed actions includes "take". Else false.
   */
  is_enrolled?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  next_courses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  outline?: Maybe<Array<Maybe<CourseSection>>>;
  prerequisites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated This shouldn't be used anymore */
  schedules?: Maybe<Array<Maybe<CourseSchedule>>>;
  /** @deprecated In favor of 'outline' */
  sections?: Maybe<Array<Maybe<CourseSection>>>;
  self_enroll_schedules?: Maybe<Array<Maybe<CourseSchedule>>>;
  style_info?: Maybe<CourseStyleInfo>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseBlock = {
  __typename?: 'CourseBlock';
  blocks_this_is_a_prerequisite_for?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  blocks_this_is_a_prerequisite_for_joined?: Maybe<Array<Maybe<CourseBlock>>>;
  certificate_block_status?: Maybe<Array<Maybe<CourseCertificateBlockStatus>>>;
  /**
   * Computed value
   *
   * Based in first course_block_status status field
   */
  certificate_block_status_value?: Maybe<Scalars['String']['output']>;
  complete_externally?: Maybe<Scalars['Boolean']['output']>;
  complete_on_final?: Maybe<Scalars['Boolean']['output']>;
  complete_on_passing?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['JSONObject']['output']>;
  cover_uri?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  days_til_expired?: Maybe<Scalars['Int']['output']>;
  expiry_date?: Maybe<Scalars['String']['output']>;
  has_user_completed?: Maybe<Scalars['Boolean']['output']>;
  is_accessible?: Maybe<Scalars['Boolean']['output']>;
  max_submissions_reached?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  next_blocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  next_blocks_joined?: Maybe<Array<Maybe<CourseBlock>>>;
  number_of_days?: Maybe<Scalars['Int']['output']>;
  open_date?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['String']['output']>;
  prerequisites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  prerequisites_course_blocks?: Maybe<Array<Maybe<CourseBlock>>>;
  /** @deprecated In favor of 'prerequisites_course_blocks' */
  prerequisites_joined?: Maybe<Array<Maybe<CourseBlock>>>;
  reference_info?: Maybe<CourseBlockReferenceInfo>;
  required?: Maybe<Scalars['Boolean']['output']>;
  required_for_certificate?: Maybe<Scalars['Boolean']['output']>;
  resource?: Maybe<Resource>;
  schedule_reference_info?: Maybe<CourseBlockScheduleReferenceInfo>;
  section?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userstatus?: Maybe<CourseBlockUserstatus>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseBlockExamResponse = {
  choices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  input?: InputMaybe<Scalars['String']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  long_input?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  response_uuid?: InputMaybe<Scalars['String']['input']>;
  short_input?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type CourseBlockExamResponseResult = {
  __typename?: 'CourseBlockExamResponseResult';
  responses?: Maybe<Array<Maybe<CourseBlockUuidUserStatusSubmissionResponse>>>;
  submission_info?: Maybe<SubmissionInfo>;
};

export type CourseBlockExamSubmission = {
  item_set?: InputMaybe<Scalars['Boolean']['input']>;
  responses?: InputMaybe<Array<InputMaybe<CourseBlockExamResponse>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  timeslot?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type CourseBlockExamSubmissionResponse = {
  responses?: InputMaybe<Array<InputMaybe<CourseBlockExamResponse>>>;
  submission?: InputMaybe<Scalars['String']['input']>;
};

export type CourseBlockExamSubmitResult = {
  __typename?: 'CourseBlockExamSubmitResult';
  /**
   * Get freedom wall item responses for the given exam item uuid.
   *
   * This will be null if no exam item uuid is provided.
   * @deprecated In favor of 'freedom_wall_responses'
   */
  freedomwall_exam_item_responses?: Maybe<Array<Maybe<ExamResponse>>>;
  submission_result?: Maybe<CourseBlockUuidUserStatusSubmission>;
};


export type CourseBlockExamSubmitResultFreedomwall_Exam_Item_ResponsesArgs = {
  freedomwall_exam_item_uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type CourseBlockExamSubmitResultV2 = {
  __typename?: 'CourseBlockExamSubmitResultV2';
  submission_result?: Maybe<CourseBlockUuidUserStatusSubmissionV2>;
};

export type CourseBlockReferenceInfo = {
  __typename?: 'CourseBlockReferenceInfo';
  custom_passing_mark?: Maybe<Scalars['Int']['output']>;
  exam_timeslot?: Maybe<ExamTimeslot>;
  max_allowed_submissions?: Maybe<Scalars['Int']['output']>;
  pass_on_submit?: Maybe<Scalars['Boolean']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
};

export type CourseBlockScheduleReferenceInfo = {
  __typename?: 'CourseBlockScheduleReferenceInfo';
  id?: Maybe<Scalars['String']['output']>;
  max_allowed_submissions?: Maybe<Scalars['Int']['output']>;
  open_date?: Maybe<Scalars['String']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
};

export type CourseBlockStatus = {
  __typename?: 'CourseBlockStatus';
  block_details?: Maybe<BlockDetails>;
  score_max?: Maybe<Scalars['Int']['output']>;
  score_raw?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CourseBlockUserstatus = {
  __typename?: 'CourseBlockUserstatus';
  grade_percent?: Maybe<Scalars['Int']['output']>;
  is_complete?: Maybe<Scalars['Boolean']['output']>;
  score_max?: Maybe<Scalars['Float']['output']>;
  score_min?: Maybe<Scalars['Float']['output']>;
  score_raw?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_count?: Maybe<Scalars['Int']['output']>;
  submission_status?: Maybe<Scalars['String']['output']>;
  training_info?: Maybe<CourseUserCompletedBlockIndicator>;
};

export type CourseBlockUuidUserStatusSubmission = {
  __typename?: 'CourseBlockUuidUserStatusSubmission';
  block_status?: Maybe<CourseBlockUserstatus>;
  certificate_block_statuses?: Maybe<Array<Maybe<CourseCertificateBlockStatus>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  ended_at?: Maybe<Scalars['String']['output']>;
  final?: Maybe<Scalars['Boolean']['output']>;
  highest_possible_submission_score?: Maybe<Scalars['Int']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  response_scores_sum?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Array<Maybe<CourseBlockUuidUserStatusSubmissionResponse>>>;
  responses_count?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_count?: Maybe<Scalars['Int']['output']>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  timeslot?: Maybe<Scalars['ID']['output']>;
  total_item_limit?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  training_info?: Maybe<CourseUserCompletedBlockIndicator>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseBlockUuidUserStatusSubmissionResponse = {
  __typename?: 'CourseBlockUuidUserStatusSubmissionResponse';
  choices?: Maybe<Array<Maybe<ExamChoice>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  feedback_image_url?: Maybe<Scalars['String']['output']>;
  feedback_message?: Maybe<Scalars['String']['output']>;
  freedom_wall_responses?: Maybe<Array<Maybe<CourseFreedomWallResult>>>;
  is_response_correct?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Scalars['String']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  manual_weight?: Maybe<Scalars['Float']['output']>;
  marked_correct?: Maybe<Scalars['Boolean']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  poll_choice?: Maybe<Scalars['String']['output']>;
  poll_results?: Maybe<Array<Maybe<PollResult>>>;
  score?: Maybe<Scalars['String']['output']>;
  short_answer_key?: Maybe<Scalars['String']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  show_grade?: Maybe<Scalars['Boolean']['output']>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  tally_results?: Maybe<Array<Maybe<TallyResult>>>;
  training_info?: Maybe<CourseUserCompletedBlockIndicator>;
  user?: Maybe<Scalars['ID']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseBlockUuidUserStatusSubmissionResponseChoice = {
  __typename?: 'CourseBlockUuidUserStatusSubmissionResponseChoice';
  item?: Maybe<Scalars['ID']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseBlockUuidUserStatusSubmissionV2 = {
  __typename?: 'CourseBlockUuidUserStatusSubmissionV2';
  block_status?: Maybe<Scalars['String']['output']>;
  certificate_block_status?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  ended_at?: Maybe<Scalars['String']['output']>;
  final?: Maybe<Scalars['Boolean']['output']>;
  grade_percent?: Maybe<Scalars['Float']['output']>;
  highest_possible_submission_score?: Maybe<Scalars['Int']['output']>;
  is_eligible?: Maybe<Scalars['Boolean']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  response_scores_sum?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Array<Maybe<CourseBlockUuidUserStatusSubmissionResponse>>>;
  responses_count?: Maybe<Scalars['Int']['output']>;
  score_max?: Maybe<Scalars['Int']['output']>;
  score_min?: Maybe<Scalars['Int']['output']>;
  score_raw?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_count?: Maybe<Scalars['Int']['output']>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  timeslot?: Maybe<Scalars['ID']['output']>;
  total_item_limit?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  user_certificate_status?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseCertificateBlockStatus = {
  __typename?: 'CourseCertificateBlockStatus';
  is_eligible?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user_certificate_status?: Maybe<Scalars['String']['output']>;
};

export type CourseCommentResult = {
  __typename?: 'CourseCommentResult';
  comment?: Maybe<ForumComment>;
};

export type CourseForumTopicInput = {
  course_uuid: Scalars['String']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CourseFreedomWallResult = {
  __typename?: 'CourseFreedomWallResult';
  created_at?: Maybe<Scalars['String']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  submitted_by?: Maybe<CourseFreedomWallSubmittedBy>;
  user?: Maybe<Scalars['String']['output']>;
  user_details?: Maybe<PassUserDetails>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseFreedomWallSubmittedBy = {
  __typename?: 'CourseFreedomWallSubmittedBy';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseProgressScreen = {
  __typename?: 'CourseProgressScreen';
  course?: Maybe<Course>;
  learner_course_status?: Maybe<StatisticsLearnerCourseStatus>;
  outline_progress?: Maybe<Array<Maybe<CourseProgressScreenOutlineProgressSection>>>;
};

export type CourseProgressScreenOutlineProgressBlock = {
  __typename?: 'CourseProgressScreenOutlineProgressBlock';
  cover_uri?: Maybe<Scalars['String']['output']>;
  resource_subtype?: Maybe<Scalars['String']['output']>;
  resource_type?: Maybe<Scalars['String']['output']>;
  score_max?: Maybe<Scalars['Float']['output']>;
  score_min?: Maybe<Scalars['Float']['output']>;
  score_raw?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CourseProgressScreenOutlineProgressSection = {
  __typename?: 'CourseProgressScreenOutlineProgressSection';
  blocks?: Maybe<Array<Maybe<CourseProgressScreenOutlineProgressBlock>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CourseSchedule = {
  __typename?: 'CourseSchedule';
  code?: Maybe<Scalars['String']['output']>;
  course_uuid?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  enroll_end?: Maybe<Scalars['String']['output']>;
  enroll_start?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseSection = {
  __typename?: 'CourseSection';
  are_user_blocks_complete?: Maybe<Scalars['Boolean']['output']>;
  blocks?: Maybe<Array<Maybe<CourseBlock>>>;
  course?: Maybe<Scalars['String']['output']>;
  cover_uri?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_user_completed?: Maybe<Scalars['Boolean']['output']>;
  is_accessible?: Maybe<Scalars['Boolean']['output']>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  next_sections?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  order_id?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  prerequisites?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sections_this_is_a_prerequisite_for?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseSectionStatus = {
  __typename?: 'CourseSectionStatus';
  block_statuses?: Maybe<Array<Maybe<CourseBlockStatus>>>;
};

export type CourseStyleInfo = {
  __typename?: 'CourseStyleInfo';
  base?: Maybe<CastAppearance>;
  card_header?: Maybe<CastAppearance>;
};

export type CourseTopicResult = {
  __typename?: 'CourseTopicResult';
  topic?: Maybe<ForumTopic>;
};

export type CourseUserCompletedBlockIndicator = {
  __typename?: 'CourseUserCompletedBlockIndicator';
  domains?: Maybe<Array<Maybe<CourseUserCompletedBlockIndicatorDomain>>>;
  total_points?: Maybe<Scalars['Float']['output']>;
};

export type CourseUserCompletedBlockIndicatorDomain = {
  __typename?: 'CourseUserCompletedBlockIndicatorDomain';
  children?: Maybe<Array<Maybe<CourseUserCompletedBlockIndicatorDomainChild>>>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  indicators?: Maybe<Array<Maybe<CourseUserCompletedBlockIndicatorDomainIndicator>>>;
  modified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  total_points?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseUserCompletedBlockIndicatorDomainChild = {
  __typename?: 'CourseUserCompletedBlockIndicatorDomainChild';
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  indicators?: Maybe<Array<Maybe<CourseUserCompletedBlockIndicatorDomainIndicator>>>;
  modified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  total_points?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseUserCompletedBlockIndicatorDomainIndicator = {
  __typename?: 'CourseUserCompletedBlockIndicatorDomainIndicator';
  blocks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  courses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_unit_name?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  sections?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CourseViewScreen = {
  __typename?: 'CourseViewScreen';
  completed_block_indicator?: Maybe<CourseUserCompletedBlockIndicator>;
  course?: Maybe<Course>;
  course_progress_max?: Maybe<Scalars['Int']['output']>;
  course_progress_value?: Maybe<Scalars['Int']['output']>;
  course_uuid?: Maybe<Scalars['String']['output']>;
  forum_topic?: Maybe<ForumTopic>;
  forum_topics?: Maybe<Array<Maybe<ForumTopic>>>;
  forum_topics_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_forum_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_user_forum_admin?: Maybe<Scalars['Boolean']['output']>;
  learner_course_status?: Maybe<StatisticsLearnerCourseStatus>;
  /**
   * By includeing this field you aggree to the following terms and conditions:
   *
   * 1. From Course service `GET /courses/${uuid}/?includeoutline,user_certificate_status,certificate_block_status,current_block,reference_info,allowed_actions`
   * 2. Return all clocks (from the outline) that has the `current_block==true` flag
   */
  next_course_blocks?: Maybe<Array<Maybe<CourseBlock>>>;
  schedule_block_status?: Maybe<ScheduleBlockStatus>;
};


export type CourseViewScreenForum_TopicArgs = {
  forum_topic_uuid?: InputMaybe<Scalars['ID']['input']>;
};


export type CourseViewScreenForum_TopicsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CourseViewScreenSchedule_Block_StatusArgs = {
  course_block_uuid?: InputMaybe<Scalars['String']['input']>;
};

export type CoursesAndCertificationScreen = {
  __typename?: 'CoursesAndCertificationScreen';
  learner_course_statuses?: Maybe<Array<Maybe<StatisticsLearnerCourseStatus>>>;
};


export type CoursesAndCertificationScreenLearner_Course_StatusesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Dev = {
  __typename?: 'Dev';
  session?: Maybe<Scalars['JSONObject']['output']>;
};

export type DirectoryViewScreen = {
  __typename?: 'DirectoryViewScreen';
  directory?: Maybe<Array<Maybe<CastBlockPropertiesDirectoryPaths>>>;
  id?: Maybe<Scalars['ID']['output']>;
  resources?: Maybe<Array<Maybe<Resource>>>;
};


export type DirectoryViewScreenDirectoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type DirectoryViewScreenResourcesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type DomainOutline = {
  __typename?: 'DomainOutline';
  applications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  children?: Maybe<Array<Maybe<ChildDomainOutline>>>;
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  indicators?: Maybe<Array<Maybe<TrainingIndicatorPoints>>>;
  modified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['String']['output']>;
  total_points?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentInfo = {
  __typename?: 'EnrollmentInfo';
  end?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type Exam = {
  __typename?: 'Exam';
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_correct?: Maybe<Scalars['Boolean']['output']>;
  display_missed?: Maybe<Scalars['Boolean']['output']>;
  display_points?: Maybe<Scalars['Boolean']['output']>;
  display_progress?: Maybe<Scalars['Boolean']['output']>;
  end_message?: Maybe<Scalars['String']['output']>;
  has_complete_submission?: Maybe<Scalars['Boolean']['output']>;
  highest_possible_score?: Maybe<Scalars['Int']['output']>;
  is_graded?: Maybe<Scalars['Boolean']['output']>;
  modified_by?: Maybe<Scalars['String']['output']>;
  passing_score?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Array<Maybe<ExamSection>>>;
  show_grade?: Maybe<Scalars['Boolean']['output']>;
  show_grade_type?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  time_limit?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userscores?: Maybe<Scalars['JSONObject']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};


export type ExamUserscoresArgs = {
  user_uuids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ExamAnswerKey = {
  __typename?: 'ExamAnswerKey';
  choice?: Maybe<ExamChoice>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_correct?: Maybe<Scalars['Boolean']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  modified_by?: Maybe<Scalars['String']['output']>;
};

export type ExamChoice = {
  __typename?: 'ExamChoice';
  audio_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  is_correct?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Scalars['String']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ExamFinalSubmissions = {
  __typename?: 'ExamFinalSubmissions';
  count?: Maybe<Scalars['Int']['output']>;
  submissions?: Maybe<Array<Maybe<ExamSubmission>>>;
};

export type ExamItem = {
  __typename?: 'ExamItem';
  choices?: Maybe<Array<Maybe<ExamChoice>>>;
  course_block_uuid?: Maybe<Scalars['ID']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  draft_value?: Maybe<ExamResponse>;
  exam_timeslot_uuid?: Maybe<Scalars['ID']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  is_graded?: Maybe<Scalars['Boolean']['output']>;
  max_allowed_responses?: Maybe<Scalars['Int']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  optional_anonymous_response?: Maybe<Scalars['Boolean']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  save_response_submitted_by?: Maybe<Scalars['Boolean']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  show_response_submitted_by?: Maybe<Scalars['Boolean']['output']>;
  show_results?: Maybe<Scalars['Boolean']['output']>;
  shuffle_choices?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type ExamItemSet = {
  __typename?: 'ExamItemSet';
  outline?: Maybe<ExamTimeslotOutline>;
  submission?: Maybe<ExamSubmission>;
};

export type ExamResponse = {
  __typename?: 'ExamResponse';
  choices?: Maybe<Array<Maybe<ExamChoice>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  feedback_image_url?: Maybe<Scalars['String']['output']>;
  feedback_message?: Maybe<Scalars['String']['output']>;
  freedom_wall_responses?: Maybe<Array<Maybe<FreedomWallResult>>>;
  is_response_correct?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Scalars['String']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  manual_weight?: Maybe<Scalars['Float']['output']>;
  marked_correct?: Maybe<Scalars['Boolean']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  poll_choice?: Maybe<Scalars['String']['output']>;
  poll_results?: Maybe<Array<Maybe<PollResult>>>;
  score?: Maybe<Scalars['String']['output']>;
  /**
   * A computed field that returns the correct answer key for a short answer item based on the returned Exam Response
   *
   * Readings:
   * https://docs.google.com/document/d/1Fuaor1dySpGHrrOF1sNZuXabYf9Pir10wsy0EvRqYVE/edit#heading=h.abb049lviho9
   */
  short_answer_key?: Maybe<Scalars['String']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  show_grade?: Maybe<Scalars['Boolean']['output']>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  tally_results?: Maybe<Array<Maybe<TallyResult>>>;
  user?: Maybe<Scalars['ID']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ExamResponseAnswerKey = {
  __typename?: 'ExamResponseAnswerKey';
  choice?: Maybe<ExamChoice>;
};

export type ExamResponseInput = {
  choices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  item?: InputMaybe<Scalars['String']['input']>;
  long_input?: InputMaybe<Scalars['String']['input']>;
  media_url?: InputMaybe<Scalars['String']['input']>;
  response_uuid?: InputMaybe<Scalars['String']['input']>;
  short_input?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ExamSection = {
  __typename?: 'ExamSection';
  created_by?: Maybe<Scalars['String']['output']>;
  exam?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  is_graded?: Maybe<Scalars['Boolean']['output']>;
  item_limit?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<ExamItem>>>;
  modified_by?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  shuffle_items?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ExamSubmission = {
  __typename?: 'ExamSubmission';
  created_at?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  ended_at?: Maybe<Scalars['String']['output']>;
  final?: Maybe<Scalars['Boolean']['output']>;
  has_complete_responses?: Maybe<Scalars['Boolean']['output']>;
  highest_possible_submission_score?: Maybe<Scalars['Int']['output']>;
  is_passing?: Maybe<Scalars['Boolean']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  response_scores_sum?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Array<Maybe<ExamResponse>>>;
  responses_count?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_count?: Maybe<Scalars['Int']['output']>;
  submitted_at?: Maybe<Scalars['String']['output']>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  timeslot?: Maybe<Scalars['ID']['output']>;
  total_item_limit?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['ID']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ExamSubmissionInput = {
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  ended_at?: InputMaybe<Scalars['String']['input']>;
  final?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  responses?: InputMaybe<Array<InputMaybe<ExamResponseInput>>>;
  started_at?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  total_score?: InputMaybe<Scalars['Int']['input']>;
};

export type ExamSubmissionInputV2 = {
  item_set?: InputMaybe<Scalars['Boolean']['input']>;
  responses?: InputMaybe<Array<InputMaybe<ExamResponseInput>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  timeslot?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type ExamSubmissionResponse = {
  __typename?: 'ExamSubmissionResponse';
  choices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  feedback_image_url?: Maybe<Scalars['String']['output']>;
  feedback_message?: Maybe<Scalars['String']['output']>;
  freedom_wall_responses?: Maybe<Array<Maybe<FreedomWallResult>>>;
  is_response_correct?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Scalars['String']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  manual_weight?: Maybe<Scalars['Float']['output']>;
  marked_correct?: Maybe<Scalars['Boolean']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  poll_choice?: Maybe<Scalars['String']['output']>;
  poll_results?: Maybe<Array<Maybe<PollResult>>>;
  score?: Maybe<Scalars['String']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  show_grade?: Maybe<Scalars['Boolean']['output']>;
  submitted_by?: Maybe<Scalars['String']['output']>;
  tally_results?: Maybe<Array<Maybe<TallyResult>>>;
  user?: Maybe<Scalars['ID']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ExamSubmitter = {
  __typename?: 'ExamSubmitter';
  created_at?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_uuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['Int']['output']>;
};

export type ExamTimeslot = {
  __typename?: 'ExamTimeslot';
  access_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  last_submission_status?: Maybe<Scalars['String']['output']>;
  max_allowed_submissions?: Maybe<Scalars['Int']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  modified_by?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  outline?: Maybe<ExamTimeslotOutline>;
  start?: Maybe<Scalars['String']['output']>;
  user_submissions?: Maybe<ExamUserSubmissions>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ExamTimeslotDetail = {
  __typename?: 'ExamTimeslotDetail';
  info?: Maybe<ExamTimeslot>;
};

export type ExamTimeslotOutline = {
  __typename?: 'ExamTimeslotOutline';
  exam?: Maybe<Exam>;
};

export type ExamUserSubmissions = {
  __typename?: 'ExamUserSubmissions';
  final?: Maybe<ExamFinalSubmissions>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export type ForumCategory = {
  __typename?: 'ForumCategory';
  created?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user_details?: Maybe<PassUserDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_user_admin?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  reference_id?: Maybe<Scalars['String']['output']>;
  reference_type?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<ForumTopic>>>;
  uuid?: Maybe<Scalars['ID']['output']>;
};


export type ForumCategoryTopicsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ForumComment = {
  __typename?: 'ForumComment';
  created?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user_details?: Maybe<PassUserDetails>;
  flagged_by?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_flagged?: Maybe<Scalars['Boolean']['output']>;
  is_user_moderator?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ForumTopic = {
  __typename?: 'ForumTopic';
  comments?: Maybe<Array<Maybe<ForumComment>>>;
  created?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user_details?: Maybe<PassUserDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_user_admin?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type FreedomWallResult = {
  __typename?: 'FreedomWallResult';
  created_at?: Maybe<Scalars['String']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  modified_at?: Maybe<Scalars['String']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  submitted_by?: Maybe<Scalars['JSONObject']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  user_details?: Maybe<PassUserDetails>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type Healthcheck = {
  __typename?: 'Healthcheck';
  cast?: Maybe<HealthcheckStatus>;
  course?: Maybe<HealthcheckStatus>;
  exam?: Maybe<HealthcheckStatus>;
  learninglocker?: Maybe<HealthcheckStatus>;
  pass?: Maybe<HealthcheckStatus>;
  pay?: Maybe<HealthcheckStatus>;
  recipe?: Maybe<HealthcheckStatus>;
  resource?: Maybe<HealthcheckStatus>;
  version?: Maybe<Scalars['String']['output']>;
};

export type HealthcheckStatus = {
  __typename?: 'HealthcheckStatus';
  status?: Maybe<Scalars['String']['output']>;
};

export type HomeScreen = {
  __typename?: 'HomeScreen';
  initial_slug?: Maybe<Scalars['String']['output']>;
};

export type HumanizedResourceTypes = {
  __typename?: 'HumanizedResourceTypes';
  buresource?: Maybe<HumanizedResourceTypesBuResource>;
};

export type HumanizedResourceTypesBuResource = {
  __typename?: 'HumanizedResourceTypesBuResource';
  resource?: Maybe<HumanizedResourceTypesBuResourceMapping>;
};

export type HumanizedResourceTypesBuResourceMapping = {
  __typename?: 'HumanizedResourceTypesBuResourceMapping';
  subtype?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  type?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
};

export type LoginScreen = {
  __typename?: 'LoginScreen';
  banner_url?: Maybe<Scalars['String']['output']>;
  cast?: Maybe<Cast>;
  cast_id?: Maybe<Scalars['Int']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  favicon_url?: Maybe<Scalars['String']['output']>;
  hero_url?: Maybe<Scalars['String']['output']>;
  /** Determine if the user can sign up for an account. */
  is_signup_enabled?: Maybe<Scalars['Boolean']['output']>;
  login_icon_url?: Maybe<Scalars['String']['output']>;
  nav_url?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  account_update?: Maybe<PassUserInfo>;
  assessment_draft_submit?: Maybe<AssessmentViewScreenAssessmentSubmitResult>;
  /** @deprecated In favor of 'assessment_response_detailed' with more defined schema */
  assessment_response?: Maybe<Scalars['JSONObject']['output']>;
  assessment_response_detailed?: Maybe<AssessmentViewScreenAssessmentResponseResult>;
  /** @deprecated In favor of 'assessment_submit' with more defined schema */
  assessment_submission?: Maybe<Scalars['JSONObject']['output']>;
  assessment_submit?: Maybe<AssessmentViewScreenAssessmentSubmitResult>;
  assessment_submit_update?: Maybe<AssessmentViewScreenAssessmentSubmitResult>;
  assessment_submit_update_v2?: Maybe<AssessmentViewScreenAssessmentSubmitResultV2>;
  assessment_submit_v2?: Maybe<AssessmentViewScreenAssessmentSubmitResultV2>;
  /** @deprecated In favor of 'subscription_cancel' */
  cancel_subscription?: Maybe<Scalars['JSONObject']['output']>;
  casticulate_clear_state?: Maybe<CasticulateState>;
  casticulate_set_state?: Maybe<CasticulateState>;
  /** @deprecated In favor of 'subscription_change' */
  change_subscription?: Maybe<Scalars['JSONObject']['output']>;
  checkout_create?: Maybe<CheckoutCreateResult>;
  /** @deprecated In favor of 'course_block_exam_submit' with more defined schema */
  course_block_exam_response?: Maybe<Scalars['JSONObject']['output']>;
  course_block_exam_response_detailed?: Maybe<CourseBlockExamResponseResult>;
  /** @deprecated In favor of 'course_block_exam_submit' with more defined schema */
  course_block_exam_submission?: Maybe<Scalars['JSONObject']['output']>;
  course_block_exam_submit?: Maybe<CourseBlockExamSubmitResult>;
  course_block_exam_submit_update?: Maybe<CourseBlockExamSubmitResult>;
  course_block_exam_submit_v2?: Maybe<CourseBlockExamSubmitResultV2>;
  course_forum_comment_create?: Maybe<CourseCommentResult>;
  course_forum_comment_delete?: Maybe<Scalars['JSONObject']['output']>;
  course_forum_comment_update?: Maybe<CourseCommentResult>;
  course_forum_topic_create?: Maybe<CourseTopicResult>;
  course_forum_topic_delete?: Maybe<Scalars['JSONObject']['output']>;
  course_forum_topic_update?: Maybe<CourseTopicResult>;
  form_submit?: Maybe<AccountAndUserDetailsScreenFormTabResult>;
  login?: Maybe<Scalars['JSONObject']['output']>;
  login_dev?: Maybe<Scalars['JSONObject']['output']>;
  logout?: Maybe<Scalars['JSONObject']['output']>;
  profile_update?: Maybe<PassUserProfile>;
  recipe_cook?: Maybe<Scalars['JSONObject']['output']>;
  recipe_cook_multiple?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  resource_end?: Maybe<ResourceViewScreenResourceEndResult>;
  resource_start?: Maybe<Scalars['JSONObject']['output']>;
  self_enroll?: Maybe<Scalars['JSONObject']['output']>;
  single_upload: UploadedFile;
  subscribe?: Maybe<PayUserSubscription>;
  subscription_cancel?: Maybe<PayUserSubscription>;
  subscription_change?: Maybe<Scalars['JSONObject']['output']>;
  subscription_uncancel?: Maybe<Scalars['JSONObject']['output']>;
};


export type MutationAccount_UpdateArgs = {
  details?: InputMaybe<AccountDetailsUpdate>;
};


export type MutationAssessment_Draft_SubmitArgs = {
  exam_timeslot_uuid: Scalars['String']['input'];
  submission: ExamSubmissionInput;
};


export type MutationAssessment_ResponseArgs = {
  response?: InputMaybe<ExamSubmissionInput>;
  submission_uuid: Scalars['String']['input'];
};


export type MutationAssessment_Response_DetailedArgs = {
  responses?: InputMaybe<Array<InputMaybe<ExamResponseInput>>>;
  submission_uuid: Scalars['String']['input'];
};


export type MutationAssessment_SubmissionArgs = {
  exam_timeslot_uuid: Scalars['String']['input'];
  submission?: InputMaybe<ExamSubmissionInput>;
};


export type MutationAssessment_SubmitArgs = {
  exam_timeslot_uuid: Scalars['String']['input'];
  submission: ExamSubmissionInput;
};


export type MutationAssessment_Submit_UpdateArgs = {
  submission_uuid: Scalars['String']['input'];
  updated_submission: ExamSubmissionInput;
};


export type MutationAssessment_Submit_Update_V2Args = {
  block_uuid?: InputMaybe<Scalars['String']['input']>;
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  submission_uuid: Scalars['String']['input'];
  updated_submission: ExamSubmissionInputV2;
};


export type MutationAssessment_Submit_V2Args = {
  block_uuid?: InputMaybe<Scalars['String']['input']>;
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  exam_timeslot_uuid: Scalars['String']['input'];
  submission?: InputMaybe<ExamSubmissionInputV2>;
};


export type MutationCancel_SubscriptionArgs = {
  user_subscription_id: Scalars['ID']['input'];
};


export type MutationCasticulate_Clear_StateArgs = {
  ids: CasticulateIdsInput;
};


export type MutationCasticulate_Set_StateArgs = {
  data: Scalars['JSONObject']['input'];
  ids: CasticulateIdsInput;
};


export type MutationChange_SubscriptionArgs = {
  subscription_plan_id_to: Scalars['ID']['input'];
  user_subscription_id: Scalars['ID']['input'];
};


export type MutationCheckout_CreateArgs = {
  callback_url?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['Int']['input'];
};


export type MutationCourse_Block_Exam_ResponseArgs = {
  block_uuid: Scalars['String']['input'];
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<CourseBlockExamSubmissionResponse>;
};


export type MutationCourse_Block_Exam_Response_DetailedArgs = {
  block_uuid: Scalars['String']['input'];
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<CourseBlockExamSubmissionResponse>;
};


export type MutationCourse_Block_Exam_SubmissionArgs = {
  block_uuid: Scalars['String']['input'];
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<CourseBlockExamSubmission>;
};


export type MutationCourse_Block_Exam_SubmitArgs = {
  block_uuid: Scalars['String']['input'];
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<CourseBlockExamSubmission>;
};


export type MutationCourse_Block_Exam_Submit_UpdateArgs = {
  block_uuid: Scalars['String']['input'];
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<CourseBlockExamSubmission>;
};


export type MutationCourse_Block_Exam_Submit_V2Args = {
  block_uuid: Scalars['String']['input'];
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<CourseBlockExamSubmission>;
};


export type MutationCourse_Forum_Comment_CreateArgs = {
  forum_topic_uuid: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationCourse_Forum_Comment_DeleteArgs = {
  forum_comment_uuid: Scalars['ID']['input'];
};


export type MutationCourse_Forum_Comment_UpdateArgs = {
  forum_comment_uuid: Scalars['ID']['input'];
  is_flagged?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCourse_Forum_Topic_CreateArgs = {
  input: CourseForumTopicInput;
};


export type MutationCourse_Forum_Topic_DeleteArgs = {
  forum_topic_uuid: Scalars['ID']['input'];
};


export type MutationCourse_Forum_Topic_UpdateArgs = {
  forum_topic_uuid: Scalars['ID']['input'];
  input: CourseForumTopicInput;
};


export type MutationForm_SubmitArgs = {
  details?: InputMaybe<AccountAndUserDetailsScreenFormTabSubmit>;
};


export type MutationLoginArgs = {
  client_id: Scalars['String']['input'];
  code: Scalars['String']['input'];
  redirect_uri: Scalars['String']['input'];
};


export type MutationLogin_DevArgs = {
  access_token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfile_UpdateArgs = {
  details?: InputMaybe<AccountProfileUpdate>;
};


export type MutationRecipe_CookArgs = {
  ingredient?: InputMaybe<RecipeIngredients>;
};


export type MutationRecipe_Cook_MultipleArgs = {
  ingredients?: InputMaybe<Array<InputMaybe<RecipeIngredients>>>;
};


export type MutationResource_EndArgs = {
  course_block_uuid?: InputMaybe<Scalars['String']['input']>;
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  resource_uuid: Scalars['ID']['input'];
};


export type MutationResource_StartArgs = {
  course_block_uuid?: InputMaybe<Scalars['String']['input']>;
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  resource_uuid: Scalars['ID']['input'];
};


export type MutationSelf_EnrollArgs = {
  course_schedule_uuid: Scalars['String']['input'];
};


export type MutationSingle_UploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationSubscribeArgs = {
  subscription_plan_id: Scalars['ID']['input'];
};


export type MutationSubscription_CancelArgs = {
  user_subscription_id: Scalars['ID']['input'];
};


export type MutationSubscription_ChangeArgs = {
  subscription_plan_id_to: Scalars['ID']['input'];
  user_subscription_id: Scalars['ID']['input'];
};


export type MutationSubscription_UncancelArgs = {
  user_subscription_id: Scalars['ID']['input'];
};

export type Navbar = {
  __typename?: 'Navbar';
  id?: Maybe<Scalars['ID']['output']>;
  nav_appearance?: Maybe<NavbarAppearance>;
  nav_logo_url?: Maybe<Scalars['String']['output']>;
  nav_screen_items?: Maybe<Array<Maybe<NavbarScreenItem>>>;
  navigation_block?: Maybe<CastBlock>;
  profile_icon_url?: Maybe<Scalars['String']['output']>;
  search_slug?: Maybe<Scalars['String']['output']>;
  user_info?: Maybe<PassUserInfo>;
};

export type NavbarAppearance = {
  __typename?: 'NavbarAppearance';
  base?: Maybe<CastAppearance>;
  item?: Maybe<CastAppearance>;
  item_active?: Maybe<CastAppearance>;
};

export type NavbarScreenItem = {
  __typename?: 'NavbarScreenItem';
  icon?: Maybe<CastIcon>;
  is_hidden?: Maybe<Scalars['Boolean']['output']>;
  screen_id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PassUserDetails = {
  __typename?: 'PassUserDetails';
  confirmation_sent_at?: Maybe<Scalars['String']['output']>;
  confirmed_at?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_sign_in_at?: Maybe<Scalars['String']['output']>;
  password_expires_at?: Maybe<Scalars['String']['output']>;
  profile_icon_url?: Maybe<Scalars['String']['output']>;
  unconfirmed_email?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type PassUserInfo = {
  __typename?: 'PassUserInfo';
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use given_name inside in PassUserProfile */
  first_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use family_name inside in PassUserProfile */
  last_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type PassUserProfile = {
  __typename?: 'PassUserProfile';
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  is_cast_member?: Maybe<Scalars['Boolean']['output']>;
  is_deactivated_user?: Maybe<Scalars['Boolean']['output']>;
  is_guest_user?: Maybe<Scalars['Boolean']['output']>;
  profile_id?: Maybe<Scalars['ID']['output']>;
};

export type PayCatalogueProduct = {
  __typename?: 'PayCatalogueProduct';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PayCheckoutToken = {
  __typename?: 'PayCheckoutToken';
  checkout_url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  valid_until?: Maybe<Scalars['Int']['output']>;
};

export type PayInvoceReceipt = {
  __typename?: 'PayInvoceReceipt';
  charge?: Maybe<PayPaymentCharge>;
  created?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type PayPaymentCharge = {
  __typename?: 'PayPaymentCharge';
  amount?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type PaySubscriptionPlan = {
  __typename?: 'PaySubscriptionPlan';
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_recurring?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plan_period?: Maybe<Scalars['Int']['output']>;
  plan_unit?: Maybe<Scalars['String']['output']>;
  product?: Maybe<PayCatalogueProduct>;
  trial_period?: Maybe<Scalars['Int']['output']>;
  trial_unit?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type PayUserSubscription = {
  __typename?: 'PayUserSubscription';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  expires?: Maybe<Scalars['String']['output']>;
  invoice_receipts?: Maybe<Array<Maybe<PayInvoceReceipt>>>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  on_trial?: Maybe<Scalars['Boolean']['output']>;
  plan?: Maybe<PaySubscriptionPlan>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type PollResult = {
  __typename?: 'PollResult';
  choice?: Maybe<PollResultChoice>;
  result?: Maybe<PollResultAnalytics>;
};

export type PollResultAnalytics = {
  __typename?: 'PollResultAnalytics';
  count?: Maybe<Scalars['Int']['output']>;
  percent?: Maybe<Scalars['Int']['output']>;
};

export type PollResultChoice = {
  __typename?: 'PollResultChoice';
  audio_url?: Maybe<Scalars['String']['output']>;
  long_input?: Maybe<Scalars['String']['output']>;
  media_url?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  short_input?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type PwaIcons = {
  __typename?: 'PwaIcons';
  icon_192?: Maybe<Scalars['String']['output']>;
  icon_512?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account_and_user_details_screen?: Maybe<AccountAndUserDetailsScreen>;
  activity_log_screen?: Maybe<ActivityLogScreen>;
  assessment_view_screen?: Maybe<AssessmentViewScreen>;
  browser_title_bar?: Maybe<BrowserTitleBar>;
  cast_block_screen?: Maybe<CastBlockListScreen>;
  casticulate_view_screen?: Maybe<CasticulateViewScreen>;
  /** @deprecated Use catalog_list_screen(cast_block_id: String) instead */
  catalog_list_screen?: Maybe<CatalogListScreen>;
  course_progress_screen?: Maybe<CourseProgressScreen>;
  course_view_screen?: Maybe<CourseViewScreen>;
  courses_and_certification_screen?: Maybe<CoursesAndCertificationScreen>;
  dev?: Maybe<Dev>;
  directory_view_screen?: Maybe<DirectoryViewScreen>;
  healthcheck?: Maybe<Healthcheck>;
  home_screen?: Maybe<HomeScreen>;
  humanized_resource_types?: Maybe<HumanizedResourceTypes>;
  login_screen?: Maybe<LoginScreen>;
  navbar?: Maybe<Navbar>;
  resource_view_screen?: Maybe<ResourceViewScreen>;
  resource_view_screen_v2?: Maybe<ResourceViewScreen>;
  /** @deprecated In favor of putting the params in resources */
  search_screen?: Maybe<SearchScreen>;
  subscription_screen?: Maybe<SubscriptionScreen>;
  tis_screen?: Maybe<TisScreen>;
};


export type QueryAssessment_View_ScreenArgs = {
  course_block_uuid?: InputMaybe<Scalars['String']['input']>;
  course_schedule_uuid?: InputMaybe<Scalars['String']['input']>;
  course_uuid?: InputMaybe<Scalars['String']['input']>;
  exam_timeslot_uuid: Scalars['String']['input'];
  resource_uuid: Scalars['String']['input'];
};


export type QueryCast_Block_ScreenArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCasticulate_View_ScreenArgs = {
  ids: CasticulateIdsInput;
};


export type QueryCatalog_List_ScreenArgs = {
  cast_block_id?: InputMaybe<Scalars['String']['input']>;
  resource_collection_uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCourse_Progress_ScreenArgs = {
  course_uuid: Scalars['ID']['input'];
  schedule_uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCourse_View_ScreenArgs = {
  course_uuid: Scalars['String']['input'];
  schedule_uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLogin_ScreenArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResource_View_ScreenArgs = {
  course_block_uuid?: InputMaybe<Scalars['String']['input']>;
  resource_uuid: Scalars['ID']['input'];
};


export type QueryResource_View_Screen_V2Args = {
  resource_details_input: ResourceDetailsInput;
};


export type QuerySearch_ScreenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeIngredients = {
  body: RecipeIngredientsBody;
  recipe_name: Scalars['String']['input'];
};

export type RecipeIngredientsBody = {
  actor?: InputMaybe<Scalars['JSONObject']['input']>;
  context?: InputMaybe<Scalars['JSONObject']['input']>;
  global?: InputMaybe<Scalars['JSONObject']['input']>;
  object?: InputMaybe<Scalars['JSONObject']['input']>;
  result?: InputMaybe<Scalars['JSONObject']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  verb?: InputMaybe<Scalars['String']['input']>;
};

export type Resource = {
  __typename?: 'Resource';
  collections?: Maybe<Array<Maybe<ResourceCollection>>>;
  content?: Maybe<ResourceContent>;
  course_block_uuid?: Maybe<Scalars['ID']['output']>;
  cover_uri?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ResourceCollection = {
  __typename?: 'ResourceCollection';
  cover_uri?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Maybe<Resource>>>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type ResourceContent = ResourceContentAssessment | ResourceContentAudio | ResourceContentBuribookWithActivity | ResourceContentBurislide | ResourceContentCasticulate | ResourceContentCourse | ResourceContentEmbed | ResourceContentEpub | ResourceContentFile | ResourceContentLink | ResourceContentNotSupported | ResourceContentPdf | ResourceContentText | ResourceContentVideo | ResourceContentXApi | ResourceContentYoutube;

export type ResourceContentAssessment = {
  __typename?: 'ResourceContentAssessment';
  exam_details?: Maybe<ResourceContentExamDetails>;
  exam_timeslot?: Maybe<ExamTimeslot>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ResourceContentAssessmentV2 = {
  __typename?: 'ResourceContentAssessmentV2';
  id?: Maybe<Scalars['ID']['output']>;
  max_allowed_submissions?: Maybe<Scalars['Int']['output']>;
  outline?: Maybe<ExamTimeslotOutline>;
};

export type ResourceContentAudio = {
  __typename?: 'ResourceContentAudio';
  content_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentBuribookWithActivity = {
  __typename?: 'ResourceContentBuribookWithActivity';
  appearance?: Maybe<ResourceContentBurislideSpreadStyleInfo>;
  exam_details?: Maybe<ResourceContentExamDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  spreads?: Maybe<Array<Maybe<ResourceContentBurislideSpread>>>;
};

export type ResourceContentBurislide = {
  __typename?: 'ResourceContentBurislide';
  appearance?: Maybe<ResourceContentBurislideSpreadStyleInfo>;
  exam_details?: Maybe<ResourceContentExamDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  spreads?: Maybe<Array<Maybe<ResourceContentBurislideSpread>>>;
};

export type ResourceContentBurislideSpread = {
  __typename?: 'ResourceContentBurislideSpread';
  appearance?: Maybe<ResourceContentBurislideSpreadStyleInfo>;
  exam_choice_trigger_flags?: Maybe<Array<Maybe<ResourceContentBurislideSpreadActivityGroupExamChoiceTriggerFlag>>>;
  exam_item?: Maybe<ExamItem>;
  exam_item_required_flags?: Maybe<Array<Maybe<ResourceContentBurislideSpreadActivityGroupExamItemRequiredFlag>>>;
  exam_item_uuid?: Maybe<Scalars['String']['output']>;
  exam_section_items?: Maybe<Array<Maybe<ExamItem>>>;
  /** @deprecated User exam_details in parent */
  exam_timeslot_uuid?: Maybe<Scalars['String']['output']>;
  image_uri?: Maybe<Scalars['String']['output']>;
  is_result_page_shown?: Maybe<Scalars['Boolean']['output']>;
  left_uri?: Maybe<Scalars['String']['output']>;
  result_page_image_uri?: Maybe<Scalars['String']['output']>;
  result_page_text?: Maybe<Scalars['String']['output']>;
  right_uri?: Maybe<Scalars['String']['output']>;
  spread_type?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  uris?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  view_mode?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentBurislideSpreadActivityGroupExamChoiceTriggerFlag = {
  __typename?: 'ResourceContentBurislideSpreadActivityGroupExamChoiceTriggerFlag';
  exam_choice_uuid?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Maybe<ResourceContentBurislideSpreadActivityGroupFlag>>>;
};

export type ResourceContentBurislideSpreadActivityGroupExamItemRequiredFlag = {
  __typename?: 'ResourceContentBurislideSpreadActivityGroupExamItemRequiredFlag';
  exam_item_uuid?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Maybe<ResourceContentBurislideSpreadActivityGroupFlag>>>;
};

export type ResourceContentBurislideSpreadActivityGroupFlag = {
  __typename?: 'ResourceContentBurislideSpreadActivityGroupFlag';
  flag_id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type ResourceContentBurislideSpreadStyleInfo = {
  __typename?: 'ResourceContentBurislideSpreadStyleInfo';
  base?: Maybe<CastAppearance>;
};

export type ResourceContentCasticulate = {
  __typename?: 'ResourceContentCasticulate';
  casticulate_uuid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ResourceContentCourse = {
  __typename?: 'ResourceContentCourse';
  course_details?: Maybe<ResourceContentCourseDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  resource_collection_uuid?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentCourseDetails = {
  __typename?: 'ResourceContentCourseDetails';
  course?: Maybe<Course>;
  course_uuid?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentEmbed = {
  __typename?: 'ResourceContentEmbed';
  content_type?: Maybe<Scalars['String']['output']>;
  embed_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentEpub = {
  __typename?: 'ResourceContentEpub';
  id?: Maybe<Scalars['ID']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentExamDetails = {
  __typename?: 'ResourceContentExamDetails';
  course_block_uuid?: Maybe<Scalars['String']['output']>;
  /**
   * By including this field you agree to do the following
   *
   * If `course_block_uuid` is included
   * 1. From Exams service `GET /timeslots/${timeslotUuid}/submissions/learner/?include=item_set`
   * 2. If no submission present, create one in Course service `POST /blocks/${blockUuid}/userstatus/submission/`
   * 3. Return the submission (created or retrieved).
   *
   *
   * If `course_block_uuid` is NOT included
   * 1. From Exams service `GET /timeslots/${timeslotUuid}/submissions?include=item_set,item_set_outline`
   * 2. If no submission present, create one with `POST /timeslots/${timeslotUuid}/submissions/`
   * 3. Return complete submission info : `GET /submissions/${uuid}/?include=item_set,item_set_outline`
   */
  exam_item_set?: Maybe<ExamItemSet>;
  exam_timeslot_uuid?: Maybe<Scalars['String']['output']>;
  exam_uuid?: Maybe<Scalars['String']['output']>;
  max_allowed_submissions?: Maybe<Scalars['Int']['output']>;
  outline?: Maybe<ExamTimeslotOutline>;
};

export type ResourceContentFile = {
  __typename?: 'ResourceContentFile';
  id?: Maybe<Scalars['ID']['output']>;
  preview_graphic_uri?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentLink = {
  __typename?: 'ResourceContentLink';
  id?: Maybe<Scalars['ID']['output']>;
  query_params?: Maybe<Array<Maybe<ResourceContentLinkQueryParams>>>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentLinkQueryParams = {
  __typename?: 'ResourceContentLinkQueryParams';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentNotSupported = {
  __typename?: 'ResourceContentNotSupported';
  _dummy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ResourceContentPdf = {
  __typename?: 'ResourceContentPdf';
  content_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  preview_graphic_uri?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentText = {
  __typename?: 'ResourceContentText';
  id?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentVideo = {
  __typename?: 'ResourceContentVideo';
  cf_stream_uid?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  dash_uri?: Maybe<Scalars['String']['output']>;
  hls_uri?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  subtitle_class?: Maybe<Scalars['String']['output']>;
  tracks?: Maybe<Array<Maybe<ResourceContentVideoTrack>>>;
  uri?: Maybe<Scalars['String']['output']>;
  video_description?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentVideoTrack = {
  __typename?: 'ResourceContentVideoTrack';
  uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentXApi = {
  __typename?: 'ResourceContentXApi';
  base_uri?: Maybe<Scalars['String']['output']>;
  file_relative_uris?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  lrs_uri?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  zip_uri?: Maybe<Scalars['String']['output']>;
};

export type ResourceContentYoutube = {
  __typename?: 'ResourceContentYoutube';
  id?: Maybe<Scalars['ID']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  video_id?: Maybe<Scalars['String']['output']>;
};

export type ResourceDetailsInput = {
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
  resourceUuid: Scalars['String']['input'];
  scheduleUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceViewScreen = {
  __typename?: 'ResourceViewScreen';
  course_block?: Maybe<CourseBlock>;
  course_block_uuid?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  resource?: Maybe<Resource>;
  resource_uuid?: Maybe<Scalars['ID']['output']>;
  section_result?: Maybe<ResourceViewScreenSectionResult>;
};


export type ResourceViewScreenSection_ResultArgs = {
  exam_section_uuid: Scalars['ID']['input'];
  exam_submission_uuid: Scalars['ID']['input'];
};

export type ResourceViewScreenResourceEndResult = {
  __typename?: 'ResourceViewScreenResourceEndResult';
  next_course_blocks?: Maybe<Array<Maybe<CourseBlock>>>;
};

export type ResourceViewScreenSectionResult = {
  __typename?: 'ResourceViewScreenSectionResult';
  score_max?: Maybe<Scalars['Int']['output']>;
  score_raw?: Maybe<Scalars['Int']['output']>;
  spread_result_details?: Maybe<ResourceViewScreenSectionResultSpreadResultDetails>;
};


export type ResourceViewScreenSectionResultSpread_Result_DetailsArgs = {
  resource_spread_index?: InputMaybe<Scalars['Int']['input']>;
};

export type ResourceViewScreenSectionResultSpreadResultDetails = {
  __typename?: 'ResourceViewScreenSectionResultSpreadResultDetails';
  result_page_image_uri?: Maybe<Scalars['String']['output']>;
  result_page_text?: Maybe<Scalars['String']['output']>;
};

export type ScheduleBlockStatus = {
  __typename?: 'ScheduleBlockStatus';
  block?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  is_complete?: Maybe<Scalars['Boolean']['output']>;
  is_current?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  pass_date?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  section_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submission_id?: Maybe<Scalars['String']['output']>;
  training_info?: Maybe<TrainingOutline>;
  user?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ScheduleDetails = {
  __typename?: 'ScheduleDetails';
  end?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SearchScreen = {
  __typename?: 'SearchScreen';
  /** @deprecated No longer supported */
  q?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<Maybe<Resource>>>;
};


export type SearchScreenResourcesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  resource_type?: InputMaybe<Scalars['String']['input']>;
};

export type StatisticsLearnerCourseStatus = {
  __typename?: 'StatisticsLearnerCourseStatus';
  course_certificate_end_message?: Maybe<Scalars['String']['output']>;
  course_certificate_url?: Maybe<Scalars['String']['output']>;
  course_details?: Maybe<Course>;
  schedule_details?: Maybe<ScheduleDetails>;
  section_statuses?: Maybe<Array<Maybe<CourseSectionStatus>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SubmissionInfo = {
  __typename?: 'SubmissionInfo';
  highest_possible_submission_score?: Maybe<Scalars['Int']['output']>;
  response_scores_sum?: Maybe<Scalars['Int']['output']>;
  responses_count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_item_limit?: Maybe<Scalars['Int']['output']>;
  total_score?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionScreen = {
  __typename?: 'SubscriptionScreen';
  subscription_plans?: Maybe<Array<Maybe<SubscriptionScreenPlan>>>;
  user_subscription?: Maybe<PayUserSubscription>;
  user_subscriptions?: Maybe<Array<Maybe<PayUserSubscription>>>;
};


export type SubscriptionScreenUser_SubscriptionArgs = {
  user_subscription_id: Scalars['ID']['input'];
};

export type SubscriptionScreenPlan = {
  __typename?: 'SubscriptionScreenPlan';
  name?: Maybe<Scalars['String']['output']>;
  plan_period?: Maybe<Scalars['Int']['output']>;
  plan_unit?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  subscription_plan_id?: Maybe<Scalars['String']['output']>;
};

export type TallyResult = {
  __typename?: 'TallyResult';
  score?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<TallyResultType>;
};

export type TallyResultType = {
  __typename?: 'TallyResultType';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type TisScreen = {
  __typename?: 'TisScreen';
  completed_block_indicator?: Maybe<CourseUserCompletedBlockIndicator>;
  course_block_status?: Maybe<CourseBlockUserstatus>;
};


export type TisScreenCourse_Block_StatusArgs = {
  course_block_uuid: Scalars['ID']['input'];
};

export type TrainingIndicatorPoints = {
  __typename?: 'TrainingIndicatorPoints';
  created?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_unit_name?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type TrainingOutline = {
  __typename?: 'TrainingOutline';
  domains?: Maybe<Array<Maybe<DomainOutline>>>;
  total_points?: Maybe<Scalars['String']['output']>;
};

export type UploadedFile = {
  __typename?: 'UploadedFile';
  content_type: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type Asd = {
  __typename?: 'asd';
  asd?: Maybe<Scalars['String']['output']>;
};

export type IsGuestUserQueryVariables = Exact<{ [key: string]: never; }>;


export type IsGuestUserQuery = { __typename?: 'Query', accountAndUserDetailsScreen?: { __typename?: 'AccountAndUserDetailsScreen', userProfile?: { __typename?: 'PassUserProfile', isGuestUser?: boolean | null, isDeactivatedUser?: boolean | null, isCastMember?: boolean | null } | null } | null };

export type IdleFieldsQueryVariables = Exact<{
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type IdleFieldsQuery = { __typename?: 'Query', loginScreen?: { __typename?: 'LoginScreen', cast?: { __typename?: 'Cast', attributes?: { __typename?: 'CastAttributes', logoutPromptAfterXSeconds?: string | null, logoutAfterXSeconds?: string | null } | null } | null } | null };

export type HumanizedResourceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type HumanizedResourceTypesQuery = { __typename?: 'Query', humanizedResourceTypes?: { __typename?: 'HumanizedResourceTypes', buresource?: { __typename?: 'HumanizedResourceTypesBuResource', resource?: { __typename?: 'HumanizedResourceTypesBuResourceMapping', type?: Array<Array<string | null> | null> | null, subtype?: Array<Array<string | null> | null> | null } | null } | null } | null };

export type DeleteCommentMutationVariables = Exact<{
  forumCommentUuid: Scalars['ID']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', courseForumCommentDelete?: any | null };

export type FlagCommentMutationVariables = Exact<{
  forumCommentUuid: Scalars['ID']['input'];
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FlagCommentMutation = { __typename?: 'Mutation', courseForumCommentUpdate?: { __typename?: 'CourseCommentResult', comment?: { __typename?: 'ForumComment', isFlagged?: boolean | null } | null } | null };

export type CreateCommentMutationVariables = Exact<{
  forumTopicUuid: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', courseForumCommentCreate?: { __typename?: 'CourseCommentResult', comment?: { __typename?: 'ForumComment', uuid?: string | null } | null } | null };

export type ResourceViewScreenCourseOutlineQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
}>;


export type ResourceViewScreenCourseOutlineQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resource?: { __typename?: 'Resource', content?: { __typename?: 'ResourceContentAssessment' } | { __typename?: 'ResourceContentAudio' } | { __typename?: 'ResourceContentBuribookWithActivity' } | { __typename?: 'ResourceContentBurislide' } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', courseDetails?: { __typename?: 'ResourceContentCourseDetails', courseUuid?: string | null } | null } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub' } | { __typename?: 'ResourceContentFile' } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf' } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo' } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null } | null };

export type CourseQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
}>;


export type CourseQuery = { __typename?: 'Query', course_view_screen?: { __typename?: 'CourseViewScreen', course?: { __typename?: 'Course', id?: string | null, is_enrolled?: boolean | null, allowed_actions?: Array<string | null> | null, outline?: Array<{ __typename?: 'CourseSection', blocks?: Array<{ __typename?: 'CourseBlock', resource?: { __typename?: 'Resource', type?: string | null, uuid?: string | null, name?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type CatalogListScreenForBlockQueryVariables = Exact<{
  castBlockId: Scalars['String']['input'];
}>;


export type CatalogListScreenForBlockQuery = { __typename?: 'Query', catalogListScreen?: { __typename?: 'CatalogListScreen', id?: string | null, castBlock?: { __typename?: 'CastBlock', id?: string | null, attributes?: { __typename?: 'CastBlockAttributes', type?: string | null, properties?: { __typename?: 'CastBlockPropertiesButtonSearch' } | { __typename?: 'CastBlockPropertiesCarousel' } | { __typename?: 'CastBlockPropertiesCatalog', id?: string | null, uuid?: string | null, limit?: number | null, resourceCollection?: { __typename?: 'ResourceCollection', id?: string | null, uuid?: string | null, name?: string | null } | null, resources?: Array<{ __typename?: 'Resource', id?: string | null, uuid?: string | null, name?: string | null, type?: string | null, subtype?: string | null, description?: string | null, coverUri?: string | null, content?: { __typename?: 'ResourceContentAssessment' } | { __typename?: 'ResourceContentAudio' } | { __typename?: 'ResourceContentBuribookWithActivity', id?: string | null } | { __typename?: 'ResourceContentBurislide', id?: string | null } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', id?: string | null, courseDetails?: { __typename?: 'ResourceContentCourseDetails', course?: { __typename?: 'Course', uuid?: string | null, allowedActions?: Array<string | null> | null, isEnrolled?: boolean | null, enrolledSchedules?: Array<{ __typename?: 'CourseSchedule', name?: string | null, uuid?: string | null, status?: string | null, isActive?: boolean | null } | null> | null } | null } | null } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub', id?: string | null } | { __typename?: 'ResourceContentFile' } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf', id?: string | null } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo', id?: string | null } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null> | null, appearance?: { __typename?: 'CastBlockPropertiesCatalogAppearance', id?: string | null, base?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null, cardHeader?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null } | { __typename?: 'CastBlockPropertiesCategory' } | { __typename?: 'CastBlockPropertiesCourseStatus' } | { __typename?: 'CastBlockPropertiesDirectory' } | { __typename?: 'CastBlockPropertiesEmbed' } | { __typename?: 'CastBlockPropertiesMarkdown' } | { __typename?: 'CastBlockPropertiesNotSupported' } | null } | null } | null } | null };

export type EnrolledSchedulesQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
}>;


export type EnrolledSchedulesQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', course?: { __typename?: 'Course', enrolledSchedules?: Array<{ __typename?: 'CourseSchedule', uuid?: string | null, name?: string | null, start?: string | null, end?: string | null, status?: string | null } | null> | null } | null } | null };

export type GetCourseProgressQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
  scheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCourseProgressQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', courseProgressValue?: number | null } | null };

export type Checkout_CreateMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type Checkout_CreateMutation = { __typename?: 'Mutation', checkoutCreate?: { __typename?: 'CheckoutCreateResult', checkoutToken?: { __typename?: 'PayCheckoutToken', checkoutUrl?: string | null, userId?: string | null, validUntil?: number | null } | null } | null };

export type CommentsListQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
  forumTopicUuid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommentsListQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', forumTopic?: { __typename?: 'ForumTopic', comments?: Array<{ __typename?: 'ForumComment', uuid?: string | null, created?: string | null, text?: string | null, isFlagged?: boolean | null, isUserModerator?: boolean | null, createdBy?: { __typename?: 'PassUserDetails', firstName?: string | null, lastName?: string | null } | null } | null> | null } | null } | null };

export type ResourceViewScreenForModalsQueryVariables = Exact<{
  resourceDetailsInput: ResourceDetailsInput;
}>;


export type ResourceViewScreenForModalsQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resourceUuid?: string | null, resource?: { __typename?: 'Resource', id?: string | null, uuid?: string | null, type?: string | null, subtype?: string | null, name?: string | null } | null, courseBlock?: { __typename?: 'CourseBlock', uuid?: string | null, title?: string | null, maxSubmissionsReached?: boolean | null, openDate?: string | null, isAccessible?: boolean | null, referenceInfo?: { __typename?: 'CourseBlockReferenceInfo', referenceId?: string | null, customPassingMark?: number | null, maxAllowedSubmissions?: number | null, passOnSubmit?: boolean | null } | null, scheduleReferenceInfo?: { __typename?: 'CourseBlockScheduleReferenceInfo', referenceId?: string | null, maxAllowedSubmissions?: number | null, openDate?: string | null } | null } | null } | null };

export type CourseCardOutlineQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
}>;


export type CourseCardOutlineQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resource?: { __typename?: 'Resource', content?: { __typename?: 'ResourceContentAssessment' } | { __typename?: 'ResourceContentAudio' } | { __typename?: 'ResourceContentBuribookWithActivity' } | { __typename?: 'ResourceContentBurislide' } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', courseDetails?: { __typename?: 'ResourceContentCourseDetails', courseUuid?: string | null, course?: { __typename?: 'Course', enrolledSchedules?: Array<{ __typename?: 'CourseSchedule', status?: string | null, name?: string | null, uuid?: string | null, isActive?: boolean | null } | null> | null } | null } | null } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub' } | { __typename?: 'ResourceContentFile' } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf' } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo' } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null } | null };

export type ResourceViewScreenCourseCardChooseBatchQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
}>;


export type ResourceViewScreenCourseCardChooseBatchQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resource?: { __typename?: 'Resource', content?: { __typename?: 'ResourceContentAssessment' } | { __typename?: 'ResourceContentAudio' } | { __typename?: 'ResourceContentBuribookWithActivity' } | { __typename?: 'ResourceContentBurislide' } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', courseDetails?: { __typename?: 'ResourceContentCourseDetails', courseUuid?: string | null } | null } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub' } | { __typename?: 'ResourceContentFile' } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf' } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo' } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null } | null };

export type Self_EnrollMutationVariables = Exact<{
  courseScheduleUuid: Scalars['String']['input'];
}>;


export type Self_EnrollMutation = { __typename?: 'Mutation', self_enroll?: any | null };

export type SelfEnrollSchedulesQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
}>;


export type SelfEnrollSchedulesQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', course?: { __typename?: 'Course', selfEnrollSchedules?: Array<{ __typename?: 'CourseSchedule', uuid?: string | null, start?: string | null, end?: string | null, name?: string | null, isActive?: boolean | null } | null> | null } | null } | null };

export type FaviconQueryVariables = Exact<{ [key: string]: never; }>;


export type FaviconQuery = { __typename?: 'Query', browserTitleBar?: { __typename?: 'BrowserTitleBar', title?: string | null, faviconUri?: string | null, pwa?: { __typename?: 'PwaIcons', icon192?: string | null, icon512?: string | null } | null } | null };

export type ForumBarQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
}>;


export type ForumBarQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', forumTopicsCount?: number | null, forumTopics?: Array<{ __typename?: 'ForumTopic', isActive?: boolean | null } | null> | null } | null };

export type ForumTopicCreateMutationVariables = Exact<{
  input: CourseForumTopicInput;
}>;


export type ForumTopicCreateMutation = { __typename?: 'Mutation', courseForumTopicCreate?: { __typename?: 'CourseTopicResult', topic?: { __typename?: 'ForumTopic', title?: string | null, text?: string | null, isActive?: boolean | null } | null } | null };

export type ResourceDownloadQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
}>;


export type ResourceDownloadQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resource?: { __typename?: 'Resource', id?: string | null, type?: string | null, content?: { __typename?: 'ResourceContentAssessment' } | { __typename?: 'ResourceContentAudio', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentBuribookWithActivity', id?: string | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, imageUri?: string | null } | null> | null } | { __typename?: 'ResourceContentBurislide', id?: string | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, imageUri?: string | null } | null> | null } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse' } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentFile', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo', id?: string | null, uri?: string | null, hlsUri?: string | null, dashUri?: string | null, tracks?: Array<{ __typename?: 'ResourceContentVideoTrack', uri?: string | null } | null> | null } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null } | null };

export type NavbarQueryVariables = Exact<{ [key: string]: never; }>;


export type NavbarQuery = { __typename?: 'Query', navbar?: { __typename?: 'Navbar', navLogoUrl?: string | null, profileIconUrl?: string | null, searchSlug?: string | null, navAppearance?: { __typename?: 'NavbarAppearance', base?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null, item?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null, itemActive?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null, navScreenItems?: Array<{ __typename?: 'NavbarScreenItem', slug?: string | null, title?: string | null, screenId?: string | null, isHidden?: boolean | null, icon?: { __typename?: 'CastIcon', material?: string | null } | null } | null> | null, userInfo?: { __typename?: 'PassUserInfo', email?: string | null, userId?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type ResourceViewScreenPrerequisitesQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResourceViewScreenPrerequisitesQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', courseBlock?: { __typename?: 'CourseBlock', prerequisitesCourseBlocks?: Array<{ __typename?: 'CourseBlock', uuid?: string | null, title?: string | null, coverUri?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null, name?: string | null, type?: string | null, subtype?: string | null, coverUri?: string | null } | null } | null> | null } | null } | null };

export type Course_View_ScreenQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
}>;


export type Course_View_ScreenQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', course?: { __typename?: 'Course', id?: string | null, description?: string | null, title?: string | null, coverUri?: string | null } | null } | null };

export type Resource_View_ScreenQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
}>;


export type Resource_View_ScreenQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resource?: { __typename?: 'Resource', id?: string | null, description?: string | null, name?: string | null, type?: string | null, coverUri?: string | null } | null } | null };

export type ResultSlideQueryVariables = Exact<{
  examSectionUuid: Scalars['ID']['input'];
  examSubmissionUuid: Scalars['ID']['input'];
  resourceUuid: Scalars['ID']['input'];
  resourceSpreadIndex?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ResultSlideQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', sectionResult?: { __typename?: 'ResourceViewScreenSectionResult', scoreRaw?: number | null, scoreMax?: number | null, spreadResultDetails?: { __typename?: 'ResourceViewScreenSectionResultSpreadResultDetails', resultPageImageUri?: string | null, resultPageText?: string | null } | null } | null } | null };

export type AssessmentSubmitV2MutationVariables = Exact<{
  updatedSubmission: ExamSubmissionInputV2;
  submissionUuid: Scalars['String']['input'];
  blockUuid?: InputMaybe<Scalars['String']['input']>;
  courseScheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssessmentSubmitV2Mutation = { __typename?: 'Mutation', assessmentSubmitUpdateV2?: { __typename?: 'AssessmentViewScreenAssessmentSubmitResultV2', submissionResult?: { __typename?: 'ExamSubmission', final?: boolean | null, status?: string | null, totalScore?: number | null, submissionCount?: number | null, highestPossibleSubmissionScore?: number | null, totalItemLimit?: number | null, responsesCount?: number | null, responses?: Array<{ __typename?: 'ExamResponse', uuid?: string | null, item?: string | null, isResponseCorrect?: boolean | null, longInput?: string | null, shortInput?: string | null, showGrade?: boolean | null, feedbackMessage?: string | null, feedbackImageUrl?: string | null, shortAnswerKey?: string | null, choices?: Array<{ __typename?: 'ExamChoice', item?: string | null, isCorrect?: boolean | null, longInput?: string | null, mediaUrl?: string | null, shortInput?: string | null, imageUrl?: string | null, audioUrl?: string | null } | null> | null, pollResults?: Array<{ __typename?: 'PollResult', choice?: { __typename?: 'PollResultChoice', uuid?: string | null, longInput?: string | null, shortInput?: string | null, mediaUrl?: string | null } | null, result?: { __typename?: 'PollResultAnalytics', count?: number | null, percent?: number | null } | null } | null> | null, freedomWallResponses?: Array<{ __typename?: 'FreedomWallResult', uuid?: string | null, longInput?: string | null, shortInput?: string | null, userDetails?: { __typename?: 'PassUserDetails', firstName?: string | null, lastName?: string | null, profileIconUrl?: string | null } | null } | null> | null, tallyResults?: Array<{ __typename?: 'TallyResult', score?: number | null, type?: { __typename?: 'TallyResultType', uuid?: string | null, name?: string | null } | null } | null> | null } | null> | null } | null, courseBlockSubmissionResult?: { __typename?: 'CourseBlockUuidUserStatusSubmission', status?: string | null, final?: boolean | null, totalScore?: number | null, highestPossibleSubmissionScore?: number | null, totalItemLimit?: number | null, responsesCount?: number | null, submissionCount?: number | null, responses?: Array<{ __typename?: 'CourseBlockUuidUserStatusSubmissionResponse', uuid?: string | null, item?: string | null, isResponseCorrect?: boolean | null, longInput?: string | null, shortInput?: string | null, showGrade?: boolean | null, feedbackMessage?: string | null, feedbackImageUrl?: string | null, shortAnswerKey?: string | null, pollResults?: Array<{ __typename?: 'PollResult', choice?: { __typename?: 'PollResultChoice', uuid?: string | null, longInput?: string | null, shortInput?: string | null, mediaUrl?: string | null } | null, result?: { __typename?: 'PollResultAnalytics', count?: number | null, percent?: number | null } | null } | null> | null, freedomWallResponses?: Array<{ __typename?: 'CourseFreedomWallResult', uuid?: string | null, longInput?: string | null, shortInput?: string | null, userDetails?: { __typename?: 'PassUserDetails', firstName?: string | null, lastName?: string | null, profileIconUrl?: string | null } | null } | null> | null, tallyResults?: Array<{ __typename?: 'TallyResult', score?: number | null, type?: { __typename?: 'TallyResultType', uuid?: string | null, name?: string | null } | null } | null> | null, choices?: Array<{ __typename?: 'ExamChoice', item?: string | null, isCorrect?: boolean | null, longInput?: string | null, mediaUrl?: string | null, shortInput?: string | null, imageUrl?: string | null, audioUrl?: string | null } | null> | null } | null> | null, blockStatus?: { __typename?: 'CourseBlockUserstatus', scoreMax?: number | null } | null } | null } | null };

export type TimeChancesV2QueryVariables = Exact<{
  resourceDetailsInput: ResourceDetailsInput;
}>;


export type TimeChancesV2Query = { __typename?: 'Query', resourceViewScreenV2?: { __typename?: 'ResourceViewScreen', courseBlock?: { __typename?: 'CourseBlock', title?: string | null, maxSubmissionsReached?: boolean | null, requiredForCertificate?: boolean | null, referenceInfo?: { __typename?: 'CourseBlockReferenceInfo', referenceId?: string | null, customPassingMark?: number | null, maxAllowedSubmissions?: number | null, passOnSubmit?: boolean | null } | null, scheduleReferenceInfo?: { __typename?: 'CourseBlockScheduleReferenceInfo', referenceId?: string | null, maxAllowedSubmissions?: number | null } | null, userstatus?: { __typename?: 'CourseBlockUserstatus', status?: string | null, isComplete?: boolean | null, gradePercent?: number | null, scoreMax?: number | null, scoreRaw?: number | null, submissionCount?: number | null, submissionStatus?: string | null } | null } | null, resource?: { __typename?: 'Resource', type?: string | null, subtype?: string | null, content?: { __typename?: 'ResourceContentAssessment', examTimeslot?: { __typename?: 'ExamTimeslot', lastSubmissionStatus?: string | null, outline?: { __typename?: 'ExamTimeslotOutline', exam?: { __typename?: 'Exam', timeLimit?: number | null, highestPossibleScore?: number | null } | null } | null, userSubmissions?: { __typename?: 'ExamUserSubmissions', totalCount?: number | null, final?: { __typename?: 'ExamFinalSubmissions', count?: number | null, submissions?: Array<{ __typename?: 'ExamSubmission', totalScore?: number | null, highestPossibleSubmissionScore?: number | null } | null> | null } | null } | null } | null } | { __typename?: 'ResourceContentAudio' } | { __typename?: 'ResourceContentBuribookWithActivity' } | { __typename?: 'ResourceContentBurislide' } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse' } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub' } | { __typename?: 'ResourceContentFile' } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf' } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo' } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null } | null };

export type DeleteForumTopicMutationVariables = Exact<{
  forumTopicUuid: Scalars['ID']['input'];
}>;


export type DeleteForumTopicMutation = { __typename?: 'Mutation', course_forum_topic_delete?: any | null };

export type ForumTopicHideMutationVariables = Exact<{
  forumTopicUuid: Scalars['ID']['input'];
  input: CourseForumTopicInput;
}>;


export type ForumTopicHideMutation = { __typename?: 'Mutation', course_forum_topic_update?: { __typename?: 'CourseTopicResult', topic?: { __typename?: 'ForumTopic', is_active?: boolean | null } | null } | null };

export type CourseBlockExamResponseMutationVariables = Exact<{
  blockUuid: Scalars['String']['input'];
  response?: InputMaybe<CourseBlockExamSubmissionResponse>;
}>;


export type CourseBlockExamResponseMutation = { __typename?: 'Mutation', course_block_exam_response?: any | null };

export type CourseBlockExamSubmitUpdateMutationVariables = Exact<{
  blockUuid: Scalars['String']['input'];
  submission?: InputMaybe<CourseBlockExamSubmission>;
}>;


export type CourseBlockExamSubmitUpdateMutation = { __typename?: 'Mutation', course_block_exam_submit_update?: { __typename?: 'CourseBlockExamSubmitResult', submissionResult?: { __typename?: 'CourseBlockUuidUserStatusSubmission', uuid?: string | null, timeslot?: string | null, editable?: boolean | null, final?: boolean | null, status?: string | null, startedAt?: string | null, endedAt?: string | null, totalScore?: number | null, submissionCount?: number | null, highestPossibleScore?: number | null, responsesScoresSum?: number | null, totalItemLimit?: number | null, responsesCount?: number | null, createAt?: string | null, modifiedAt?: string | null, responses?: Array<{ __typename?: 'CourseBlockUuidUserStatusSubmissionResponse', uuid?: string | null, item?: string | null, editable?: boolean | null, score?: string | null, user?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, markedCorrect?: boolean | null, feedbackImageUrl?: string | null, feedbackMessage?: string | null, manualWeight?: number | null, isResponseCorrect?: boolean | null, createAt?: string | null, modifiedAt?: string | null, showGrade?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, item?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null } | null> | null, freedomWallResponses?: Array<{ __typename?: 'CourseFreedomWallResult', uuid?: string | null, user?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, createAt?: string | null, modifiedAt?: string | null, submittedBy?: { __typename?: 'CourseFreedomWallSubmittedBy', name?: string | null, email?: string | null, userUuid?: string | null } | null } | null> | null } | null> | null, blockStatus?: { __typename?: 'CourseBlockUserstatus', status?: string | null, isComplete?: boolean | null, gradePercent?: number | null, scoreRaw?: number | null, scoreMin?: number | null, scoreMax?: number | null } | null, certificateBlockStatuses?: Array<{ __typename?: 'CourseCertificateBlockStatus', status?: string | null, isEligible?: boolean | null, userCertificateStatus?: string | null } | null> | null } | null } | null };

export type AssessmentSubmitUpdateMutationVariables = Exact<{
  submissionUuid: Scalars['String']['input'];
  updatedSubmission: ExamSubmissionInput;
}>;


export type AssessmentSubmitUpdateMutation = { __typename?: 'Mutation', assessment_submit_update?: { __typename?: 'AssessmentViewScreenAssessmentSubmitResult', submissionResult?: { __typename?: 'ExamSubmission', status?: string | null, timeslot?: string | null, uuid?: string | null, totalItemLimit?: number | null, totalScore?: number | null, submissionCount?: number | null, responsesScoresSum?: number | null, responses?: Array<{ __typename?: 'ExamResponse', uuid?: string | null, score?: string | null, item?: string | null, mediaUrl?: string | null, markedCorrect?: boolean | null, feedbackImageUrl?: string | null, feedbackMessage?: string | null, modifiedAt?: string | null, pollChoice?: string | null, longInput?: string | null, isResponseCorrect?: boolean | null, shortInput?: string | null, showGrade?: boolean | null, tallyResults?: Array<{ __typename?: 'TallyResult', score?: number | null, type?: { __typename?: 'TallyResultType', uuid?: string | null, name?: string | null, description?: string | null } | null } | null> | null, pollResults?: Array<{ __typename?: 'PollResult', choice?: { __typename?: 'PollResultChoice', uuid?: string | null, audio_url?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, orderId?: number | null } | null, result?: { __typename?: 'PollResultAnalytics', count?: number | null, percent?: number | null } | null } | null> | null, choices?: Array<{ __typename?: 'ExamChoice', item?: string | null } | null> | null, freedomWallResponses?: Array<{ __typename?: 'FreedomWallResult', uuid?: string | null, user?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, createAt?: string | null, modifiedAt?: string | null } | null> | null } | null> | null } | null } | null };

export type ResourceViewScreenBuriBooksDetailedQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
}>;


export type ResourceViewScreenBuriBooksDetailedQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resourceUuid?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null, type?: string | null, name?: string | null, content?: { __typename: 'ResourceContentAssessment' } | { __typename: 'ResourceContentAudio' } | { __typename: 'ResourceContentBuribookWithActivity', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, text?: string | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, examItemUuid?: string | null, imageUri?: string | null, examItem?: { __typename?: 'ExamItem', uuid?: string | null, title?: string | null, text?: string | null, type?: string | null, subtype?: string | null, section?: string | null, instructions?: string | null, weight?: number | null, value?: number | null, hint?: string | null, explanation?: string | null, required?: boolean | null, mediaUrl?: string | null, orderId?: number | null, isGraded?: boolean | null, shuffleChoices?: string | null, maxAllowedResponses?: number | null, showResults?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, item?: string | null, image_url?: string | null, audio_url?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, orderId?: number | null, isCorrect?: boolean | null } | null> | null } | null } | null> | null } | { __typename: 'ResourceContentBurislide', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, text?: string | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, examItemUuid?: string | null, examTimeslotUuid?: string | null, imageUri?: string | null, examItem?: { __typename?: 'ExamItem', uuid?: string | null, title?: string | null, text?: string | null, type?: string | null, subtype?: string | null, section?: string | null, instructions?: string | null, weight?: number | null, value?: number | null, hint?: string | null, explanation?: string | null, required?: boolean | null, mediaUrl?: string | null, orderId?: number | null, isGraded?: boolean | null, shuffleChoices?: string | null, maxAllowedResponses?: number | null, showResults?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, item?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, imageUrl?: string | null, audioUrl?: string | null, orderId?: number | null, isCorrect?: boolean | null } | null> | null } | null } | null> | null } | { __typename: 'ResourceContentCasticulate' } | { __typename: 'ResourceContentCourse' } | { __typename: 'ResourceContentEmbed' } | { __typename: 'ResourceContentEpub' } | { __typename: 'ResourceContentFile' } | { __typename: 'ResourceContentLink' } | { __typename: 'ResourceContentNotSupported' } | { __typename: 'ResourceContentPdf' } | { __typename: 'ResourceContentText' } | { __typename: 'ResourceContentVideo' } | { __typename: 'ResourceContentXApi' } | { __typename: 'ResourceContentYoutube' } | null } | null } | null };

export type ItemsQueryVariables = Exact<{
  examTimeslotUuid: Scalars['String']['input'];
  resourceUuid: Scalars['String']['input'];
}>;


export type ItemsQuery = { __typename?: 'Query', assessmentViewScreen?: { __typename?: 'AssessmentViewScreen', examTimeslot?: { __typename?: 'ExamTimeslot', outline?: { __typename?: 'ExamTimeslotOutline', exam?: { __typename?: 'Exam', sections?: Array<{ __typename?: 'ExamSection', items?: Array<{ __typename?: 'ExamItem', uuid?: string | null, type?: string | null } | null> | null } | null> | null } | null } | null } | null } | null };

export type FileSubmissionV2MutationVariables = Exact<{
  updatedSubmission: ExamSubmissionInputV2;
  submissionUuid: Scalars['String']['input'];
  blockUuid?: InputMaybe<Scalars['String']['input']>;
  courseScheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type FileSubmissionV2Mutation = { __typename?: 'Mutation', assessmentSubmitUpdateV2?: { __typename: 'AssessmentViewScreenAssessmentSubmitResultV2' } | null };

export type FileSubmissionInsideCourseMutationVariables = Exact<{
  blockUuid: Scalars['String']['input'];
  submission?: InputMaybe<CourseBlockExamSubmission>;
}>;


export type FileSubmissionInsideCourseMutation = { __typename?: 'Mutation', course_block_exam_submission?: any | null };

export type FileSubmissionOutsideCourseMutationVariables = Exact<{
  examTimeslotUuid: Scalars['String']['input'];
  submission?: InputMaybe<ExamSubmissionInput>;
}>;


export type FileSubmissionOutsideCourseMutation = { __typename?: 'Mutation', assessment_submission?: any | null };

export type FreedomWallSubmitMutationVariables = Exact<{
  updatedSubmission: ExamSubmissionInputV2;
  submissionUuid: Scalars['String']['input'];
  blockUuid?: InputMaybe<Scalars['String']['input']>;
  courseScheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type FreedomWallSubmitMutation = { __typename?: 'Mutation', assessmentSubmitUpdateV2?: { __typename: 'AssessmentViewScreenAssessmentSubmitResultV2', submissionResult?: { __typename?: 'ExamSubmission', responses?: Array<{ __typename?: 'ExamResponse', feedbackMessage?: string | null, freedomWallResponses?: Array<{ __typename?: 'FreedomWallResult', userDetails?: { __typename?: 'PassUserDetails', firstName?: string | null, lastName?: string | null, profileIconUrl?: string | null } | null } | null> | null } | null> | null } | null, courseBlockSubmissionResult?: { __typename?: 'CourseBlockUuidUserStatusSubmission', responses?: Array<{ __typename?: 'CourseBlockUuidUserStatusSubmissionResponse', feedbackMessage?: string | null, freedomWallResponses?: Array<{ __typename?: 'CourseFreedomWallResult', uuid?: string | null, shortInput?: string | null, longInput?: string | null, userDetails?: { __typename?: 'PassUserDetails', firstName?: string | null, lastName?: string | null, profileIconUrl?: string | null } | null } | null> | null } | null> | null } | null } | null };

export type Account_And_User_Details_ScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type Account_And_User_Details_ScreenQuery = { __typename?: 'Query', accountAndUserDetailsScreen?: { __typename?: 'AccountAndUserDetailsScreen', userInfo?: { __typename?: 'PassUserInfo', firstName?: string | null, userId?: string | null } | null } | null };

export type DevQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DevQueryQuery = { __typename?: 'Query', dev?: { __typename?: 'Dev', session?: any | null } | null };

export type AccountAndUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountAndUserDetailsQuery = { __typename?: 'Query', accountAndUserDetailsScreen?: { __typename?: 'AccountAndUserDetailsScreen', userInfo?: { __typename?: 'PassUserInfo', email?: string | null, userId?: string | null, firstName?: string | null, lastName?: string | null, emailVerified?: boolean | null } | null, userProfile?: { __typename?: 'PassUserProfile', profileId?: string | null, givenName?: string | null, familyName?: string | null } | null, customFields?: Array<{ __typename?: 'AccountAndUserDetailsScreenCustomField', required?: boolean | null, label?: string | null, value?: string | null, options?: Array<string | null> | null, disabled?: boolean | null, inputType?: string | null, inputName?: string | null } | null> | null, formTabs?: Array<{ __typename?: 'AccountAndUserDetailsScreenFormTab', name?: string | null, id?: string | null } | null> | null } | null };

export type FormSubmitMutationVariables = Exact<{
  details?: InputMaybe<AccountAndUserDetailsScreenFormTabSubmit>;
}>;


export type FormSubmitMutation = { __typename?: 'Mutation', form_submit?: { __typename?: 'AccountAndUserDetailsScreenFormTabResult', formSubmissionSummary?: { __typename?: 'AccountAndUserDetailsScreenFormSubmissionSummary', id?: string | null, subtitle?: string | null, title?: string | null, approvalStatus?: string | null, dateCreated?: string | null, fileDescripiton?: string | null } | null } | null };

export type GetFormItemsQueryVariables = Exact<{
  formTabId: Scalars['ID']['input'];
}>;


export type GetFormItemsQuery = { __typename?: 'Query', accountAndUserDetailsScreen?: { __typename?: 'AccountAndUserDetailsScreen', formTab?: { __typename?: 'AccountAndUserDetailsScreenFormTab', formItems?: Array<{ __typename?: 'AccountAndUserDetailsScreenCustomField', disabled?: boolean | null, label?: string | null, options?: Array<string | null> | null, required?: boolean | null, value?: string | null, id?: string | null, inputName?: string | null, approvalStatus?: string | null, inputType?: string | null, needsApproval?: boolean | null } | null> | null } | null } | null };

export type GetFormSubmissionSummariesQueryVariables = Exact<{
  formTabId: Scalars['ID']['input'];
}>;


export type GetFormSubmissionSummariesQuery = { __typename?: 'Query', accountAndUserDetails?: { __typename?: 'AccountAndUserDetailsScreen', formTab?: { __typename?: 'AccountAndUserDetailsScreenFormTab', formSubmissionSummaries?: Array<{ __typename?: 'AccountAndUserDetailsScreenFormSubmissionSummary', id?: string | null, subtitle?: string | null, title?: string | null, approvalStatus?: string | null, dateCreated?: string | null, fileDescription?: string | null } | null> | null } | null } | null };

export type UpdateAccountMutationVariables = Exact<{
  details?: InputMaybe<AccountDetailsUpdate>;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', account_update?: { __typename?: 'PassUserInfo', user_id?: string | null, email?: string | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  details?: InputMaybe<AccountProfileUpdate>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', profile_update?: { __typename?: 'PassUserProfile', profile_id?: string | null, given_name?: string | null, family_name?: string | null } | null };

export type Log_GroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type Log_GroupsQuery = { __typename?: 'Query', activityLogScreen?: { __typename?: 'ActivityLogScreen', logGroups?: Array<{ __typename?: 'ActivityLogScreenLogGroup', name?: string | null, logItems?: Array<{ __typename?: 'ActivityLogScreenLogGroupItem', timestamp?: string | null, verb?: string | null, resource?: { __typename?: 'Resource', name?: string | null, type?: string | null, subtype?: string | null, coverUri?: string | null } | null } | null> | null } | null> | null } | null };

export type AssessmentDetailedViewScreenQueryVariables = Exact<{
  examTimeslotUuid: Scalars['String']['input'];
  resourceUuid: Scalars['String']['input'];
}>;


export type AssessmentDetailedViewScreenQuery = { __typename?: 'Query', assessment_view_screen?: { __typename?: 'AssessmentViewScreen', resource?: { __typename?: 'Resource', name?: string | null } | null, exam_timeslot?: { __typename?: 'ExamTimeslot', created_by?: string | null, created_at?: string | null, description?: string | null, end?: string | null, start?: string | null, uuid?: string | null, open?: boolean | null, name?: string | null, outline?: { __typename?: 'ExamTimeslotOutline', exam?: { __typename?: 'Exam', time_limit?: number | null, title?: string | null, userscores?: any | null, uuid?: string | null, slug?: string | null, show_grade_type?: string | null, show_grade?: boolean | null, modified_by?: string | null, is_graded?: boolean | null, has_complete_submission?: boolean | null, end_message?: string | null, display_progress?: boolean | null, display_points?: boolean | null, display_missed?: boolean | null, display_correct?: boolean | null, description?: string | null, created_by?: string | null, sections?: Array<{ __typename?: 'ExamSection', title?: string | null, uuid?: string | null, order_id?: number | null, is_graded?: boolean | null, item_limit?: number | null, created_by?: string | null, instructions?: string | null, shuffle_items?: boolean | null, modified_by?: string | null, exam?: string | null, items?: Array<{ __typename?: 'ExamItem', text?: string | null, type?: string | null, subtype?: string | null, media_url?: string | null, required?: boolean | null, title?: string | null, instructions?: string | null, hint?: string | null, explanation?: string | null, is_graded?: boolean | null, order_id?: number | null, uuid?: string | null, value?: number | null, shuffle_choices?: string | null, section?: string | null, weight?: number | null, show_results?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', is_correct?: boolean | null, long_input?: string | null, image_url?: string | null, short_input?: string | null, audio_url?: string | null, item?: string | null, uuid?: string | null, order_id?: number | null, created_at?: string | null, modified_at?: string | null } | null> | null } | null> | null } | null> | null } | null } | null, user_submissions?: { __typename?: 'ExamUserSubmissions', total_count?: number | null } | null } | null } | null };

export type GetNextCourseBlocksQueryVariables = Exact<{
  resourceDetailsInput: ResourceDetailsInput;
}>;


export type GetNextCourseBlocksQuery = { __typename?: 'Query', resourceViewScreenV2?: { __typename?: 'ResourceViewScreen', courseBlock?: { __typename?: 'CourseBlock', nextBlocks?: Array<string | null> | null, nextBlocksJoined?: Array<{ __typename?: 'CourseBlock', uuid?: string | null, title?: string | null, coverUri?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null } | null } | null> | null } | null } | null };

export type OldAssessmentSubmissionMutationVariables = Exact<{
  examTimeslotUuid: Scalars['String']['input'];
  submission?: InputMaybe<ExamSubmissionInput>;
}>;


export type OldAssessmentSubmissionMutation = { __typename?: 'Mutation', assessment_submission?: any | null };

export type OldCourseBlockExamSubmissionMutationVariables = Exact<{
  blockUuid: Scalars['String']['input'];
  submission?: InputMaybe<CourseBlockExamSubmission>;
}>;


export type OldCourseBlockExamSubmissionMutation = { __typename?: 'Mutation', course_block_exam_submission?: any | null };

export type AssessmentNextButtonMutationVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
  courseScheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssessmentNextButtonMutation = { __typename?: 'Mutation', resourceEnd?: { __typename?: 'ResourceViewScreenResourceEndResult', nextCourseBlocks?: Array<{ __typename?: 'CourseBlock', uuid?: string | null, title?: string | null, coverUri?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null } | null } | null> | null } | null };

export type LoginMutationVariables = Exact<{
  redirectUri: Scalars['String']['input'];
  code: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: any | null };

export type CastIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CastIdQuery = { __typename?: 'Query', browserTitleBar?: { __typename?: 'BrowserTitleBar', id?: string | null } | null };

export type CasticulateClearStateMutationVariables = Exact<{
  ids: CasticulateIdsInput;
}>;


export type CasticulateClearStateMutation = { __typename?: 'Mutation', casticulate_clear_state?: { __typename?: 'CasticulateState', id?: string | null } | null };

export type CasticulateSetStateMutationVariables = Exact<{
  ids: CasticulateIdsInput;
  data: Scalars['JSONObject']['input'];
}>;


export type CasticulateSetStateMutation = { __typename?: 'Mutation', casticulate_set_state?: { __typename?: 'CasticulateState', data?: any | null, hasState?: boolean | null } | null };

export type CasticulateStateQueryVariables = Exact<{
  ids: CasticulateIdsInput;
}>;


export type CasticulateStateQuery = { __typename?: 'Query', casticulateViewScreen?: { __typename?: 'CasticulateViewScreen', casticulateState?: { __typename?: 'CasticulateState', data?: any | null, id?: string | null, hasState?: boolean | null } | null } | null };

export type CasticulateViewScreenQueryVariables = Exact<{
  ids: CasticulateIdsInput;
}>;


export type CasticulateViewScreenQuery = { __typename?: 'Query', casticulateViewScreen?: { __typename?: 'CasticulateViewScreen', id?: string | null, casticulateGraph?: { __typename?: 'CasticulateGraph', id?: string | null, name?: string | null, nodes?: Array<{ __typename?: 'CasticulateNode', id?: string | null, data?: any | null, slideType?: string | null, isEndNode?: boolean | null, layout?: { __typename?: 'CasticulateLayout', id?: string | null, html?: string | null } | null } | null> | null, edges?: Array<{ __typename?: 'CasticulateEdge', id?: string | null, data?: any | null, fromNode?: { __typename?: 'CasticulateNode', id?: string | null, slideType?: string | null } | null, toNode?: { __typename?: 'CasticulateNode', id?: string | null, slideType?: string | null } | null, triggers?: Array<{ __typename?: 'CasticulateTrigger', action?: string | null, value?: string | null, id?: string | null, refId?: string | null } | null> | null } | null> | null, possibleRoutes?: Array<Array<{ __typename?: 'CasticulateNode', id?: string | null, data?: any | null, slideType?: string | null } | null> | null> | null } | null } | null };

export type CollectionListScreenQueryVariables = Exact<{
  resourceCollectionUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollectionListScreenQuery = { __typename?: 'Query', catalogListScreen?: { __typename?: 'CatalogListScreen', resourceCollection?: { __typename?: 'ResourceCollection', id?: string | null, name?: string | null } | null, resources?: Array<{ __typename?: 'Resource', id?: string | null, uuid?: string | null, name?: string | null, description?: string | null, type?: string | null, subtype?: string | null, coverUri?: string | null, content?: { __typename?: 'ResourceContentAssessment', examTimeslot?: { __typename?: 'ExamTimeslot', userSubmissions?: { __typename?: 'ExamUserSubmissions', final?: { __typename?: 'ExamFinalSubmissions', count?: number | null } | null } | null, outline?: { __typename?: 'ExamTimeslotOutline', exam?: { __typename?: 'Exam', timeLimit?: number | null } | null } | null } | null } | { __typename?: 'ResourceContentAudio' } | { __typename?: 'ResourceContentBuribookWithActivity' } | { __typename?: 'ResourceContentBurislide' } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', course_details?: { __typename?: 'ResourceContentCourseDetails', course?: { __typename?: 'Course', uuid?: string | null, id?: string | null, allowedActions?: Array<string | null> | null, isEnrolled?: boolean | null } | null } | null } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub' } | { __typename?: 'ResourceContentFile' } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf' } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo' } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null> | null } | null };

export type CourseActivityCheckerQueryVariables = Exact<{
  courseUuid: Scalars['ID']['input'];
  scheduleUuid: Scalars['String']['input'];
}>;


export type CourseActivityCheckerQuery = { __typename?: 'Query', courseProgressScreen?: { __typename?: 'CourseProgressScreen', outlineProgress?: Array<{ __typename?: 'CourseProgressScreenOutlineProgressSection', title?: string | null, blocks?: Array<{ __typename?: 'CourseProgressScreenOutlineProgressBlock', title?: string | null, status?: string | null, resourceType?: string | null, resourceSubType?: string | null, coverUri?: string | null, scoreRaw?: number | null, scoreMax?: number | null } | null> | null } | null> | null, course?: { __typename?: 'Course', title?: string | null, description?: string | null, coverUri?: string | null, hasUserComplete?: boolean | null, enrollmentInfo?: { __typename?: 'EnrollmentInfo', end?: string | null } | null, enrolledSchedules?: Array<{ __typename?: 'CourseSchedule', status?: string | null, uuid?: string | null } | null> | null } | null, learnerCourseStatus?: { __typename?: 'StatisticsLearnerCourseStatus', status?: string | null, courseCertificateUrl?: string | null, scheduleDetails?: { __typename?: 'ScheduleDetails', status?: string | null } | null } | null } | null };

export type CourseViewerQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
  scheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CourseViewerQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', id?: string | null, courseProgressMax?: number | null, courseProgressValue?: number | null, isForumEnabled?: boolean | null, course?: { __typename?: 'Course', id?: string | null, uuid?: string | null, description?: string | null, title?: string | null, coverUri?: string | null, isEnrolled?: boolean | null, outline?: Array<{ __typename?: 'CourseSection', title?: string | null, blocks?: Array<{ __typename?: 'CourseBlock', uuid?: string | null, title?: string | null, coverUri?: string | null, isAccessible?: boolean | null, maxSubmissionsReached?: boolean | null, openDate?: string | null, numberOfDays?: number | null, expiryDate?: string | null, daysTilExpired?: number | null, certificateBlockStatusValue?: string | null, resource?: { __typename?: 'Resource', id?: string | null, type?: string | null, description?: string | null, uuid?: string | null } | null, certificateBlockStatus?: Array<{ __typename?: 'CourseCertificateBlockStatus', status?: string | null } | null> | null, userstatus?: { __typename?: 'CourseBlockUserstatus', status?: string | null } | null, prerequisitesCourseBlocks?: Array<{ __typename?: 'CourseBlock', hasUserCompleted?: boolean | null } | null> | null, scheduleReferenceInfo?: { __typename?: 'CourseBlockScheduleReferenceInfo', maxAllowedSubmissions?: number | null, openDate?: string | null, referenceId?: string | null } | null } | null> | null } | null> | null, styleInfo?: { __typename?: 'CourseStyleInfo', base?: { __typename?: 'CastAppearance', fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null, cardHeader?: { __typename?: 'CastAppearance', fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null, enrollmentInfo?: { __typename?: 'EnrollmentInfo', name?: string | null, start?: string | null, end?: string | null, isActive?: boolean | null } | null } | null, nextCourseBlocks?: Array<{ __typename?: 'CourseBlock', uuid?: string | null, title?: string | null, coverUri?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null, type?: string | null, description?: string | null } | null } | null> | null, learnerCourseStatus?: { __typename?: 'StatisticsLearnerCourseStatus', status?: string | null, courseCertificateEndMessage?: string | null, courseCertificateUrl?: string | null, scheduleDetails?: { __typename?: 'ScheduleDetails', status?: string | null } | null } | null } | null };

export type DirectoryViewScreenQueryVariables = Exact<{
  path?: InputMaybe<Scalars['String']['input']>;
  resourcesPath2?: InputMaybe<Scalars['String']['input']>;
}>;


export type DirectoryViewScreenQuery = { __typename?: 'Query', directory_view_screen?: { __typename?: 'DirectoryViewScreen', id?: string | null, directory?: Array<{ __typename?: 'CastBlockPropertiesDirectoryPaths', id?: string | null, path?: string | null } | null> | null, resources?: Array<{ __typename?: 'Resource', id?: string | null, uuid?: string | null, name?: string | null, type?: string | null, subtype?: string | null, description?: string | null, coverUri?: string | null, content?: { __typename?: 'ResourceContentAssessment' } | { __typename?: 'ResourceContentAudio' } | { __typename?: 'ResourceContentBuribookWithActivity', id?: string | null } | { __typename?: 'ResourceContentBurislide', id?: string | null } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', id?: string | null, courseDetails?: { __typename?: 'ResourceContentCourseDetails', course?: { __typename?: 'Course', uuid?: string | null, allowedActions?: Array<string | null> | null, isEnrolled?: boolean | null, enrolledSchedules?: Array<{ __typename?: 'CourseSchedule', name?: string | null, uuid?: string | null, status?: string | null, isActive?: boolean | null } | null> | null } | null } | null } | { __typename?: 'ResourceContentEmbed' } | { __typename?: 'ResourceContentEpub', id?: string | null } | { __typename?: 'ResourceContentFile' } | { __typename?: 'ResourceContentLink' } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf', id?: string | null } | { __typename?: 'ResourceContentText' } | { __typename?: 'ResourceContentVideo', id?: string | null } | { __typename?: 'ResourceContentXApi' } | { __typename?: 'ResourceContentYoutube' } | null } | null> | null } | null };

export type ForumTopicsQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
}>;


export type ForumTopicsQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', isUserForumAdmin?: boolean | null, forumTopics?: Array<{ __typename?: 'ForumTopic', uuid?: string | null, title?: string | null, created?: string | null, createdBy?: string | null, isActive?: boolean | null, isUserAdmin?: boolean | null, createdByUserDetails?: { __typename?: 'PassUserDetails', email?: string | null, firstName?: string | null, lastName?: string | null } | null, comments?: Array<{ __typename?: 'ForumComment', uuid?: string | null, isFlagged?: boolean | null } | null> | null } | null> | null, course?: { __typename?: 'Course', title?: string | null, isEnrolled?: boolean | null, coverUri?: string | null, styleInfo?: { __typename?: 'CourseStyleInfo', base?: { __typename?: 'CastAppearance', backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null } | null } | null };

export type GbfSlideViewQueryVariables = Exact<{
  resourceDetailsInput: ResourceDetailsInput;
}>;


export type GbfSlideViewQuery = { __typename?: 'Query', resourceViewScreenV2?: { __typename?: 'ResourceViewScreen', resourceUuid?: string | null, resource?: { __typename?: 'Resource', id?: string | null, uuid?: string | null, type?: string | null, name?: string | null, course_block_uuid?: string | null, content?: { __typename: 'ResourceContentAssessment' } | { __typename: 'ResourceContentAudio' } | { __typename: 'ResourceContentBuribookWithActivity', id?: string | null, examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, text?: string | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, examItemUuid?: string | null, imageUri?: string | null, isResultPageShown?: boolean | null, resultPageImageUri?: string | null, viewMode?: string | null, examItem?: { __typename?: 'ExamItem', uuid?: string | null, title?: string | null, text?: string | null, type?: string | null, subtype?: string | null, section?: string | null, instructions?: string | null, weight?: number | null, value?: number | null, hint?: string | null, explanation?: string | null, required?: boolean | null, mediaUrl?: string | null, orderId?: number | null, isGraded?: boolean | null, shuffleChoices?: string | null, maxAllowedResponses?: number | null, showResults?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, item?: string | null, image_url?: string | null, audio_url?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, orderId?: number | null, isCorrect?: boolean | null } | null> | null } | null, examSectionItems?: Array<{ __typename?: 'ExamItem', uuid?: string | null, title?: string | null, text?: string | null, type?: string | null, subtype?: string | null, section?: string | null, instructions?: string | null, weight?: number | null, value?: number | null, hint?: string | null, explanation?: string | null, required?: boolean | null, mediaUrl?: string | null, orderId?: number | null, isGraded?: boolean | null, shuffleChoices?: string | null, maxAllowedResponses?: number | null, showResults?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, item?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, imageUrl?: string | null, audioUrl?: string | null, orderId?: number | null, isCorrect?: boolean | null } | null> | null } | null> | null, appearance?: { __typename?: 'ResourceContentBurislideSpreadStyleInfo', base?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null, examChoiceTriggerFlags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupExamChoiceTriggerFlag', examChoiceUuid?: string | null, flags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupFlag', value?: boolean | null, flagId?: string | null } | null> | null } | null> | null, examItemRequiredFlags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupExamItemRequiredFlag', examItemUuid?: string | null, flags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupFlag', value?: boolean | null, flagId?: string | null } | null> | null } | null> | null } | null> | null, appearance?: { __typename?: 'ResourceContentBurislideSpreadStyleInfo', base?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null } | { __typename: 'ResourceContentBurislide', id?: string | null, examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, text?: string | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, examItemUuid?: string | null, examTimeslotUuid?: string | null, imageUri?: string | null, isResultPageShown?: boolean | null, resultPageImageUri?: string | null, viewMode?: string | null, examItem?: { __typename?: 'ExamItem', uuid?: string | null, title?: string | null, text?: string | null, type?: string | null, subtype?: string | null, section?: string | null, instructions?: string | null, weight?: number | null, value?: number | null, hint?: string | null, explanation?: string | null, required?: boolean | null, mediaUrl?: string | null, orderId?: number | null, isGraded?: boolean | null, shuffleChoices?: string | null, maxAllowedResponses?: number | null, showResults?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, item?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, imageUrl?: string | null, audioUrl?: string | null, orderId?: number | null, isCorrect?: boolean | null } | null> | null } | null, examSectionItems?: Array<{ __typename?: 'ExamItem', uuid?: string | null, title?: string | null, text?: string | null, type?: string | null, subtype?: string | null, section?: string | null, instructions?: string | null, weight?: number | null, value?: number | null, hint?: string | null, explanation?: string | null, required?: boolean | null, mediaUrl?: string | null, orderId?: number | null, isGraded?: boolean | null, shuffleChoices?: string | null, maxAllowedResponses?: number | null, showResults?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, item?: string | null, shortInput?: string | null, longInput?: string | null, mediaUrl?: string | null, imageUrl?: string | null, audioUrl?: string | null, orderId?: number | null, isCorrect?: boolean | null } | null> | null } | null> | null, appearance?: { __typename?: 'ResourceContentBurislideSpreadStyleInfo', base?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null, examChoiceTriggerFlags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupExamChoiceTriggerFlag', examChoiceUuid?: string | null, flags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupFlag', value?: boolean | null, flagId?: string | null } | null> | null } | null> | null, examItemRequiredFlags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupExamItemRequiredFlag', examItemUuid?: string | null, flags?: Array<{ __typename?: 'ResourceContentBurislideSpreadActivityGroupFlag', value?: boolean | null, flagId?: string | null } | null> | null } | null> | null } | null> | null, appearance?: { __typename?: 'ResourceContentBurislideSpreadStyleInfo', base?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null } | { __typename: 'ResourceContentCasticulate' } | { __typename: 'ResourceContentCourse' } | { __typename: 'ResourceContentEmbed' } | { __typename: 'ResourceContentEpub' } | { __typename: 'ResourceContentFile' } | { __typename: 'ResourceContentLink' } | { __typename: 'ResourceContentNotSupported' } | { __typename: 'ResourceContentPdf' } | { __typename: 'ResourceContentText' } | { __typename: 'ResourceContentVideo' } | { __typename: 'ResourceContentXApi' } | { __typename: 'ResourceContentYoutube' } | null } | null, courseBlock?: { __typename?: 'CourseBlock', completeOnFinal?: boolean | null, scheduleReferenceInfo?: { __typename?: 'CourseBlockScheduleReferenceInfo', schedule?: string | null, referenceId?: string | null } | null } | null } | null };

export type GetSubmissionUuidMutationVariables = Exact<{
  examTimeslotUuid: Scalars['String']['input'];
  blockUuid?: InputMaybe<Scalars['String']['input']>;
  submission?: InputMaybe<ExamSubmissionInputV2>;
  courseScheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSubmissionUuidMutation = { __typename?: 'Mutation', assessmentSubmitV2?: { __typename?: 'AssessmentViewScreenAssessmentSubmitResultV2', courseBlockSubmissionResult?: { __typename?: 'CourseBlockUuidUserStatusSubmission', uuid?: string | null } | null, submissionResult?: { __typename?: 'ExamSubmission', uuid?: string | null } | null } | null };

export type GetGradesQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGradesQuery = { __typename?: 'Query', coursesAndCertificationScreen?: { __typename?: 'CoursesAndCertificationScreen', learnerCourseStatuses?: Array<{ __typename?: 'StatisticsLearnerCourseStatus', status?: string | null, courseCertificateUrl?: string | null, courseDetails?: { __typename?: 'Course', title?: string | null, uuid?: string | null, coverUri?: string | null, isEnrolled?: boolean | null } | null, scheduleDetails?: { __typename?: 'ScheduleDetails', uuid?: string | null, name?: string | null, start?: string | null, end?: string | null, status?: string | null, isActive?: boolean | null } | null, sectionStatuses?: Array<{ __typename?: 'CourseSectionStatus', blockStatuses?: Array<{ __typename?: 'CourseBlockStatus', status?: string | null, scoreMax?: number | null, scoreRaw?: number | null, blockDetails?: { __typename?: 'BlockDetails', title?: string | null, requiredForCertificate?: boolean | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type HomeScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeScreenQuery = { __typename?: 'Query', home_screen?: { __typename?: 'HomeScreen', initial_slug?: string | null } | null };

export type GetLoginScreenQueryVariables = Exact<{
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLoginScreenQuery = { __typename?: 'Query', loginScreen?: { __typename?: 'LoginScreen', castId?: number | null, bannerUrl?: string | null, heroUrl?: string | null, navUrl?: string | null, clientId?: string | null, faviconUrl?: string | null, loginIconUrl?: string | null, isSignupEnabled?: boolean | null, cast?: { __typename?: 'Cast', attributes?: { __typename?: 'CastAttributes', allowGuestLogin?: boolean | null, defaultLoginAsGuest?: boolean | null } | null } | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: any | null };

export type CardBatchStatusQueryVariables = Exact<{
  courseUuid: Scalars['ID']['input'];
}>;


export type CardBatchStatusQuery = { __typename?: 'Query', courseProgressScreen?: { __typename?: 'CourseProgressScreen', course?: { __typename?: 'Course', enrolledSchedules?: Array<{ __typename?: 'CourseSchedule', uuid?: string | null, status?: string | null } | null> | null } | null } | null };

export type LearnerCourseStatusQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnerCourseStatusQuery = { __typename?: 'Query', coursesAndCertificationScreen?: { __typename?: 'CoursesAndCertificationScreen', learnerCourseStatuses?: Array<{ __typename?: 'StatisticsLearnerCourseStatus', status?: string | null, courseCertificateUrl?: string | null, courseDetails?: { __typename?: 'Course', title?: string | null, uuid?: string | null, coverUri?: string | null } | null, scheduleDetails?: { __typename?: 'ScheduleDetails', uuid?: string | null, name?: string | null, start?: string | null, end?: string | null, status?: string | null, isActive?: boolean | null } | null } | null> | null } | null };

export type CastBlocksQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type CastBlocksQuery = { __typename?: 'Query', castBlockScreen?: { __typename?: 'CastBlockListScreen', id?: string | null, castBlocks?: Array<{ __typename?: 'CastBlock', id?: string | null, attributes?: { __typename?: 'CastBlockAttributes', type?: string | null, properties?: { __typename?: 'CastBlockPropertiesButtonSearch', id?: string | null, _dummy?: string | null, title?: string | null, appearance?: { __typename?: 'CastBlockPropertiesButtonSearchAppearance', base?: { __typename?: 'CastAppearance', backgroundImage?: string | null, fontFamily?: Array<string | null> | null, backgroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null, foregroundColor?: { __typename?: 'CastColor', alpha?: number | null, blue?: number | null, green?: number | null, red?: number | null } | null } | null } | null } | { __typename?: 'CastBlockPropertiesCarousel', id?: string | null, items?: Array<{ __typename?: 'CastBlockPropertiesCarouselItems', src?: string | null, image?: string | null, url?: string | null } | null> | null } | { __typename?: 'CastBlockPropertiesCatalog', id?: string | null, uuid?: string | null } | { __typename?: 'CastBlockPropertiesCategory', collectionsUuid?: Array<string | null> | null, collections?: Array<{ __typename?: 'ResourceCollection', id?: string | null, description?: string | null, name?: string | null, uuid?: string | null, coverUri?: string | null } | null> | null } | { __typename?: 'CastBlockPropertiesCourseStatus', id?: string | null, heading?: string | null } | { __typename?: 'CastBlockPropertiesDirectory', id?: string | null, basePath?: string | null, directory?: Array<{ __typename?: 'CastBlockPropertiesDirectoryPaths', id?: string | null, path?: string | null } | null> | null, resources?: Array<{ __typename?: 'Resource', id?: string | null, type?: string | null, subtype?: string | null, description?: string | null, name?: string | null, uuid?: string | null, coverUri?: string | null } | null> | null } | { __typename?: 'CastBlockPropertiesEmbed', id?: string | null, url?: string | null } | { __typename?: 'CastBlockPropertiesMarkdown', id?: string | null, content?: string | null } | { __typename?: 'CastBlockPropertiesNotSupported' } | null } | null } | null> | null } | null };

export type SearchSlugQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchSlugQuery = { __typename?: 'Query', navbar?: { __typename?: 'Navbar', seachSlug?: string | null } | null };

export type GetSearchScreenQueryVariables = Exact<{
  q: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSearchScreenQuery = { __typename?: 'Query', search_screen?: { __typename?: 'SearchScreen', resources?: Array<{ __typename?: 'Resource', uuid?: string | null, name?: string | null, type?: string | null, subtype?: string | null, cover_uri?: string | null, description?: string | null } | null> | null } | null };

export type SearchScreenQueryVariables = Exact<{
  q: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchScreenQuery = { __typename?: 'Query', searchScreen?: { __typename?: 'SearchScreen', resources?: Array<{ __typename?: 'Resource', uuid?: string | null, name?: string | null, type?: string | null, description?: string | null, coverUri?: string | null } | null> | null } | null };

export type User_SubscriptionQueryVariables = Exact<{
  userSubscriptionId: Scalars['ID']['input'];
}>;


export type User_SubscriptionQuery = { __typename?: 'Query', subscriptionScreen?: { __typename?: 'SubscriptionScreen', userSubscription?: { __typename?: 'PayUserSubscription', uuid?: string | null, cancelled?: boolean | null, expires?: string | null, onTrial?: boolean | null, isActive?: boolean | null, plan?: { __typename?: 'PaySubscriptionPlan', uuid?: string | null, name?: string | null, trialPeriod?: number | null, trialUnit?: string | null, planPeriod?: number | null, planUnit?: string | null, isRecurring?: boolean | null, isActive?: boolean | null, product?: { __typename?: 'PayCatalogueProduct', id?: string | null, title?: string | null, slug?: string | null, description?: string | null } | null } | null, invoiceReceipts?: Array<{ __typename?: 'PayInvoceReceipt', uuid?: string | null, charge?: { __typename?: 'PayPaymentCharge', amount?: string | null, status?: string | null, modified?: string | null } | null } | null> | null } | null } | null };

export type Subscription_PlansQueryVariables = Exact<{ [key: string]: never; }>;


export type Subscription_PlansQuery = { __typename?: 'Query', subscriptionScreen?: { __typename?: 'SubscriptionScreen', subscriptionPlans?: Array<{ __typename?: 'SubscriptionScreenPlan', name?: string | null, price?: number | null, planPeriod?: number | null, planUnit?: string | null, productId?: number | null, subscriptionPlanId?: string | null } | null> | null } | null };

export type Subscription_ChangeMutationVariables = Exact<{
  userSubscriptionId: Scalars['ID']['input'];
  subscriptionPlanIdTo: Scalars['ID']['input'];
}>;


export type Subscription_ChangeMutation = { __typename?: 'Mutation', subscription_change?: any | null };

export type Subscription_CancelMutationVariables = Exact<{
  userSubscriptionId: Scalars['ID']['input'];
}>;


export type Subscription_CancelMutation = { __typename?: 'Mutation', subscription_cancel?: { __typename?: 'PayUserSubscription', uuid?: string | null } | null };

export type Subscription_UncancelMutationVariables = Exact<{
  userSubscriptionId: Scalars['ID']['input'];
}>;


export type Subscription_UncancelMutation = { __typename?: 'Mutation', subscription_uncancel?: any | null };

export type Subscription_ScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type Subscription_ScreenQuery = { __typename?: 'Query', subscriptionScreen?: { __typename?: 'SubscriptionScreen', subscriptionPlans?: Array<{ __typename?: 'SubscriptionScreenPlan', name?: string | null, price?: number | null, planPeriod?: number | null, planUnit?: string | null, productId?: number | null, subscriptionPlanId?: string | null } | null> | null, userSubscriptions?: Array<{ __typename?: 'PayUserSubscription', uuid?: string | null, expires?: string | null, cancelled?: boolean | null, onTrial?: boolean | null, isActive?: boolean | null, plan?: { __typename?: 'PaySubscriptionPlan', uuid?: string | null, name?: string | null, trialPeriod?: number | null, trialUnit?: string | null, planPeriod?: number | null, planUnit?: string | null, isRecurring?: boolean | null, isActive?: boolean | null, product?: { __typename?: 'PayCatalogueProduct', id?: string | null, title?: string | null, slug?: string | null, description?: string | null } | null } | null } | null> | null } | null };

export type TopicViewQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
  forumTopicUuid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TopicViewQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', forumTopic?: { __typename?: 'ForumTopic', uuid?: string | null, text?: string | null, title?: string | null } | null } | null };

export type UserUuidQueryVariables = Exact<{ [key: string]: never; }>;


export type UserUuidQuery = { __typename?: 'Query', accountAndUserDetailsScreen?: { __typename?: 'AccountAndUserDetailsScreen', userProfile?: { __typename?: 'PassUserProfile', givenName?: string | null, familyName?: string | null } | null } | null };

export type CompletedDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompletedDomainsQuery = { __typename?: 'Query', tisScreen?: { __typename?: 'TisScreen', completedBlockIndicator?: { __typename?: 'CourseUserCompletedBlockIndicator', totalPoints?: number | null, domains?: Array<{ __typename?: 'CourseUserCompletedBlockIndicatorDomain', name?: string | null, totalPoints?: number | null, children?: Array<{ __typename?: 'CourseUserCompletedBlockIndicatorDomainChild', name?: string | null, totalPoints?: number | null, indicators?: Array<{ __typename?: 'CourseUserCompletedBlockIndicatorDomainIndicator', name?: string | null, points?: number | null, displayUnitName?: string | null } | null> | null } | null> | null, indicators?: Array<{ __typename?: 'CourseUserCompletedBlockIndicatorDomainIndicator', name?: string | null, points?: number | null, displayUnitName?: string | null } | null> | null } | null> | null } | null } | null };

export type CertificateViewScreenQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
  scheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CertificateViewScreenQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', learnerCourseStatus?: { __typename?: 'StatisticsLearnerCourseStatus', status?: string | null, courseCertificateEndMessage?: string | null, courseCertificateUrl?: string | null } | null } | null };

export type ResourceViewScreenQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
}>;


export type ResourceViewScreenQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resource_uuid?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null, type?: string | null, subtype?: string | null, name?: string | null, content?: { __typename?: 'ResourceContentAssessment', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null } | { __typename?: 'ResourceContentAudio', uri?: string | null, contentType?: string | null } | { __typename?: 'ResourceContentBuribookWithActivity', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null } | { __typename?: 'ResourceContentBurislide', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', courseDetails?: { __typename?: 'ResourceContentCourseDetails', courseUuid?: string | null } | null } | { __typename?: 'ResourceContentEmbed', uri?: string | null } | { __typename?: 'ResourceContentEpub', uri?: string | null } | { __typename?: 'ResourceContentFile', uri?: string | null, previewGraphicUri?: string | null } | { __typename?: 'ResourceContentLink', uri?: string | null } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf', uri?: string | null, contentType?: string | null, previewGraphicUri?: string | null } | { __typename?: 'ResourceContentText', text?: string | null } | { __typename?: 'ResourceContentVideo', uri?: string | null, hlsUri?: string | null, dashUri?: string | null, contentType?: string | null, videoDescription?: string | null, subtitleClass?: string | null, tracks?: Array<{ __typename?: 'ResourceContentVideoTrack', uri?: string | null } | null> | null } | { __typename?: 'ResourceContentXApi', uri?: string | null } | { __typename?: 'ResourceContentYoutube', uri?: string | null, videoId?: string | null } | null } | null } | null };

export type ResourceStartMutationVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
  courseScheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResourceStartMutation = { __typename?: 'Mutation', resource_start?: any | null };

export type ResourceEndMutationVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
  courseScheduleUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResourceEndMutation = { __typename?: 'Mutation', resource_end?: { __typename?: 'ResourceViewScreenResourceEndResult', next_course_blocks?: Array<{ __typename?: 'CourseBlock', uuid?: string | null, title?: string | null, coverUri?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null } | null } | null> | null } | null };

export type RecipeCookMutationVariables = Exact<{
  ingredient?: InputMaybe<RecipeIngredients>;
}>;


export type RecipeCookMutation = { __typename?: 'Mutation', recipe_cook?: any | null };

export type RecipeCookMultipleMutationVariables = Exact<{
  ingredients?: InputMaybe<Array<InputMaybe<RecipeIngredients>> | InputMaybe<RecipeIngredients>>;
}>;


export type RecipeCookMultipleMutation = { __typename?: 'Mutation', recipe_cook_multiple?: Array<any | null> | null };

export type ResourceViewScreenWithReferenceInfoAndUserStatusQueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResourceViewScreenWithReferenceInfoAndUserStatusQuery = { __typename?: 'Query', resourceViewScreen?: { __typename?: 'ResourceViewScreen', resourceUuid?: string | null, resource?: { __typename?: 'Resource', uuid?: string | null, type?: string | null, subtype?: string | null, name?: string | null, content?: { __typename?: 'ResourceContentAssessment', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null, examTimeslot?: { __typename?: 'ExamTimeslot', maxAllowedSubmissions?: number | null, outline?: { __typename?: 'ExamTimeslotOutline', exam?: { __typename?: 'Exam', timeLimit?: number | null } | null } | null, userSubmissions?: { __typename?: 'ExamUserSubmissions', totalCount?: number | null } | null } | null } | { __typename?: 'ResourceContentAudio', uri?: string | null, contentType?: string | null } | { __typename?: 'ResourceContentBuribookWithActivity', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null } | { __typename?: 'ResourceContentBurislide', examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null } | { __typename?: 'ResourceContentCasticulate' } | { __typename?: 'ResourceContentCourse', courseDetails?: { __typename?: 'ResourceContentCourseDetails', courseUuid?: string | null } | null } | { __typename?: 'ResourceContentEmbed', uri?: string | null } | { __typename?: 'ResourceContentEpub', uri?: string | null } | { __typename?: 'ResourceContentFile', uri?: string | null, previewGraphicUri?: string | null } | { __typename?: 'ResourceContentLink', uri?: string | null } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf', uri?: string | null, contentType?: string | null, previewGraphicUri?: string | null } | { __typename?: 'ResourceContentText', text?: string | null } | { __typename?: 'ResourceContentVideo', uri?: string | null, hlsUri?: string | null, dashUri?: string | null, contentType?: string | null, videoDescription?: string | null, subtitleClass?: string | null, tracks?: Array<{ __typename?: 'ResourceContentVideoTrack', uri?: string | null } | null> | null } | { __typename?: 'ResourceContentXApi', uri?: string | null } | { __typename?: 'ResourceContentYoutube', uri?: string | null, videoId?: string | null } | null } | null, courseBlock?: { __typename?: 'CourseBlock', title?: string | null, maxSubmissionsReached?: boolean | null, referenceInfo?: { __typename?: 'CourseBlockReferenceInfo', referenceId?: string | null, customPassingMark?: number | null, maxAllowedSubmissions?: number | null, passOnSubmit?: boolean | null } | null, userstatus?: { __typename?: 'CourseBlockUserstatus', is_complete?: boolean | null, status?: string | null, grade_percent?: number | null, score_raw?: number | null, score_min?: number | null, score_max?: number | null } | null } | null } | null };

export type CheckIfXapiCompleteV1QueryVariables = Exact<{
  resourceUuid: Scalars['ID']['input'];
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckIfXapiCompleteV1Query = { __typename?: 'Query', resource_view_screen?: { __typename?: 'ResourceViewScreen', course_block?: { __typename?: 'CourseBlock', has_user_completed?: boolean | null } | null } | null };

export type CheckIfXapiCompleteQueryVariables = Exact<{
  resourceDetailsInput: ResourceDetailsInput;
}>;


export type CheckIfXapiCompleteQuery = { __typename?: 'Query', resourceViewScreenV2?: { __typename?: 'ResourceViewScreen', courseBlock?: { __typename?: 'CourseBlock', hasUserComplete?: boolean | null } | null } | null };

export type ResourceAccessibilityQueryVariables = Exact<{
  resourceDetailsInput: ResourceDetailsInput;
}>;


export type ResourceAccessibilityQuery = { __typename?: 'Query', resourceViewScreenV2?: { __typename?: 'ResourceViewScreen', courseBlock?: { __typename?: 'CourseBlock', isAccessible?: boolean | null, userstatus?: { __typename?: 'CourseBlockUserstatus', status?: string | null } | null, resource?: { __typename?: 'Resource', type?: string | null } | null } | null } | null };

export type ResourceViewV2QueryVariables = Exact<{
  resourceDetailsInput: ResourceDetailsInput;
}>;


export type ResourceViewV2Query = { __typename?: 'Query', resourceViewScreenV2?: { __typename?: 'ResourceViewScreen', resourceUuid?: string | null, resource?: { __typename?: 'Resource', id?: string | null, uuid?: string | null, type?: string | null, subtype?: string | null, name?: string | null, content?: { __typename?: 'ResourceContentAssessment', id?: string | null, examDetails?: { __typename?: 'ResourceContentExamDetails', examTimeslotUuid?: string | null, maxAllowedSubmissions?: number | null, examItemSet?: { __typename?: 'ExamItemSet', outline?: { __typename?: 'ExamTimeslotOutline', exam?: { __typename?: 'Exam', title?: string | null, timeLimit?: number | null, sections?: Array<{ __typename?: 'ExamSection', title?: string | null, items?: Array<{ __typename?: 'ExamItem', uuid?: string | null, text?: string | null, type?: string | null, subtype?: string | null, required?: boolean | null, showResults?: boolean | null, mediaUrl?: string | null, isGraded?: boolean | null, choices?: Array<{ __typename?: 'ExamChoice', item?: string | null, uuid?: string | null, isCorrect?: boolean | null, longInput?: string | null, imageUrl?: string | null, shortInput?: string | null, audioUrl?: string | null, orderId?: number | null, createdAt?: string | null, modifiedAt?: string | null } | null> | null, draftValue?: { __typename?: 'ExamResponse', item?: string | null, longInput?: string | null, shortInput?: string | null, choices?: Array<{ __typename?: 'ExamChoice', uuid?: string | null, shortInput?: string | null, longInput?: string | null } | null> | null } | null } | null> | null } | null> | null } | null } | null, submission?: { __typename?: 'ExamSubmission', uuid?: string | null } | null } | null } | null } | { __typename?: 'ResourceContentAudio', id?: string | null, uri?: string | null, contentType?: string | null } | { __typename?: 'ResourceContentBuribookWithActivity', id?: string | null, examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, imageUri?: string | null } | null> | null } | { __typename?: 'ResourceContentBurislide', id?: string | null, examDetails?: { __typename?: 'ResourceContentExamDetails', examUuid?: string | null, examTimeslotUuid?: string | null } | null, spreads?: Array<{ __typename?: 'ResourceContentBurislideSpread', uri?: string | null, uris?: Array<string | null> | null, title?: string | null, spreadType?: string | null, leftUri?: string | null, rightUri?: string | null, imageUri?: string | null } | null> | null } | { __typename?: 'ResourceContentCasticulate', id?: string | null, casticulateUuid?: string | null } | { __typename?: 'ResourceContentCourse', id?: string | null, courseDetails?: { __typename?: 'ResourceContentCourseDetails', courseUuid?: string | null } | null } | { __typename?: 'ResourceContentEmbed', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentEpub', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentFile', id?: string | null, uri?: string | null, previewGraphicUri?: string | null } | { __typename?: 'ResourceContentLink', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentNotSupported' } | { __typename?: 'ResourceContentPdf', id?: string | null, uri?: string | null, contentType?: string | null, previewGraphicUri?: string | null } | { __typename?: 'ResourceContentText', id?: string | null, text?: string | null } | { __typename?: 'ResourceContentVideo', id?: string | null, uri?: string | null, hlsUri?: string | null, dashUri?: string | null, contentType?: string | null, videoDescription?: string | null, subtitleClass?: string | null, tracks?: Array<{ __typename?: 'ResourceContentVideoTrack', uri?: string | null } | null> | null } | { __typename?: 'ResourceContentXApi', id?: string | null, uri?: string | null } | { __typename?: 'ResourceContentYoutube', id?: string | null, uri?: string | null, videoId?: string | null } | null } | null, courseBlock?: { __typename?: 'CourseBlock', title?: string | null, isAccessible?: boolean | null, maxSubmissionsReached?: boolean | null, requiredForCertificate?: boolean | null, completeOnFinal?: boolean | null, referenceInfo?: { __typename?: 'CourseBlockReferenceInfo', referenceId?: string | null, customPassingMark?: number | null, maxAllowedSubmissions?: number | null, passOnSubmit?: boolean | null } | null, scheduleReferenceInfo?: { __typename?: 'CourseBlockScheduleReferenceInfo', referenceId?: string | null, maxAllowedSubmissions?: number | null } | null, userstatus?: { __typename?: 'CourseBlockUserstatus', status?: string | null, isComplete?: boolean | null, gradePercent?: number | null, scoreRaw?: number | null, scoreMin?: number | null, scoreMax?: number | null, submissionCount?: number | null } | null, nextBlocksJoined?: Array<{ __typename?: 'CourseBlock', title?: string | null, uuid?: string | null, coverUri?: string | null, resource?: { __typename?: 'Resource', id?: string | null } | null } | null> | null } | null } | null };

export type ScheduleBlockStatusTrainingInfoQueryVariables = Exact<{
  courseUuid: Scalars['String']['input'];
  scheduleUuid?: InputMaybe<Scalars['String']['input']>;
  courseBlockUuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScheduleBlockStatusTrainingInfoQuery = { __typename?: 'Query', courseViewScreen?: { __typename?: 'CourseViewScreen', scheduleBlockStatus?: { __typename?: 'ScheduleBlockStatus', trainingInfo?: { __typename?: 'TrainingOutline', totalPoints?: string | null, domains?: Array<{ __typename?: 'DomainOutline', uuid?: string | null, name?: string | null, description?: string | null, totalPoints?: string | null, indicators?: Array<{ __typename?: 'TrainingIndicatorPoints', name?: string | null, uuid?: string | null, displayUnitName?: string | null } | null> | null, children?: Array<{ __typename?: 'ChildDomainOutline', name?: string | null, uuid?: string | null, description?: string | null, totalPoints?: string | null, indicators?: Array<{ __typename?: 'TrainingIndicatorPoints', name?: string | null, uuid?: string | null, displayUnitName?: string | null } | null> | null } | null> | null } | null> | null } | null } | null } | null };


export const IsGuestUserDocument = gql`
    query IsGuestUser {
  accountAndUserDetailsScreen: account_and_user_details_screen {
    userProfile: user_profile {
      isGuestUser: is_guest_user
      isDeactivatedUser: is_deactivated_user
      isCastMember: is_cast_member
    }
  }
}
    `;

/**
 * __useIsGuestUserQuery__
 *
 * To run a query within a React component, call `useIsGuestUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsGuestUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsGuestUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsGuestUserQuery(baseOptions?: Apollo.QueryHookOptions<IsGuestUserQuery, IsGuestUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsGuestUserQuery, IsGuestUserQueryVariables>(IsGuestUserDocument, options);
      }
export function useIsGuestUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsGuestUserQuery, IsGuestUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsGuestUserQuery, IsGuestUserQueryVariables>(IsGuestUserDocument, options);
        }
export type IsGuestUserQueryHookResult = ReturnType<typeof useIsGuestUserQuery>;
export type IsGuestUserLazyQueryHookResult = ReturnType<typeof useIsGuestUserLazyQuery>;
export type IsGuestUserQueryResult = Apollo.QueryResult<IsGuestUserQuery, IsGuestUserQueryVariables>;
export const IdleFieldsDocument = gql`
    query IdleFields($domain: String) {
  loginScreen: login_screen(domain: $domain) {
    cast {
      attributes {
        logoutPromptAfterXSeconds: logout_prompt_after_x_seconds
        logoutAfterXSeconds: logout_after_x_seconds
      }
    }
  }
}
    `;

/**
 * __useIdleFieldsQuery__
 *
 * To run a query within a React component, call `useIdleFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdleFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdleFieldsQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useIdleFieldsQuery(baseOptions?: Apollo.QueryHookOptions<IdleFieldsQuery, IdleFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdleFieldsQuery, IdleFieldsQueryVariables>(IdleFieldsDocument, options);
      }
export function useIdleFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdleFieldsQuery, IdleFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdleFieldsQuery, IdleFieldsQueryVariables>(IdleFieldsDocument, options);
        }
export type IdleFieldsQueryHookResult = ReturnType<typeof useIdleFieldsQuery>;
export type IdleFieldsLazyQueryHookResult = ReturnType<typeof useIdleFieldsLazyQuery>;
export type IdleFieldsQueryResult = Apollo.QueryResult<IdleFieldsQuery, IdleFieldsQueryVariables>;
export const HumanizedResourceTypesDocument = gql`
    query HumanizedResourceTypes {
  humanizedResourceTypes: humanized_resource_types {
    buresource {
      resource {
        type
        subtype
      }
    }
  }
}
    `;

/**
 * __useHumanizedResourceTypesQuery__
 *
 * To run a query within a React component, call `useHumanizedResourceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHumanizedResourceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHumanizedResourceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHumanizedResourceTypesQuery(baseOptions?: Apollo.QueryHookOptions<HumanizedResourceTypesQuery, HumanizedResourceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HumanizedResourceTypesQuery, HumanizedResourceTypesQueryVariables>(HumanizedResourceTypesDocument, options);
      }
export function useHumanizedResourceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HumanizedResourceTypesQuery, HumanizedResourceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HumanizedResourceTypesQuery, HumanizedResourceTypesQueryVariables>(HumanizedResourceTypesDocument, options);
        }
export type HumanizedResourceTypesQueryHookResult = ReturnType<typeof useHumanizedResourceTypesQuery>;
export type HumanizedResourceTypesLazyQueryHookResult = ReturnType<typeof useHumanizedResourceTypesLazyQuery>;
export type HumanizedResourceTypesQueryResult = Apollo.QueryResult<HumanizedResourceTypesQuery, HumanizedResourceTypesQueryVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($forumCommentUuid: ID!) {
  courseForumCommentDelete: course_forum_comment_delete(
    forum_comment_uuid: $forumCommentUuid
  )
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      forumCommentUuid: // value for 'forumCommentUuid'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const FlagCommentDocument = gql`
    mutation FlagComment($forumCommentUuid: ID!, $isFlagged: Boolean) {
  courseForumCommentUpdate: course_forum_comment_update(
    forum_comment_uuid: $forumCommentUuid
    is_flagged: $isFlagged
  ) {
    comment {
      isFlagged: is_flagged
    }
  }
}
    `;
export type FlagCommentMutationFn = Apollo.MutationFunction<FlagCommentMutation, FlagCommentMutationVariables>;

/**
 * __useFlagCommentMutation__
 *
 * To run a mutation, you first call `useFlagCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagCommentMutation, { data, loading, error }] = useFlagCommentMutation({
 *   variables: {
 *      forumCommentUuid: // value for 'forumCommentUuid'
 *      isFlagged: // value for 'isFlagged'
 *   },
 * });
 */
export function useFlagCommentMutation(baseOptions?: Apollo.MutationHookOptions<FlagCommentMutation, FlagCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagCommentMutation, FlagCommentMutationVariables>(FlagCommentDocument, options);
      }
export type FlagCommentMutationHookResult = ReturnType<typeof useFlagCommentMutation>;
export type FlagCommentMutationResult = Apollo.MutationResult<FlagCommentMutation>;
export type FlagCommentMutationOptions = Apollo.BaseMutationOptions<FlagCommentMutation, FlagCommentMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($forumTopicUuid: ID!, $text: String!) {
  courseForumCommentCreate: course_forum_comment_create(
    forum_topic_uuid: $forumTopicUuid
    text: $text
  ) {
    comment {
      uuid
    }
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      forumTopicUuid: // value for 'forumTopicUuid'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const ResourceViewScreenCourseOutlineDocument = gql`
    query ResourceViewScreenCourseOutline($resourceUuid: ID!) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    resource {
      content {
        ... on ResourceContentCourse {
          courseDetails: course_details {
            courseUuid: course_uuid
          }
        }
      }
    }
  }
}
    `;

/**
 * __useResourceViewScreenCourseOutlineQuery__
 *
 * To run a query within a React component, call `useResourceViewScreenCourseOutlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewScreenCourseOutlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewScreenCourseOutlineQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useResourceViewScreenCourseOutlineQuery(baseOptions: Apollo.QueryHookOptions<ResourceViewScreenCourseOutlineQuery, ResourceViewScreenCourseOutlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewScreenCourseOutlineQuery, ResourceViewScreenCourseOutlineQueryVariables>(ResourceViewScreenCourseOutlineDocument, options);
      }
export function useResourceViewScreenCourseOutlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewScreenCourseOutlineQuery, ResourceViewScreenCourseOutlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewScreenCourseOutlineQuery, ResourceViewScreenCourseOutlineQueryVariables>(ResourceViewScreenCourseOutlineDocument, options);
        }
export type ResourceViewScreenCourseOutlineQueryHookResult = ReturnType<typeof useResourceViewScreenCourseOutlineQuery>;
export type ResourceViewScreenCourseOutlineLazyQueryHookResult = ReturnType<typeof useResourceViewScreenCourseOutlineLazyQuery>;
export type ResourceViewScreenCourseOutlineQueryResult = Apollo.QueryResult<ResourceViewScreenCourseOutlineQuery, ResourceViewScreenCourseOutlineQueryVariables>;
export const CourseDocument = gql`
    query Course($courseUuid: String!) {
  course_view_screen(course_uuid: $courseUuid) {
    course {
      id
      outline {
        blocks {
          resource {
            type
            uuid
            name
          }
        }
      }
      is_enrolled
      allowed_actions
    }
  }
}
    `;

/**
 * __useCourseQuery__
 *
 * To run a query within a React component, call `useCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *   },
 * });
 */
export function useCourseQuery(baseOptions: Apollo.QueryHookOptions<CourseQuery, CourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
      }
export function useCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseQuery, CourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseQuery, CourseQueryVariables>(CourseDocument, options);
        }
export type CourseQueryHookResult = ReturnType<typeof useCourseQuery>;
export type CourseLazyQueryHookResult = ReturnType<typeof useCourseLazyQuery>;
export type CourseQueryResult = Apollo.QueryResult<CourseQuery, CourseQueryVariables>;
export const CatalogListScreenForBlockDocument = gql`
    query CatalogListScreenForBlock($castBlockId: String!) {
  catalogListScreen: catalog_list_screen(cast_block_id: $castBlockId) {
    id
    castBlock: cast_block {
      id
      attributes {
        type
        properties {
          ... on CastBlockPropertiesCatalog {
            id
            uuid
            resourceCollection: resource_collection {
              id
              uuid
              name
            }
            resources {
              id
              uuid
              name
              type
              subtype
              description
              coverUri: cover_uri
              content {
                ... on ResourceContentCourse {
                  id
                  courseDetails: course_details {
                    course {
                      allowedActions: allowed_actions
                      uuid
                      isEnrolled: is_enrolled
                      enrolledSchedules: enrolled_schedules {
                        isActive: is_active
                        name
                        uuid
                        status
                      }
                    }
                  }
                }
                ... on ResourceContentVideo {
                  id
                }
                ... on ResourceContentPdf {
                  id
                }
                ... on ResourceContentEpub {
                  id
                }
                ... on ResourceContentBurislide {
                  id
                }
                ... on ResourceContentBuribookWithActivity {
                  id
                }
              }
            }
            appearance {
              id
              base {
                backgroundImage: background_image
                fontFamily: font_family
                backgroundColor: background_color {
                  alpha
                  blue
                  green
                  red
                }
                foregroundColor: foreground_color {
                  alpha
                  blue
                  green
                  red
                }
              }
              cardHeader: card_header {
                foregroundColor: foreground_color {
                  alpha
                  blue
                  green
                  red
                }
                backgroundColor: background_color {
                  alpha
                  blue
                  green
                  red
                }
                backgroundImage: background_image
                fontFamily: font_family
              }
            }
            limit
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCatalogListScreenForBlockQuery__
 *
 * To run a query within a React component, call `useCatalogListScreenForBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogListScreenForBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogListScreenForBlockQuery({
 *   variables: {
 *      castBlockId: // value for 'castBlockId'
 *   },
 * });
 */
export function useCatalogListScreenForBlockQuery(baseOptions: Apollo.QueryHookOptions<CatalogListScreenForBlockQuery, CatalogListScreenForBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogListScreenForBlockQuery, CatalogListScreenForBlockQueryVariables>(CatalogListScreenForBlockDocument, options);
      }
export function useCatalogListScreenForBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogListScreenForBlockQuery, CatalogListScreenForBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogListScreenForBlockQuery, CatalogListScreenForBlockQueryVariables>(CatalogListScreenForBlockDocument, options);
        }
export type CatalogListScreenForBlockQueryHookResult = ReturnType<typeof useCatalogListScreenForBlockQuery>;
export type CatalogListScreenForBlockLazyQueryHookResult = ReturnType<typeof useCatalogListScreenForBlockLazyQuery>;
export type CatalogListScreenForBlockQueryResult = Apollo.QueryResult<CatalogListScreenForBlockQuery, CatalogListScreenForBlockQueryVariables>;
export const EnrolledSchedulesDocument = gql`
    query EnrolledSchedules($courseUuid: String!) {
  courseViewScreen: course_view_screen(course_uuid: $courseUuid) {
    course {
      enrolledSchedules: enrolled_schedules {
        uuid
        name
        start
        end
        status
      }
    }
  }
}
    `;

/**
 * __useEnrolledSchedulesQuery__
 *
 * To run a query within a React component, call `useEnrolledSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrolledSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrolledSchedulesQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *   },
 * });
 */
export function useEnrolledSchedulesQuery(baseOptions: Apollo.QueryHookOptions<EnrolledSchedulesQuery, EnrolledSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrolledSchedulesQuery, EnrolledSchedulesQueryVariables>(EnrolledSchedulesDocument, options);
      }
export function useEnrolledSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrolledSchedulesQuery, EnrolledSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrolledSchedulesQuery, EnrolledSchedulesQueryVariables>(EnrolledSchedulesDocument, options);
        }
export type EnrolledSchedulesQueryHookResult = ReturnType<typeof useEnrolledSchedulesQuery>;
export type EnrolledSchedulesLazyQueryHookResult = ReturnType<typeof useEnrolledSchedulesLazyQuery>;
export type EnrolledSchedulesQueryResult = Apollo.QueryResult<EnrolledSchedulesQuery, EnrolledSchedulesQueryVariables>;
export const GetCourseProgressDocument = gql`
    query GetCourseProgress($courseUuid: String!, $scheduleUuid: String) {
  courseViewScreen: course_view_screen(
    course_uuid: $courseUuid
    schedule_uuid: $scheduleUuid
  ) {
    courseProgressValue: course_progress_value
  }
}
    `;

/**
 * __useGetCourseProgressQuery__
 *
 * To run a query within a React component, call `useGetCourseProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseProgressQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *      scheduleUuid: // value for 'scheduleUuid'
 *   },
 * });
 */
export function useGetCourseProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseProgressQuery, GetCourseProgressQueryVariables>(GetCourseProgressDocument, options);
      }
export function useGetCourseProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseProgressQuery, GetCourseProgressQueryVariables>(GetCourseProgressDocument, options);
        }
export type GetCourseProgressQueryHookResult = ReturnType<typeof useGetCourseProgressQuery>;
export type GetCourseProgressLazyQueryHookResult = ReturnType<typeof useGetCourseProgressLazyQuery>;
export type GetCourseProgressQueryResult = Apollo.QueryResult<GetCourseProgressQuery, GetCourseProgressQueryVariables>;
export const Checkout_CreateDocument = gql`
    mutation Checkout_create($productId: Int!, $callbackUrl: String) {
  checkoutCreate: checkout_create(
    product_id: $productId
    callback_url: $callbackUrl
  ) {
    checkoutToken: checkout_token {
      checkoutUrl: checkout_url
      userId: user_id
      validUntil: valid_until
    }
  }
}
    `;
export type Checkout_CreateMutationFn = Apollo.MutationFunction<Checkout_CreateMutation, Checkout_CreateMutationVariables>;

/**
 * __useCheckout_CreateMutation__
 *
 * To run a mutation, you first call `useCheckout_CreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckout_CreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCreateMutation, { data, loading, error }] = useCheckout_CreateMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      callbackUrl: // value for 'callbackUrl'
 *   },
 * });
 */
export function useCheckout_CreateMutation(baseOptions?: Apollo.MutationHookOptions<Checkout_CreateMutation, Checkout_CreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Checkout_CreateMutation, Checkout_CreateMutationVariables>(Checkout_CreateDocument, options);
      }
export type Checkout_CreateMutationHookResult = ReturnType<typeof useCheckout_CreateMutation>;
export type Checkout_CreateMutationResult = Apollo.MutationResult<Checkout_CreateMutation>;
export type Checkout_CreateMutationOptions = Apollo.BaseMutationOptions<Checkout_CreateMutation, Checkout_CreateMutationVariables>;
export const CommentsListDocument = gql`
    query CommentsList($courseUuid: String!, $forumTopicUuid: ID) {
  courseViewScreen: course_view_screen(course_uuid: $courseUuid) {
    forumTopic: forum_topic(forum_topic_uuid: $forumTopicUuid) {
      comments {
        uuid
        created
        text
        isFlagged: is_flagged
        isUserModerator: is_user_moderator
        createdBy: created_by_user_details {
          firstName: first_name
          lastName: last_name
        }
      }
    }
  }
}
    `;

/**
 * __useCommentsListQuery__
 *
 * To run a query within a React component, call `useCommentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsListQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *      forumTopicUuid: // value for 'forumTopicUuid'
 *   },
 * });
 */
export function useCommentsListQuery(baseOptions: Apollo.QueryHookOptions<CommentsListQuery, CommentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsListQuery, CommentsListQueryVariables>(CommentsListDocument, options);
      }
export function useCommentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsListQuery, CommentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsListQuery, CommentsListQueryVariables>(CommentsListDocument, options);
        }
export type CommentsListQueryHookResult = ReturnType<typeof useCommentsListQuery>;
export type CommentsListLazyQueryHookResult = ReturnType<typeof useCommentsListLazyQuery>;
export type CommentsListQueryResult = Apollo.QueryResult<CommentsListQuery, CommentsListQueryVariables>;
export const ResourceViewScreenForModalsDocument = gql`
    query resourceViewScreenForModals($resourceDetailsInput: ResourceDetailsInput!) {
  resourceViewScreen: resource_view_screen_v2(
    resource_details_input: $resourceDetailsInput
  ) {
    resourceUuid: resource_uuid
    resource {
      id
      uuid
      type
      subtype
      name
    }
    courseBlock: course_block {
      uuid
      title
      maxSubmissionsReached: max_submissions_reached
      openDate: open_date
      isAccessible: is_accessible
      referenceInfo: reference_info {
        referenceId: reference_id
        customPassingMark: custom_passing_mark
        maxAllowedSubmissions: max_allowed_submissions
        passOnSubmit: pass_on_submit
      }
      scheduleReferenceInfo: schedule_reference_info {
        referenceId: reference_id
        maxAllowedSubmissions: max_allowed_submissions
        openDate: open_date
      }
    }
  }
}
    `;

/**
 * __useResourceViewScreenForModalsQuery__
 *
 * To run a query within a React component, call `useResourceViewScreenForModalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewScreenForModalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewScreenForModalsQuery({
 *   variables: {
 *      resourceDetailsInput: // value for 'resourceDetailsInput'
 *   },
 * });
 */
export function useResourceViewScreenForModalsQuery(baseOptions: Apollo.QueryHookOptions<ResourceViewScreenForModalsQuery, ResourceViewScreenForModalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewScreenForModalsQuery, ResourceViewScreenForModalsQueryVariables>(ResourceViewScreenForModalsDocument, options);
      }
export function useResourceViewScreenForModalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewScreenForModalsQuery, ResourceViewScreenForModalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewScreenForModalsQuery, ResourceViewScreenForModalsQueryVariables>(ResourceViewScreenForModalsDocument, options);
        }
export type ResourceViewScreenForModalsQueryHookResult = ReturnType<typeof useResourceViewScreenForModalsQuery>;
export type ResourceViewScreenForModalsLazyQueryHookResult = ReturnType<typeof useResourceViewScreenForModalsLazyQuery>;
export type ResourceViewScreenForModalsQueryResult = Apollo.QueryResult<ResourceViewScreenForModalsQuery, ResourceViewScreenForModalsQueryVariables>;
export const CourseCardOutlineDocument = gql`
    query CourseCardOutline($resourceUuid: ID!) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    resource {
      content {
        ... on ResourceContentCourse {
          courseDetails: course_details {
            courseUuid: course_uuid
            course {
              enrolledSchedules: enrolled_schedules {
                isActive: is_active
                status
                name
                uuid
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCourseCardOutlineQuery__
 *
 * To run a query within a React component, call `useCourseCardOutlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseCardOutlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseCardOutlineQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useCourseCardOutlineQuery(baseOptions: Apollo.QueryHookOptions<CourseCardOutlineQuery, CourseCardOutlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseCardOutlineQuery, CourseCardOutlineQueryVariables>(CourseCardOutlineDocument, options);
      }
export function useCourseCardOutlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseCardOutlineQuery, CourseCardOutlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseCardOutlineQuery, CourseCardOutlineQueryVariables>(CourseCardOutlineDocument, options);
        }
export type CourseCardOutlineQueryHookResult = ReturnType<typeof useCourseCardOutlineQuery>;
export type CourseCardOutlineLazyQueryHookResult = ReturnType<typeof useCourseCardOutlineLazyQuery>;
export type CourseCardOutlineQueryResult = Apollo.QueryResult<CourseCardOutlineQuery, CourseCardOutlineQueryVariables>;
export const ResourceViewScreenCourseCardChooseBatchDocument = gql`
    query ResourceViewScreenCourseCardChooseBatch($resourceUuid: ID!) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    resource {
      content {
        ... on ResourceContentCourse {
          courseDetails: course_details {
            courseUuid: course_uuid
          }
        }
      }
    }
  }
}
    `;

/**
 * __useResourceViewScreenCourseCardChooseBatchQuery__
 *
 * To run a query within a React component, call `useResourceViewScreenCourseCardChooseBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewScreenCourseCardChooseBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewScreenCourseCardChooseBatchQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useResourceViewScreenCourseCardChooseBatchQuery(baseOptions: Apollo.QueryHookOptions<ResourceViewScreenCourseCardChooseBatchQuery, ResourceViewScreenCourseCardChooseBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewScreenCourseCardChooseBatchQuery, ResourceViewScreenCourseCardChooseBatchQueryVariables>(ResourceViewScreenCourseCardChooseBatchDocument, options);
      }
export function useResourceViewScreenCourseCardChooseBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewScreenCourseCardChooseBatchQuery, ResourceViewScreenCourseCardChooseBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewScreenCourseCardChooseBatchQuery, ResourceViewScreenCourseCardChooseBatchQueryVariables>(ResourceViewScreenCourseCardChooseBatchDocument, options);
        }
export type ResourceViewScreenCourseCardChooseBatchQueryHookResult = ReturnType<typeof useResourceViewScreenCourseCardChooseBatchQuery>;
export type ResourceViewScreenCourseCardChooseBatchLazyQueryHookResult = ReturnType<typeof useResourceViewScreenCourseCardChooseBatchLazyQuery>;
export type ResourceViewScreenCourseCardChooseBatchQueryResult = Apollo.QueryResult<ResourceViewScreenCourseCardChooseBatchQuery, ResourceViewScreenCourseCardChooseBatchQueryVariables>;
export const Self_EnrollDocument = gql`
    mutation Self_enroll($courseScheduleUuid: String!) {
  self_enroll(course_schedule_uuid: $courseScheduleUuid)
}
    `;
export type Self_EnrollMutationFn = Apollo.MutationFunction<Self_EnrollMutation, Self_EnrollMutationVariables>;

/**
 * __useSelf_EnrollMutation__
 *
 * To run a mutation, you first call `useSelf_EnrollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelf_EnrollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfEnrollMutation, { data, loading, error }] = useSelf_EnrollMutation({
 *   variables: {
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useSelf_EnrollMutation(baseOptions?: Apollo.MutationHookOptions<Self_EnrollMutation, Self_EnrollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Self_EnrollMutation, Self_EnrollMutationVariables>(Self_EnrollDocument, options);
      }
export type Self_EnrollMutationHookResult = ReturnType<typeof useSelf_EnrollMutation>;
export type Self_EnrollMutationResult = Apollo.MutationResult<Self_EnrollMutation>;
export type Self_EnrollMutationOptions = Apollo.BaseMutationOptions<Self_EnrollMutation, Self_EnrollMutationVariables>;
export const SelfEnrollSchedulesDocument = gql`
    query SelfEnrollSchedules($courseUuid: String!) {
  courseViewScreen: course_view_screen(course_uuid: $courseUuid) {
    course {
      selfEnrollSchedules: self_enroll_schedules {
        uuid
        start
        end
        name
        isActive: is_active
      }
    }
  }
}
    `;

/**
 * __useSelfEnrollSchedulesQuery__
 *
 * To run a query within a React component, call `useSelfEnrollSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfEnrollSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfEnrollSchedulesQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *   },
 * });
 */
export function useSelfEnrollSchedulesQuery(baseOptions: Apollo.QueryHookOptions<SelfEnrollSchedulesQuery, SelfEnrollSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfEnrollSchedulesQuery, SelfEnrollSchedulesQueryVariables>(SelfEnrollSchedulesDocument, options);
      }
export function useSelfEnrollSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfEnrollSchedulesQuery, SelfEnrollSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfEnrollSchedulesQuery, SelfEnrollSchedulesQueryVariables>(SelfEnrollSchedulesDocument, options);
        }
export type SelfEnrollSchedulesQueryHookResult = ReturnType<typeof useSelfEnrollSchedulesQuery>;
export type SelfEnrollSchedulesLazyQueryHookResult = ReturnType<typeof useSelfEnrollSchedulesLazyQuery>;
export type SelfEnrollSchedulesQueryResult = Apollo.QueryResult<SelfEnrollSchedulesQuery, SelfEnrollSchedulesQueryVariables>;
export const FaviconDocument = gql`
    query Favicon {
  browserTitleBar: browser_title_bar {
    faviconUri: favicon_uri
    title
    pwa {
      icon192: icon_192
      icon512: icon_512
    }
  }
}
    `;

/**
 * __useFaviconQuery__
 *
 * To run a query within a React component, call `useFaviconQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaviconQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaviconQuery({
 *   variables: {
 *   },
 * });
 */
export function useFaviconQuery(baseOptions?: Apollo.QueryHookOptions<FaviconQuery, FaviconQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaviconQuery, FaviconQueryVariables>(FaviconDocument, options);
      }
export function useFaviconLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaviconQuery, FaviconQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaviconQuery, FaviconQueryVariables>(FaviconDocument, options);
        }
export type FaviconQueryHookResult = ReturnType<typeof useFaviconQuery>;
export type FaviconLazyQueryHookResult = ReturnType<typeof useFaviconLazyQuery>;
export type FaviconQueryResult = Apollo.QueryResult<FaviconQuery, FaviconQueryVariables>;
export const ForumBarDocument = gql`
    query ForumBar($courseUuid: String!) {
  courseViewScreen: course_view_screen(course_uuid: $courseUuid) {
    forumTopicsCount: forum_topics_count
    forumTopics: forum_topics {
      isActive: is_active
    }
  }
}
    `;

/**
 * __useForumBarQuery__
 *
 * To run a query within a React component, call `useForumBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useForumBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForumBarQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *   },
 * });
 */
export function useForumBarQuery(baseOptions: Apollo.QueryHookOptions<ForumBarQuery, ForumBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForumBarQuery, ForumBarQueryVariables>(ForumBarDocument, options);
      }
export function useForumBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForumBarQuery, ForumBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForumBarQuery, ForumBarQueryVariables>(ForumBarDocument, options);
        }
export type ForumBarQueryHookResult = ReturnType<typeof useForumBarQuery>;
export type ForumBarLazyQueryHookResult = ReturnType<typeof useForumBarLazyQuery>;
export type ForumBarQueryResult = Apollo.QueryResult<ForumBarQuery, ForumBarQueryVariables>;
export const ForumTopicCreateDocument = gql`
    mutation ForumTopicCreate($input: CourseForumTopicInput!) {
  courseForumTopicCreate: course_forum_topic_create(input: $input) {
    topic {
      title
      text
      isActive: is_active
    }
  }
}
    `;
export type ForumTopicCreateMutationFn = Apollo.MutationFunction<ForumTopicCreateMutation, ForumTopicCreateMutationVariables>;

/**
 * __useForumTopicCreateMutation__
 *
 * To run a mutation, you first call `useForumTopicCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForumTopicCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forumTopicCreateMutation, { data, loading, error }] = useForumTopicCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForumTopicCreateMutation(baseOptions?: Apollo.MutationHookOptions<ForumTopicCreateMutation, ForumTopicCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForumTopicCreateMutation, ForumTopicCreateMutationVariables>(ForumTopicCreateDocument, options);
      }
export type ForumTopicCreateMutationHookResult = ReturnType<typeof useForumTopicCreateMutation>;
export type ForumTopicCreateMutationResult = Apollo.MutationResult<ForumTopicCreateMutation>;
export type ForumTopicCreateMutationOptions = Apollo.BaseMutationOptions<ForumTopicCreateMutation, ForumTopicCreateMutationVariables>;
export const ResourceDownloadDocument = gql`
    query ResourceDownload($resourceUuid: ID!) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    resource {
      id
      type
      content {
        ... on ResourceContentVideo {
          id
          uri
          hlsUri: hls_uri
          dashUri: dash_uri
          tracks {
            uri
          }
        }
        ... on ResourceContentBuribookWithActivity {
          id
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            uris
            imageUri: image_uri
            title
          }
        }
        ... on ResourceContentBurislide {
          id
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            uris
            imageUri: image_uri
            title
          }
        }
        ... on ResourceContentAudio {
          id
          uri
        }
        ... on ResourceContentEpub {
          id
          uri
        }
        ... on ResourceContentFile {
          id
          uri
        }
        ... on ResourceContentPdf {
          id
          uri
        }
      }
    }
  }
}
    `;

/**
 * __useResourceDownloadQuery__
 *
 * To run a query within a React component, call `useResourceDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceDownloadQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useResourceDownloadQuery(baseOptions: Apollo.QueryHookOptions<ResourceDownloadQuery, ResourceDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceDownloadQuery, ResourceDownloadQueryVariables>(ResourceDownloadDocument, options);
      }
export function useResourceDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceDownloadQuery, ResourceDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceDownloadQuery, ResourceDownloadQueryVariables>(ResourceDownloadDocument, options);
        }
export type ResourceDownloadQueryHookResult = ReturnType<typeof useResourceDownloadQuery>;
export type ResourceDownloadLazyQueryHookResult = ReturnType<typeof useResourceDownloadLazyQuery>;
export type ResourceDownloadQueryResult = Apollo.QueryResult<ResourceDownloadQuery, ResourceDownloadQueryVariables>;
export const NavbarDocument = gql`
    query Navbar {
  navbar {
    navAppearance: nav_appearance {
      base {
        foregroundColor: foreground_color {
          alpha
          blue
          green
          red
        }
        backgroundColor: background_color {
          alpha
          blue
          green
          red
        }
        backgroundImage: background_image
        fontFamily: font_family
      }
      item {
        foregroundColor: foreground_color {
          alpha
          blue
          green
          red
        }
        backgroundColor: background_color {
          alpha
          blue
          green
          red
        }
        backgroundImage: background_image
        fontFamily: font_family
      }
      itemActive: item_active {
        foregroundColor: foreground_color {
          alpha
          blue
          green
          red
        }
        backgroundColor: background_color {
          alpha
          blue
          green
          red
        }
        backgroundImage: background_image
        fontFamily: font_family
      }
    }
    navLogoUrl: nav_logo_url
    navScreenItems: nav_screen_items {
      screenId: screen_id
      slug
      title
      icon {
        material
      }
      isHidden: is_hidden
    }
    profileIconUrl: profile_icon_url
    userInfo: user_info {
      userId: user_id
      firstName: first_name
      lastName: last_name
      email
    }
    searchSlug: search_slug
  }
}
    `;

/**
 * __useNavbarQuery__
 *
 * To run a query within a React component, call `useNavbarQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavbarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavbarQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavbarQuery(baseOptions?: Apollo.QueryHookOptions<NavbarQuery, NavbarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavbarQuery, NavbarQueryVariables>(NavbarDocument, options);
      }
export function useNavbarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavbarQuery, NavbarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavbarQuery, NavbarQueryVariables>(NavbarDocument, options);
        }
export type NavbarQueryHookResult = ReturnType<typeof useNavbarQuery>;
export type NavbarLazyQueryHookResult = ReturnType<typeof useNavbarLazyQuery>;
export type NavbarQueryResult = Apollo.QueryResult<NavbarQuery, NavbarQueryVariables>;
export const ResourceViewScreenPrerequisitesDocument = gql`
    query ResourceViewScreenPrerequisites($resourceUuid: ID!, $courseBlockUuid: String) {
  resourceViewScreen: resource_view_screen(
    resource_uuid: $resourceUuid
    course_block_uuid: $courseBlockUuid
  ) {
    courseBlock: course_block {
      prerequisitesCourseBlocks: prerequisites_course_blocks {
        uuid
        title
        coverUri: cover_uri
        resource {
          uuid
          name
          type
          subtype
          coverUri: cover_uri
        }
      }
    }
  }
}
    `;

/**
 * __useResourceViewScreenPrerequisitesQuery__
 *
 * To run a query within a React component, call `useResourceViewScreenPrerequisitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewScreenPrerequisitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewScreenPrerequisitesQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *      courseBlockUuid: // value for 'courseBlockUuid'
 *   },
 * });
 */
export function useResourceViewScreenPrerequisitesQuery(baseOptions: Apollo.QueryHookOptions<ResourceViewScreenPrerequisitesQuery, ResourceViewScreenPrerequisitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewScreenPrerequisitesQuery, ResourceViewScreenPrerequisitesQueryVariables>(ResourceViewScreenPrerequisitesDocument, options);
      }
export function useResourceViewScreenPrerequisitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewScreenPrerequisitesQuery, ResourceViewScreenPrerequisitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewScreenPrerequisitesQuery, ResourceViewScreenPrerequisitesQueryVariables>(ResourceViewScreenPrerequisitesDocument, options);
        }
export type ResourceViewScreenPrerequisitesQueryHookResult = ReturnType<typeof useResourceViewScreenPrerequisitesQuery>;
export type ResourceViewScreenPrerequisitesLazyQueryHookResult = ReturnType<typeof useResourceViewScreenPrerequisitesLazyQuery>;
export type ResourceViewScreenPrerequisitesQueryResult = Apollo.QueryResult<ResourceViewScreenPrerequisitesQuery, ResourceViewScreenPrerequisitesQueryVariables>;
export const Course_View_ScreenDocument = gql`
    query Course_view_screen($courseUuid: String!) {
  courseViewScreen: course_view_screen(course_uuid: $courseUuid) {
    course {
      id
      coverUri: cover_uri
      description
      title
    }
  }
}
    `;

/**
 * __useCourse_View_ScreenQuery__
 *
 * To run a query within a React component, call `useCourse_View_ScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourse_View_ScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourse_View_ScreenQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *   },
 * });
 */
export function useCourse_View_ScreenQuery(baseOptions: Apollo.QueryHookOptions<Course_View_ScreenQuery, Course_View_ScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Course_View_ScreenQuery, Course_View_ScreenQueryVariables>(Course_View_ScreenDocument, options);
      }
export function useCourse_View_ScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Course_View_ScreenQuery, Course_View_ScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Course_View_ScreenQuery, Course_View_ScreenQueryVariables>(Course_View_ScreenDocument, options);
        }
export type Course_View_ScreenQueryHookResult = ReturnType<typeof useCourse_View_ScreenQuery>;
export type Course_View_ScreenLazyQueryHookResult = ReturnType<typeof useCourse_View_ScreenLazyQuery>;
export type Course_View_ScreenQueryResult = Apollo.QueryResult<Course_View_ScreenQuery, Course_View_ScreenQueryVariables>;
export const Resource_View_ScreenDocument = gql`
    query Resource_view_screen($resourceUuid: ID!) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    resource {
      id
      coverUri: cover_uri
      description
      name
      type
    }
  }
}
    `;

/**
 * __useResource_View_ScreenQuery__
 *
 * To run a query within a React component, call `useResource_View_ScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useResource_View_ScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResource_View_ScreenQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useResource_View_ScreenQuery(baseOptions: Apollo.QueryHookOptions<Resource_View_ScreenQuery, Resource_View_ScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Resource_View_ScreenQuery, Resource_View_ScreenQueryVariables>(Resource_View_ScreenDocument, options);
      }
export function useResource_View_ScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Resource_View_ScreenQuery, Resource_View_ScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Resource_View_ScreenQuery, Resource_View_ScreenQueryVariables>(Resource_View_ScreenDocument, options);
        }
export type Resource_View_ScreenQueryHookResult = ReturnType<typeof useResource_View_ScreenQuery>;
export type Resource_View_ScreenLazyQueryHookResult = ReturnType<typeof useResource_View_ScreenLazyQuery>;
export type Resource_View_ScreenQueryResult = Apollo.QueryResult<Resource_View_ScreenQuery, Resource_View_ScreenQueryVariables>;
export const ResultSlideDocument = gql`
    query ResultSlide($examSectionUuid: ID!, $examSubmissionUuid: ID!, $resourceUuid: ID!, $resourceSpreadIndex: Int) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    sectionResult: section_result(
      exam_section_uuid: $examSectionUuid
      exam_submission_uuid: $examSubmissionUuid
    ) {
      scoreRaw: score_raw
      scoreMax: score_max
      spreadResultDetails: spread_result_details(
        resource_spread_index: $resourceSpreadIndex
      ) {
        resultPageImageUri: result_page_image_uri
        resultPageText: result_page_text
      }
    }
  }
}
    `;

/**
 * __useResultSlideQuery__
 *
 * To run a query within a React component, call `useResultSlideQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultSlideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResultSlideQuery({
 *   variables: {
 *      examSectionUuid: // value for 'examSectionUuid'
 *      examSubmissionUuid: // value for 'examSubmissionUuid'
 *      resourceUuid: // value for 'resourceUuid'
 *      resourceSpreadIndex: // value for 'resourceSpreadIndex'
 *   },
 * });
 */
export function useResultSlideQuery(baseOptions: Apollo.QueryHookOptions<ResultSlideQuery, ResultSlideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResultSlideQuery, ResultSlideQueryVariables>(ResultSlideDocument, options);
      }
export function useResultSlideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResultSlideQuery, ResultSlideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResultSlideQuery, ResultSlideQueryVariables>(ResultSlideDocument, options);
        }
export type ResultSlideQueryHookResult = ReturnType<typeof useResultSlideQuery>;
export type ResultSlideLazyQueryHookResult = ReturnType<typeof useResultSlideLazyQuery>;
export type ResultSlideQueryResult = Apollo.QueryResult<ResultSlideQuery, ResultSlideQueryVariables>;
export const AssessmentSubmitV2Document = gql`
    mutation AssessmentSubmitV2($updatedSubmission: ExamSubmissionInputV2!, $submissionUuid: String!, $blockUuid: String, $courseScheduleUuid: String) {
  assessmentSubmitUpdateV2: assessment_submit_update_v2(
    updated_submission: $updatedSubmission
    submission_uuid: $submissionUuid
    block_uuid: $blockUuid
    course_schedule_uuid: $courseScheduleUuid
  ) {
    submissionResult: submission_result {
      totalScore: total_score
      final
      status
      responses {
        uuid
        item
        isResponseCorrect: is_response_correct
        choices {
          item
          isCorrect: is_correct
          longInput: long_input
          mediaUrl: media_url
          shortInput: short_input
          imageUrl: image_url
          audioUrl: audio_url
        }
        longInput: long_input
        shortInput: short_input
        showGrade: show_grade
        feedbackMessage: feedback_message
        feedbackImageUrl: feedback_image_url
        pollResults: poll_results {
          choice {
            uuid
            longInput: long_input
            shortInput: short_input
            mediaUrl: media_url
          }
          result {
            count
            percent
          }
        }
        freedomWallResponses: freedom_wall_responses {
          userDetails: user_details {
            firstName: first_name
            lastName: last_name
            profileIconUrl: profile_icon_url
          }
          uuid
          longInput: long_input
          shortInput: short_input
        }
        tallyResults: tally_results {
          type {
            uuid
            name
          }
          score
        }
        shortAnswerKey: short_answer_key
      }
      submissionCount: submission_count
      highestPossibleSubmissionScore: highest_possible_submission_score
      totalItemLimit: total_item_limit
      responsesCount: responses_count
    }
    courseBlockSubmissionResult: course_block_submission_result {
      totalScore: total_score
      status
      final
      highestPossibleSubmissionScore: highest_possible_submission_score
      totalItemLimit: total_item_limit
      responsesCount: responses_count
      responses {
        uuid
        item
        isResponseCorrect: is_response_correct
        longInput: long_input
        shortInput: short_input
        showGrade: show_grade
        feedbackMessage: feedback_message
        feedbackImageUrl: feedback_image_url
        pollResults: poll_results {
          choice {
            uuid
            longInput: long_input
            shortInput: short_input
            mediaUrl: media_url
          }
          result {
            count
            percent
          }
        }
        freedomWallResponses: freedom_wall_responses {
          userDetails: user_details {
            firstName: first_name
            lastName: last_name
            profileIconUrl: profile_icon_url
          }
          uuid
          longInput: long_input
          shortInput: short_input
        }
        tallyResults: tally_results {
          type {
            uuid
            name
          }
          score
        }
        choices {
          item
          isCorrect: is_correct
          longInput: long_input
          mediaUrl: media_url
          shortInput: short_input
          imageUrl: image_url
          audioUrl: audio_url
        }
        shortAnswerKey: short_answer_key
      }
      submissionCount: submission_count
      blockStatus: block_status {
        scoreMax: score_max
      }
    }
  }
}
    `;
export type AssessmentSubmitV2MutationFn = Apollo.MutationFunction<AssessmentSubmitV2Mutation, AssessmentSubmitV2MutationVariables>;

/**
 * __useAssessmentSubmitV2Mutation__
 *
 * To run a mutation, you first call `useAssessmentSubmitV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSubmitV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assessmentSubmitV2Mutation, { data, loading, error }] = useAssessmentSubmitV2Mutation({
 *   variables: {
 *      updatedSubmission: // value for 'updatedSubmission'
 *      submissionUuid: // value for 'submissionUuid'
 *      blockUuid: // value for 'blockUuid'
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useAssessmentSubmitV2Mutation(baseOptions?: Apollo.MutationHookOptions<AssessmentSubmitV2Mutation, AssessmentSubmitV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssessmentSubmitV2Mutation, AssessmentSubmitV2MutationVariables>(AssessmentSubmitV2Document, options);
      }
export type AssessmentSubmitV2MutationHookResult = ReturnType<typeof useAssessmentSubmitV2Mutation>;
export type AssessmentSubmitV2MutationResult = Apollo.MutationResult<AssessmentSubmitV2Mutation>;
export type AssessmentSubmitV2MutationOptions = Apollo.BaseMutationOptions<AssessmentSubmitV2Mutation, AssessmentSubmitV2MutationVariables>;
export const TimeChancesV2Document = gql`
    query TimeChancesV2($resourceDetailsInput: ResourceDetailsInput!) {
  resourceViewScreenV2: resource_view_screen_v2(
    resource_details_input: $resourceDetailsInput
  ) {
    courseBlock: course_block {
      title
      referenceInfo: reference_info {
        referenceId: reference_id
        customPassingMark: custom_passing_mark
        maxAllowedSubmissions: max_allowed_submissions
        passOnSubmit: pass_on_submit
      }
      scheduleReferenceInfo: schedule_reference_info {
        referenceId: reference_id
        maxAllowedSubmissions: max_allowed_submissions
      }
      userstatus {
        isComplete: is_complete
        status
        gradePercent: grade_percent
        scoreMax: score_max
        scoreRaw: score_raw
        submissionCount: submission_count
        submissionStatus: submission_status
      }
      maxSubmissionsReached: max_submissions_reached
      requiredForCertificate: required_for_certificate
    }
    resource {
      type
      subtype
      content {
        ... on ResourceContentAssessment {
          examTimeslot: exam_timeslot {
            outline {
              exam {
                timeLimit: time_limit
                highestPossibleScore: highest_possible_score
              }
            }
            userSubmissions: user_submissions {
              final {
                submissions {
                  totalScore: total_score
                  highestPossibleSubmissionScore: highest_possible_submission_score
                }
                count
              }
              totalCount: total_count
            }
            lastSubmissionStatus: last_submission_status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTimeChancesV2Query__
 *
 * To run a query within a React component, call `useTimeChancesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useTimeChancesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeChancesV2Query({
 *   variables: {
 *      resourceDetailsInput: // value for 'resourceDetailsInput'
 *   },
 * });
 */
export function useTimeChancesV2Query(baseOptions: Apollo.QueryHookOptions<TimeChancesV2Query, TimeChancesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeChancesV2Query, TimeChancesV2QueryVariables>(TimeChancesV2Document, options);
      }
export function useTimeChancesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeChancesV2Query, TimeChancesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeChancesV2Query, TimeChancesV2QueryVariables>(TimeChancesV2Document, options);
        }
export type TimeChancesV2QueryHookResult = ReturnType<typeof useTimeChancesV2Query>;
export type TimeChancesV2LazyQueryHookResult = ReturnType<typeof useTimeChancesV2LazyQuery>;
export type TimeChancesV2QueryResult = Apollo.QueryResult<TimeChancesV2Query, TimeChancesV2QueryVariables>;
export const DeleteForumTopicDocument = gql`
    mutation DeleteForumTopic($forumTopicUuid: ID!) {
  course_forum_topic_delete(forum_topic_uuid: $forumTopicUuid)
}
    `;
export type DeleteForumTopicMutationFn = Apollo.MutationFunction<DeleteForumTopicMutation, DeleteForumTopicMutationVariables>;

/**
 * __useDeleteForumTopicMutation__
 *
 * To run a mutation, you first call `useDeleteForumTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForumTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForumTopicMutation, { data, loading, error }] = useDeleteForumTopicMutation({
 *   variables: {
 *      forumTopicUuid: // value for 'forumTopicUuid'
 *   },
 * });
 */
export function useDeleteForumTopicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForumTopicMutation, DeleteForumTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForumTopicMutation, DeleteForumTopicMutationVariables>(DeleteForumTopicDocument, options);
      }
export type DeleteForumTopicMutationHookResult = ReturnType<typeof useDeleteForumTopicMutation>;
export type DeleteForumTopicMutationResult = Apollo.MutationResult<DeleteForumTopicMutation>;
export type DeleteForumTopicMutationOptions = Apollo.BaseMutationOptions<DeleteForumTopicMutation, DeleteForumTopicMutationVariables>;
export const ForumTopicHideDocument = gql`
    mutation ForumTopicHide($forumTopicUuid: ID!, $input: CourseForumTopicInput!) {
  course_forum_topic_update(forum_topic_uuid: $forumTopicUuid, input: $input) {
    topic {
      is_active
    }
  }
}
    `;
export type ForumTopicHideMutationFn = Apollo.MutationFunction<ForumTopicHideMutation, ForumTopicHideMutationVariables>;

/**
 * __useForumTopicHideMutation__
 *
 * To run a mutation, you first call `useForumTopicHideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForumTopicHideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forumTopicHideMutation, { data, loading, error }] = useForumTopicHideMutation({
 *   variables: {
 *      forumTopicUuid: // value for 'forumTopicUuid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForumTopicHideMutation(baseOptions?: Apollo.MutationHookOptions<ForumTopicHideMutation, ForumTopicHideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForumTopicHideMutation, ForumTopicHideMutationVariables>(ForumTopicHideDocument, options);
      }
export type ForumTopicHideMutationHookResult = ReturnType<typeof useForumTopicHideMutation>;
export type ForumTopicHideMutationResult = Apollo.MutationResult<ForumTopicHideMutation>;
export type ForumTopicHideMutationOptions = Apollo.BaseMutationOptions<ForumTopicHideMutation, ForumTopicHideMutationVariables>;
export const CourseBlockExamResponseDocument = gql`
    mutation courseBlockExamResponse($blockUuid: String!, $response: CourseBlockExamSubmissionResponse) {
  course_block_exam_response(block_uuid: $blockUuid, response: $response)
}
    `;
export type CourseBlockExamResponseMutationFn = Apollo.MutationFunction<CourseBlockExamResponseMutation, CourseBlockExamResponseMutationVariables>;

/**
 * __useCourseBlockExamResponseMutation__
 *
 * To run a mutation, you first call `useCourseBlockExamResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseBlockExamResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseBlockExamResponseMutation, { data, loading, error }] = useCourseBlockExamResponseMutation({
 *   variables: {
 *      blockUuid: // value for 'blockUuid'
 *      response: // value for 'response'
 *   },
 * });
 */
export function useCourseBlockExamResponseMutation(baseOptions?: Apollo.MutationHookOptions<CourseBlockExamResponseMutation, CourseBlockExamResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseBlockExamResponseMutation, CourseBlockExamResponseMutationVariables>(CourseBlockExamResponseDocument, options);
      }
export type CourseBlockExamResponseMutationHookResult = ReturnType<typeof useCourseBlockExamResponseMutation>;
export type CourseBlockExamResponseMutationResult = Apollo.MutationResult<CourseBlockExamResponseMutation>;
export type CourseBlockExamResponseMutationOptions = Apollo.BaseMutationOptions<CourseBlockExamResponseMutation, CourseBlockExamResponseMutationVariables>;
export const CourseBlockExamSubmitUpdateDocument = gql`
    mutation courseBlockExamSubmitUpdate($blockUuid: String!, $submission: CourseBlockExamSubmission) {
  course_block_exam_submit_update(block_uuid: $blockUuid, submission: $submission) {
    submissionResult: submission_result {
      uuid
      timeslot
      responses {
        uuid
        item
        shortInput: short_input
        longInput: long_input
        mediaUrl: media_url
        choices {
          uuid
          item
          shortInput: short_input
          longInput: long_input
          mediaUrl: media_url
        }
        markedCorrect: marked_correct
        editable
        feedbackImageUrl: feedback_image_url
        feedbackMessage: feedback_message
        manualWeight: manual_weight
        isResponseCorrect: is_response_correct
        score
        createAt: created_at
        modifiedAt: modified_at
        user
        showGrade: show_grade
        freedomWallResponses: freedom_wall_responses {
          uuid
          shortInput: short_input
          longInput: long_input
          mediaUrl: media_url
          createAt: created_at
          modifiedAt: modified_at
          user
          submittedBy: submitted_by {
            name
            email
            userUuid: user_uuid
          }
        }
      }
      startedAt: started_at
      endedAt: ended_at
      totalScore: total_score
      editable
      final
      status
      submissionCount: submission_count
      highestPossibleScore: highest_possible_submission_score
      responsesScoresSum: response_scores_sum
      totalItemLimit: total_item_limit
      responsesCount: responses_count
      blockStatus: block_status {
        isComplete: is_complete
        status
        gradePercent: grade_percent
        scoreRaw: score_raw
        scoreMin: score_min
        scoreMax: score_max
      }
      certificateBlockStatuses: certificate_block_statuses {
        isEligible: is_eligible
        status
        userCertificateStatus: user_certificate_status
      }
      createAt: created_at
      modifiedAt: modified_at
    }
  }
}
    `;
export type CourseBlockExamSubmitUpdateMutationFn = Apollo.MutationFunction<CourseBlockExamSubmitUpdateMutation, CourseBlockExamSubmitUpdateMutationVariables>;

/**
 * __useCourseBlockExamSubmitUpdateMutation__
 *
 * To run a mutation, you first call `useCourseBlockExamSubmitUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseBlockExamSubmitUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseBlockExamSubmitUpdateMutation, { data, loading, error }] = useCourseBlockExamSubmitUpdateMutation({
 *   variables: {
 *      blockUuid: // value for 'blockUuid'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useCourseBlockExamSubmitUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CourseBlockExamSubmitUpdateMutation, CourseBlockExamSubmitUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseBlockExamSubmitUpdateMutation, CourseBlockExamSubmitUpdateMutationVariables>(CourseBlockExamSubmitUpdateDocument, options);
      }
export type CourseBlockExamSubmitUpdateMutationHookResult = ReturnType<typeof useCourseBlockExamSubmitUpdateMutation>;
export type CourseBlockExamSubmitUpdateMutationResult = Apollo.MutationResult<CourseBlockExamSubmitUpdateMutation>;
export type CourseBlockExamSubmitUpdateMutationOptions = Apollo.BaseMutationOptions<CourseBlockExamSubmitUpdateMutation, CourseBlockExamSubmitUpdateMutationVariables>;
export const AssessmentSubmitUpdateDocument = gql`
    mutation assessmentSubmitUpdate($submissionUuid: String!, $updatedSubmission: ExamSubmissionInput!) {
  assessment_submit_update(
    submission_uuid: $submissionUuid
    updated_submission: $updatedSubmission
  ) {
    submissionResult: submission_result {
      status
      timeslot
      totalItemLimit: total_item_limit
      totalScore: total_score
      uuid
      submissionCount: submission_count
      responsesScoresSum: response_scores_sum
      responses {
        uuid
        mediaUrl: media_url
        markedCorrect: marked_correct
        feedbackImageUrl: feedback_image_url
        feedbackMessage: feedback_message
        score
        modifiedAt: modified_at
        pollChoice: poll_choice
        tallyResults: tally_results {
          type {
            uuid
            name
            description
          }
          score
        }
        pollResults: poll_results {
          choice {
            uuid
            shortInput: short_input
            longInput: long_input
            mediaUrl: media_url
            orderId: order_id
            audio_url
          }
          result {
            count
            percent
          }
        }
        longInput: long_input
        item
        isResponseCorrect: is_response_correct
        shortInput: short_input
        showGrade: show_grade
        choices {
          item
        }
        freedomWallResponses: freedom_wall_responses {
          uuid
          shortInput: short_input
          longInput: long_input
          mediaUrl: media_url
          createAt: created_at
          modifiedAt: modified_at
          user
        }
      }
    }
  }
}
    `;
export type AssessmentSubmitUpdateMutationFn = Apollo.MutationFunction<AssessmentSubmitUpdateMutation, AssessmentSubmitUpdateMutationVariables>;

/**
 * __useAssessmentSubmitUpdateMutation__
 *
 * To run a mutation, you first call `useAssessmentSubmitUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssessmentSubmitUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assessmentSubmitUpdateMutation, { data, loading, error }] = useAssessmentSubmitUpdateMutation({
 *   variables: {
 *      submissionUuid: // value for 'submissionUuid'
 *      updatedSubmission: // value for 'updatedSubmission'
 *   },
 * });
 */
export function useAssessmentSubmitUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AssessmentSubmitUpdateMutation, AssessmentSubmitUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssessmentSubmitUpdateMutation, AssessmentSubmitUpdateMutationVariables>(AssessmentSubmitUpdateDocument, options);
      }
export type AssessmentSubmitUpdateMutationHookResult = ReturnType<typeof useAssessmentSubmitUpdateMutation>;
export type AssessmentSubmitUpdateMutationResult = Apollo.MutationResult<AssessmentSubmitUpdateMutation>;
export type AssessmentSubmitUpdateMutationOptions = Apollo.BaseMutationOptions<AssessmentSubmitUpdateMutation, AssessmentSubmitUpdateMutationVariables>;
export const ResourceViewScreenBuriBooksDetailedDocument = gql`
    query resourceViewScreenBuriBooksDetailed($resourceUuid: ID!) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    resourceUuid: resource_uuid
    resource {
      uuid
      type
      name
      content {
        __typename
        ... on ResourceContentBurislide {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            examItemUuid: exam_item_uuid
            examTimeslotUuid: exam_timeslot_uuid
            uris
            text
            imageUri: image_uri
            title
            examItem: exam_item {
              uuid
              title
              text
              type
              subtype
              section
              instructions
              mediaUrl: media_url
              orderId: order_id
              isGraded: is_graded
              shuffleChoices: shuffle_choices
              weight
              value
              hint
              explanation
              required
              maxAllowedResponses: max_allowed_responses
              showResults: show_results
              choices {
                uuid
                item
                shortInput: short_input
                longInput: long_input
                mediaUrl: media_url
                imageUrl: image_url
                audioUrl: audio_url
                orderId: order_id
                isCorrect: is_correct
              }
            }
          }
        }
        ... on ResourceContentBuribookWithActivity {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            examItemUuid: exam_item_uuid
            uris
            text
            imageUri: image_uri
            title
            examItem: exam_item {
              uuid
              title
              text
              type
              subtype
              section
              instructions
              mediaUrl: media_url
              orderId: order_id
              isGraded: is_graded
              shuffleChoices: shuffle_choices
              weight
              value
              hint
              explanation
              required
              maxAllowedResponses: max_allowed_responses
              showResults: show_results
              choices {
                uuid
                item
                shortInput: short_input
                longInput: long_input
                mediaUrl: media_url
                image_url
                audio_url
                orderId: order_id
                isCorrect: is_correct
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useResourceViewScreenBuriBooksDetailedQuery__
 *
 * To run a query within a React component, call `useResourceViewScreenBuriBooksDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewScreenBuriBooksDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewScreenBuriBooksDetailedQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useResourceViewScreenBuriBooksDetailedQuery(baseOptions: Apollo.QueryHookOptions<ResourceViewScreenBuriBooksDetailedQuery, ResourceViewScreenBuriBooksDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewScreenBuriBooksDetailedQuery, ResourceViewScreenBuriBooksDetailedQueryVariables>(ResourceViewScreenBuriBooksDetailedDocument, options);
      }
export function useResourceViewScreenBuriBooksDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewScreenBuriBooksDetailedQuery, ResourceViewScreenBuriBooksDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewScreenBuriBooksDetailedQuery, ResourceViewScreenBuriBooksDetailedQueryVariables>(ResourceViewScreenBuriBooksDetailedDocument, options);
        }
export type ResourceViewScreenBuriBooksDetailedQueryHookResult = ReturnType<typeof useResourceViewScreenBuriBooksDetailedQuery>;
export type ResourceViewScreenBuriBooksDetailedLazyQueryHookResult = ReturnType<typeof useResourceViewScreenBuriBooksDetailedLazyQuery>;
export type ResourceViewScreenBuriBooksDetailedQueryResult = Apollo.QueryResult<ResourceViewScreenBuriBooksDetailedQuery, ResourceViewScreenBuriBooksDetailedQueryVariables>;
export const ItemsDocument = gql`
    query Items($examTimeslotUuid: String!, $resourceUuid: String!) {
  assessmentViewScreen: assessment_view_screen(
    exam_timeslot_uuid: $examTimeslotUuid
    resource_uuid: $resourceUuid
  ) {
    examTimeslot: exam_timeslot {
      outline {
        exam {
          sections {
            items {
              uuid
              type
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useItemsQuery__
 *
 * To run a query within a React component, call `useItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQuery({
 *   variables: {
 *      examTimeslotUuid: // value for 'examTimeslotUuid'
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useItemsQuery(baseOptions: Apollo.QueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
      }
export function useItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
export type ItemsQueryHookResult = ReturnType<typeof useItemsQuery>;
export type ItemsLazyQueryHookResult = ReturnType<typeof useItemsLazyQuery>;
export type ItemsQueryResult = Apollo.QueryResult<ItemsQuery, ItemsQueryVariables>;
export const FileSubmissionV2Document = gql`
    mutation FileSubmissionV2($updatedSubmission: ExamSubmissionInputV2!, $submissionUuid: String!, $blockUuid: String, $courseScheduleUuid: String) {
  assessmentSubmitUpdateV2: assessment_submit_update_v2(
    updated_submission: $updatedSubmission
    submission_uuid: $submissionUuid
    block_uuid: $blockUuid
    course_schedule_uuid: $courseScheduleUuid
  ) {
    __typename
  }
}
    `;
export type FileSubmissionV2MutationFn = Apollo.MutationFunction<FileSubmissionV2Mutation, FileSubmissionV2MutationVariables>;

/**
 * __useFileSubmissionV2Mutation__
 *
 * To run a mutation, you first call `useFileSubmissionV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileSubmissionV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileSubmissionV2Mutation, { data, loading, error }] = useFileSubmissionV2Mutation({
 *   variables: {
 *      updatedSubmission: // value for 'updatedSubmission'
 *      submissionUuid: // value for 'submissionUuid'
 *      blockUuid: // value for 'blockUuid'
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useFileSubmissionV2Mutation(baseOptions?: Apollo.MutationHookOptions<FileSubmissionV2Mutation, FileSubmissionV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileSubmissionV2Mutation, FileSubmissionV2MutationVariables>(FileSubmissionV2Document, options);
      }
export type FileSubmissionV2MutationHookResult = ReturnType<typeof useFileSubmissionV2Mutation>;
export type FileSubmissionV2MutationResult = Apollo.MutationResult<FileSubmissionV2Mutation>;
export type FileSubmissionV2MutationOptions = Apollo.BaseMutationOptions<FileSubmissionV2Mutation, FileSubmissionV2MutationVariables>;
export const FileSubmissionInsideCourseDocument = gql`
    mutation FileSubmissionInsideCourse($blockUuid: String!, $submission: CourseBlockExamSubmission) {
  course_block_exam_submission(block_uuid: $blockUuid, submission: $submission)
}
    `;
export type FileSubmissionInsideCourseMutationFn = Apollo.MutationFunction<FileSubmissionInsideCourseMutation, FileSubmissionInsideCourseMutationVariables>;

/**
 * __useFileSubmissionInsideCourseMutation__
 *
 * To run a mutation, you first call `useFileSubmissionInsideCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileSubmissionInsideCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileSubmissionInsideCourseMutation, { data, loading, error }] = useFileSubmissionInsideCourseMutation({
 *   variables: {
 *      blockUuid: // value for 'blockUuid'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useFileSubmissionInsideCourseMutation(baseOptions?: Apollo.MutationHookOptions<FileSubmissionInsideCourseMutation, FileSubmissionInsideCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileSubmissionInsideCourseMutation, FileSubmissionInsideCourseMutationVariables>(FileSubmissionInsideCourseDocument, options);
      }
export type FileSubmissionInsideCourseMutationHookResult = ReturnType<typeof useFileSubmissionInsideCourseMutation>;
export type FileSubmissionInsideCourseMutationResult = Apollo.MutationResult<FileSubmissionInsideCourseMutation>;
export type FileSubmissionInsideCourseMutationOptions = Apollo.BaseMutationOptions<FileSubmissionInsideCourseMutation, FileSubmissionInsideCourseMutationVariables>;
export const FileSubmissionOutsideCourseDocument = gql`
    mutation FileSubmissionOutsideCourse($examTimeslotUuid: String!, $submission: ExamSubmissionInput) {
  assessment_submission(
    exam_timeslot_uuid: $examTimeslotUuid
    submission: $submission
  )
}
    `;
export type FileSubmissionOutsideCourseMutationFn = Apollo.MutationFunction<FileSubmissionOutsideCourseMutation, FileSubmissionOutsideCourseMutationVariables>;

/**
 * __useFileSubmissionOutsideCourseMutation__
 *
 * To run a mutation, you first call `useFileSubmissionOutsideCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileSubmissionOutsideCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileSubmissionOutsideCourseMutation, { data, loading, error }] = useFileSubmissionOutsideCourseMutation({
 *   variables: {
 *      examTimeslotUuid: // value for 'examTimeslotUuid'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useFileSubmissionOutsideCourseMutation(baseOptions?: Apollo.MutationHookOptions<FileSubmissionOutsideCourseMutation, FileSubmissionOutsideCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileSubmissionOutsideCourseMutation, FileSubmissionOutsideCourseMutationVariables>(FileSubmissionOutsideCourseDocument, options);
      }
export type FileSubmissionOutsideCourseMutationHookResult = ReturnType<typeof useFileSubmissionOutsideCourseMutation>;
export type FileSubmissionOutsideCourseMutationResult = Apollo.MutationResult<FileSubmissionOutsideCourseMutation>;
export type FileSubmissionOutsideCourseMutationOptions = Apollo.BaseMutationOptions<FileSubmissionOutsideCourseMutation, FileSubmissionOutsideCourseMutationVariables>;
export const FreedomWallSubmitDocument = gql`
    mutation FreedomWallSubmit($updatedSubmission: ExamSubmissionInputV2!, $submissionUuid: String!, $blockUuid: String, $courseScheduleUuid: String) {
  assessmentSubmitUpdateV2: assessment_submit_update_v2(
    updated_submission: $updatedSubmission
    submission_uuid: $submissionUuid
    block_uuid: $blockUuid
    course_schedule_uuid: $courseScheduleUuid
  ) {
    __typename
    submissionResult: submission_result {
      responses {
        freedomWallResponses: freedom_wall_responses {
          userDetails: user_details {
            firstName: first_name
            lastName: last_name
            profileIconUrl: profile_icon_url
          }
        }
        feedbackMessage: feedback_message
      }
    }
    courseBlockSubmissionResult: course_block_submission_result {
      responses {
        freedomWallResponses: freedom_wall_responses {
          uuid
          shortInput: short_input
          longInput: long_input
          userDetails: user_details {
            firstName: first_name
            lastName: last_name
            profileIconUrl: profile_icon_url
          }
        }
        feedbackMessage: feedback_message
      }
    }
  }
}
    `;
export type FreedomWallSubmitMutationFn = Apollo.MutationFunction<FreedomWallSubmitMutation, FreedomWallSubmitMutationVariables>;

/**
 * __useFreedomWallSubmitMutation__
 *
 * To run a mutation, you first call `useFreedomWallSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreedomWallSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freedomWallSubmitMutation, { data, loading, error }] = useFreedomWallSubmitMutation({
 *   variables: {
 *      updatedSubmission: // value for 'updatedSubmission'
 *      submissionUuid: // value for 'submissionUuid'
 *      blockUuid: // value for 'blockUuid'
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useFreedomWallSubmitMutation(baseOptions?: Apollo.MutationHookOptions<FreedomWallSubmitMutation, FreedomWallSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreedomWallSubmitMutation, FreedomWallSubmitMutationVariables>(FreedomWallSubmitDocument, options);
      }
export type FreedomWallSubmitMutationHookResult = ReturnType<typeof useFreedomWallSubmitMutation>;
export type FreedomWallSubmitMutationResult = Apollo.MutationResult<FreedomWallSubmitMutation>;
export type FreedomWallSubmitMutationOptions = Apollo.BaseMutationOptions<FreedomWallSubmitMutation, FreedomWallSubmitMutationVariables>;
export const Account_And_User_Details_ScreenDocument = gql`
    query Account_and_user_details_screen {
  accountAndUserDetailsScreen: account_and_user_details_screen {
    userInfo: user_info {
      firstName: first_name
      userId: user_id
    }
  }
}
    `;

/**
 * __useAccount_And_User_Details_ScreenQuery__
 *
 * To run a query within a React component, call `useAccount_And_User_Details_ScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccount_And_User_Details_ScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccount_And_User_Details_ScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccount_And_User_Details_ScreenQuery(baseOptions?: Apollo.QueryHookOptions<Account_And_User_Details_ScreenQuery, Account_And_User_Details_ScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Account_And_User_Details_ScreenQuery, Account_And_User_Details_ScreenQueryVariables>(Account_And_User_Details_ScreenDocument, options);
      }
export function useAccount_And_User_Details_ScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Account_And_User_Details_ScreenQuery, Account_And_User_Details_ScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Account_And_User_Details_ScreenQuery, Account_And_User_Details_ScreenQueryVariables>(Account_And_User_Details_ScreenDocument, options);
        }
export type Account_And_User_Details_ScreenQueryHookResult = ReturnType<typeof useAccount_And_User_Details_ScreenQuery>;
export type Account_And_User_Details_ScreenLazyQueryHookResult = ReturnType<typeof useAccount_And_User_Details_ScreenLazyQuery>;
export type Account_And_User_Details_ScreenQueryResult = Apollo.QueryResult<Account_And_User_Details_ScreenQuery, Account_And_User_Details_ScreenQueryVariables>;
export const DevQueryDocument = gql`
    query DevQuery {
  dev {
    session
  }
}
    `;

/**
 * __useDevQueryQuery__
 *
 * To run a query within a React component, call `useDevQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevQueryQuery(baseOptions?: Apollo.QueryHookOptions<DevQueryQuery, DevQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevQueryQuery, DevQueryQueryVariables>(DevQueryDocument, options);
      }
export function useDevQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevQueryQuery, DevQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevQueryQuery, DevQueryQueryVariables>(DevQueryDocument, options);
        }
export type DevQueryQueryHookResult = ReturnType<typeof useDevQueryQuery>;
export type DevQueryLazyQueryHookResult = ReturnType<typeof useDevQueryLazyQuery>;
export type DevQueryQueryResult = Apollo.QueryResult<DevQueryQuery, DevQueryQueryVariables>;
export const AccountAndUserDetailsDocument = gql`
    query AccountAndUserDetails {
  accountAndUserDetailsScreen: account_and_user_details_screen {
    userInfo: user_info {
      userId: user_id
      firstName: first_name
      lastName: last_name
      email
      emailVerified: email_verified
    }
    userProfile: user_profile {
      profileId: profile_id
      givenName: given_name
      familyName: family_name
    }
    customFields: custom_fields {
      required
      label
      inputType: input_type
      inputName: input_name
      value
      options
      disabled
    }
    formTabs: form_tabs {
      name
      id
    }
  }
}
    `;

/**
 * __useAccountAndUserDetailsQuery__
 *
 * To run a query within a React component, call `useAccountAndUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountAndUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountAndUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountAndUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<AccountAndUserDetailsQuery, AccountAndUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountAndUserDetailsQuery, AccountAndUserDetailsQueryVariables>(AccountAndUserDetailsDocument, options);
      }
export function useAccountAndUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountAndUserDetailsQuery, AccountAndUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountAndUserDetailsQuery, AccountAndUserDetailsQueryVariables>(AccountAndUserDetailsDocument, options);
        }
export type AccountAndUserDetailsQueryHookResult = ReturnType<typeof useAccountAndUserDetailsQuery>;
export type AccountAndUserDetailsLazyQueryHookResult = ReturnType<typeof useAccountAndUserDetailsLazyQuery>;
export type AccountAndUserDetailsQueryResult = Apollo.QueryResult<AccountAndUserDetailsQuery, AccountAndUserDetailsQueryVariables>;
export const FormSubmitDocument = gql`
    mutation FormSubmit($details: AccountAndUserDetailsScreenFormTabSubmit) {
  form_submit(details: $details) {
    formSubmissionSummary: form_submission_summary {
      approvalStatus: approval_status
      dateCreated: date_created
      fileDescripiton: file_description
      id
      subtitle
      title
    }
  }
}
    `;
export type FormSubmitMutationFn = Apollo.MutationFunction<FormSubmitMutation, FormSubmitMutationVariables>;

/**
 * __useFormSubmitMutation__
 *
 * To run a mutation, you first call `useFormSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formSubmitMutation, { data, loading, error }] = useFormSubmitMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useFormSubmitMutation(baseOptions?: Apollo.MutationHookOptions<FormSubmitMutation, FormSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormSubmitMutation, FormSubmitMutationVariables>(FormSubmitDocument, options);
      }
export type FormSubmitMutationHookResult = ReturnType<typeof useFormSubmitMutation>;
export type FormSubmitMutationResult = Apollo.MutationResult<FormSubmitMutation>;
export type FormSubmitMutationOptions = Apollo.BaseMutationOptions<FormSubmitMutation, FormSubmitMutationVariables>;
export const GetFormItemsDocument = gql`
    query GetFormItems($formTabId: ID!) {
  accountAndUserDetailsScreen: account_and_user_details_screen {
    formTab: form_tab(id: $formTabId) {
      formItems: form_items {
        inputName: input_name
        disabled
        approvalStatus: approval_status
        label
        inputType: input_type
        needsApproval: needs_approval
        options
        required
        value
        id
      }
    }
  }
}
    `;

/**
 * __useGetFormItemsQuery__
 *
 * To run a query within a React component, call `useGetFormItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormItemsQuery({
 *   variables: {
 *      formTabId: // value for 'formTabId'
 *   },
 * });
 */
export function useGetFormItemsQuery(baseOptions: Apollo.QueryHookOptions<GetFormItemsQuery, GetFormItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormItemsQuery, GetFormItemsQueryVariables>(GetFormItemsDocument, options);
      }
export function useGetFormItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormItemsQuery, GetFormItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormItemsQuery, GetFormItemsQueryVariables>(GetFormItemsDocument, options);
        }
export type GetFormItemsQueryHookResult = ReturnType<typeof useGetFormItemsQuery>;
export type GetFormItemsLazyQueryHookResult = ReturnType<typeof useGetFormItemsLazyQuery>;
export type GetFormItemsQueryResult = Apollo.QueryResult<GetFormItemsQuery, GetFormItemsQueryVariables>;
export const GetFormSubmissionSummariesDocument = gql`
    query GetFormSubmissionSummaries($formTabId: ID!) {
  accountAndUserDetails: account_and_user_details_screen {
    formTab: form_tab(id: $formTabId) {
      formSubmissionSummaries: form_submission_summaries {
        approvalStatus: approval_status
        dateCreated: date_created
        fileDescription: file_description
        id
        subtitle
        title
      }
    }
  }
}
    `;

/**
 * __useGetFormSubmissionSummariesQuery__
 *
 * To run a query within a React component, call `useGetFormSubmissionSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSubmissionSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSubmissionSummariesQuery({
 *   variables: {
 *      formTabId: // value for 'formTabId'
 *   },
 * });
 */
export function useGetFormSubmissionSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetFormSubmissionSummariesQuery, GetFormSubmissionSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormSubmissionSummariesQuery, GetFormSubmissionSummariesQueryVariables>(GetFormSubmissionSummariesDocument, options);
      }
export function useGetFormSubmissionSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormSubmissionSummariesQuery, GetFormSubmissionSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormSubmissionSummariesQuery, GetFormSubmissionSummariesQueryVariables>(GetFormSubmissionSummariesDocument, options);
        }
export type GetFormSubmissionSummariesQueryHookResult = ReturnType<typeof useGetFormSubmissionSummariesQuery>;
export type GetFormSubmissionSummariesLazyQueryHookResult = ReturnType<typeof useGetFormSubmissionSummariesLazyQuery>;
export type GetFormSubmissionSummariesQueryResult = Apollo.QueryResult<GetFormSubmissionSummariesQuery, GetFormSubmissionSummariesQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($details: AccountDetailsUpdate) {
  account_update(details: $details) {
    user_id
    email
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($details: AccountProfileUpdate) {
  profile_update(details: $details) {
    profile_id
    given_name
    family_name
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const Log_GroupsDocument = gql`
    query Log_groups {
  activityLogScreen: activity_log_screen {
    logGroups: log_groups {
      name
      logItems: log_items {
        timestamp
        resource {
          name
          coverUri: cover_uri
          type
          subtype
        }
        verb
      }
    }
  }
}
    `;

/**
 * __useLog_GroupsQuery__
 *
 * To run a query within a React component, call `useLog_GroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLog_GroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLog_GroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLog_GroupsQuery(baseOptions?: Apollo.QueryHookOptions<Log_GroupsQuery, Log_GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Log_GroupsQuery, Log_GroupsQueryVariables>(Log_GroupsDocument, options);
      }
export function useLog_GroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Log_GroupsQuery, Log_GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Log_GroupsQuery, Log_GroupsQueryVariables>(Log_GroupsDocument, options);
        }
export type Log_GroupsQueryHookResult = ReturnType<typeof useLog_GroupsQuery>;
export type Log_GroupsLazyQueryHookResult = ReturnType<typeof useLog_GroupsLazyQuery>;
export type Log_GroupsQueryResult = Apollo.QueryResult<Log_GroupsQuery, Log_GroupsQueryVariables>;
export const AssessmentDetailedViewScreenDocument = gql`
    query AssessmentDetailedViewScreen($examTimeslotUuid: String!, $resourceUuid: String!) {
  assessment_view_screen(
    exam_timeslot_uuid: $examTimeslotUuid
    resource_uuid: $resourceUuid
  ) {
    resource {
      name
    }
    exam_timeslot {
      outline {
        exam {
          sections {
            items {
              text
              type
              subtype
              choices {
                is_correct
                long_input
                image_url
                short_input
                audio_url
                item
                uuid
                order_id
                created_at
                modified_at
              }
              media_url
              required
              title
              instructions
              hint
              explanation
              is_graded
              order_id
              uuid
              value
              shuffle_choices
              section
              weight
              show_results
            }
            title
            uuid
            order_id
            is_graded
            item_limit
            created_by
            instructions
            shuffle_items
            modified_by
            exam
          }
          time_limit
          title
          userscores
          uuid
          slug
          show_grade_type
          show_grade
          modified_by
          is_graded
          has_complete_submission
          end_message
          display_progress
          display_points
          display_missed
          display_correct
          description
          created_by
        }
      }
      created_by
      created_at
      description
      end
      start
      uuid
      open
      name
      user_submissions {
        total_count
      }
    }
  }
}
    `;

/**
 * __useAssessmentDetailedViewScreenQuery__
 *
 * To run a query within a React component, call `useAssessmentDetailedViewScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentDetailedViewScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentDetailedViewScreenQuery({
 *   variables: {
 *      examTimeslotUuid: // value for 'examTimeslotUuid'
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useAssessmentDetailedViewScreenQuery(baseOptions: Apollo.QueryHookOptions<AssessmentDetailedViewScreenQuery, AssessmentDetailedViewScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentDetailedViewScreenQuery, AssessmentDetailedViewScreenQueryVariables>(AssessmentDetailedViewScreenDocument, options);
      }
export function useAssessmentDetailedViewScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentDetailedViewScreenQuery, AssessmentDetailedViewScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentDetailedViewScreenQuery, AssessmentDetailedViewScreenQueryVariables>(AssessmentDetailedViewScreenDocument, options);
        }
export type AssessmentDetailedViewScreenQueryHookResult = ReturnType<typeof useAssessmentDetailedViewScreenQuery>;
export type AssessmentDetailedViewScreenLazyQueryHookResult = ReturnType<typeof useAssessmentDetailedViewScreenLazyQuery>;
export type AssessmentDetailedViewScreenQueryResult = Apollo.QueryResult<AssessmentDetailedViewScreenQuery, AssessmentDetailedViewScreenQueryVariables>;
export const GetNextCourseBlocksDocument = gql`
    query GetNextCourseBlocks($resourceDetailsInput: ResourceDetailsInput!) {
  resourceViewScreenV2: resource_view_screen_v2(
    resource_details_input: $resourceDetailsInput
  ) {
    courseBlock: course_block {
      nextBlocksJoined: next_blocks_joined {
        coverUri: cover_uri
        uuid
        title
        resource {
          uuid
        }
      }
      nextBlocks: next_blocks
    }
  }
}
    `;

/**
 * __useGetNextCourseBlocksQuery__
 *
 * To run a query within a React component, call `useGetNextCourseBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextCourseBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextCourseBlocksQuery({
 *   variables: {
 *      resourceDetailsInput: // value for 'resourceDetailsInput'
 *   },
 * });
 */
export function useGetNextCourseBlocksQuery(baseOptions: Apollo.QueryHookOptions<GetNextCourseBlocksQuery, GetNextCourseBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextCourseBlocksQuery, GetNextCourseBlocksQueryVariables>(GetNextCourseBlocksDocument, options);
      }
export function useGetNextCourseBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextCourseBlocksQuery, GetNextCourseBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextCourseBlocksQuery, GetNextCourseBlocksQueryVariables>(GetNextCourseBlocksDocument, options);
        }
export type GetNextCourseBlocksQueryHookResult = ReturnType<typeof useGetNextCourseBlocksQuery>;
export type GetNextCourseBlocksLazyQueryHookResult = ReturnType<typeof useGetNextCourseBlocksLazyQuery>;
export type GetNextCourseBlocksQueryResult = Apollo.QueryResult<GetNextCourseBlocksQuery, GetNextCourseBlocksQueryVariables>;
export const OldAssessmentSubmissionDocument = gql`
    mutation OldAssessmentSubmission($examTimeslotUuid: String!, $submission: ExamSubmissionInput) {
  assessment_submission(
    exam_timeslot_uuid: $examTimeslotUuid
    submission: $submission
  )
}
    `;
export type OldAssessmentSubmissionMutationFn = Apollo.MutationFunction<OldAssessmentSubmissionMutation, OldAssessmentSubmissionMutationVariables>;

/**
 * __useOldAssessmentSubmissionMutation__
 *
 * To run a mutation, you first call `useOldAssessmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOldAssessmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oldAssessmentSubmissionMutation, { data, loading, error }] = useOldAssessmentSubmissionMutation({
 *   variables: {
 *      examTimeslotUuid: // value for 'examTimeslotUuid'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useOldAssessmentSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<OldAssessmentSubmissionMutation, OldAssessmentSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OldAssessmentSubmissionMutation, OldAssessmentSubmissionMutationVariables>(OldAssessmentSubmissionDocument, options);
      }
export type OldAssessmentSubmissionMutationHookResult = ReturnType<typeof useOldAssessmentSubmissionMutation>;
export type OldAssessmentSubmissionMutationResult = Apollo.MutationResult<OldAssessmentSubmissionMutation>;
export type OldAssessmentSubmissionMutationOptions = Apollo.BaseMutationOptions<OldAssessmentSubmissionMutation, OldAssessmentSubmissionMutationVariables>;
export const OldCourseBlockExamSubmissionDocument = gql`
    mutation OldCourseBlockExamSubmission($blockUuid: String!, $submission: CourseBlockExamSubmission) {
  course_block_exam_submission(block_uuid: $blockUuid, submission: $submission)
}
    `;
export type OldCourseBlockExamSubmissionMutationFn = Apollo.MutationFunction<OldCourseBlockExamSubmissionMutation, OldCourseBlockExamSubmissionMutationVariables>;

/**
 * __useOldCourseBlockExamSubmissionMutation__
 *
 * To run a mutation, you first call `useOldCourseBlockExamSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOldCourseBlockExamSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oldCourseBlockExamSubmissionMutation, { data, loading, error }] = useOldCourseBlockExamSubmissionMutation({
 *   variables: {
 *      blockUuid: // value for 'blockUuid'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useOldCourseBlockExamSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<OldCourseBlockExamSubmissionMutation, OldCourseBlockExamSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OldCourseBlockExamSubmissionMutation, OldCourseBlockExamSubmissionMutationVariables>(OldCourseBlockExamSubmissionDocument, options);
      }
export type OldCourseBlockExamSubmissionMutationHookResult = ReturnType<typeof useOldCourseBlockExamSubmissionMutation>;
export type OldCourseBlockExamSubmissionMutationResult = Apollo.MutationResult<OldCourseBlockExamSubmissionMutation>;
export type OldCourseBlockExamSubmissionMutationOptions = Apollo.BaseMutationOptions<OldCourseBlockExamSubmissionMutation, OldCourseBlockExamSubmissionMutationVariables>;
export const AssessmentNextButtonDocument = gql`
    mutation AssessmentNextButton($resourceUuid: ID!, $courseBlockUuid: String, $courseScheduleUuid: String) {
  resourceEnd: resource_end(
    resource_uuid: $resourceUuid
    course_block_uuid: $courseBlockUuid
    course_schedule_uuid: $courseScheduleUuid
  ) {
    nextCourseBlocks: next_course_blocks {
      uuid
      title
      resource {
        uuid
      }
      coverUri: cover_uri
    }
  }
}
    `;
export type AssessmentNextButtonMutationFn = Apollo.MutationFunction<AssessmentNextButtonMutation, AssessmentNextButtonMutationVariables>;

/**
 * __useAssessmentNextButtonMutation__
 *
 * To run a mutation, you first call `useAssessmentNextButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssessmentNextButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assessmentNextButtonMutation, { data, loading, error }] = useAssessmentNextButtonMutation({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *      courseBlockUuid: // value for 'courseBlockUuid'
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useAssessmentNextButtonMutation(baseOptions?: Apollo.MutationHookOptions<AssessmentNextButtonMutation, AssessmentNextButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssessmentNextButtonMutation, AssessmentNextButtonMutationVariables>(AssessmentNextButtonDocument, options);
      }
export type AssessmentNextButtonMutationHookResult = ReturnType<typeof useAssessmentNextButtonMutation>;
export type AssessmentNextButtonMutationResult = Apollo.MutationResult<AssessmentNextButtonMutation>;
export type AssessmentNextButtonMutationOptions = Apollo.BaseMutationOptions<AssessmentNextButtonMutation, AssessmentNextButtonMutationVariables>;
export const LoginDocument = gql`
    mutation Login($redirectUri: String!, $code: String!, $clientId: String!) {
  login(redirect_uri: $redirectUri, code: $code, client_id: $clientId)
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      redirectUri: // value for 'redirectUri'
 *      code: // value for 'code'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const CastIdDocument = gql`
    query CastId {
  browserTitleBar: browser_title_bar {
    id
  }
}
    `;

/**
 * __useCastIdQuery__
 *
 * To run a query within a React component, call `useCastIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCastIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCastIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCastIdQuery(baseOptions?: Apollo.QueryHookOptions<CastIdQuery, CastIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CastIdQuery, CastIdQueryVariables>(CastIdDocument, options);
      }
export function useCastIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CastIdQuery, CastIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CastIdQuery, CastIdQueryVariables>(CastIdDocument, options);
        }
export type CastIdQueryHookResult = ReturnType<typeof useCastIdQuery>;
export type CastIdLazyQueryHookResult = ReturnType<typeof useCastIdLazyQuery>;
export type CastIdQueryResult = Apollo.QueryResult<CastIdQuery, CastIdQueryVariables>;
export const CasticulateClearStateDocument = gql`
    mutation CasticulateClearState($ids: CasticulateIdsInput!) {
  casticulate_clear_state(ids: $ids) {
    id
  }
}
    `;
export type CasticulateClearStateMutationFn = Apollo.MutationFunction<CasticulateClearStateMutation, CasticulateClearStateMutationVariables>;

/**
 * __useCasticulateClearStateMutation__
 *
 * To run a mutation, you first call `useCasticulateClearStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCasticulateClearStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [casticulateClearStateMutation, { data, loading, error }] = useCasticulateClearStateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCasticulateClearStateMutation(baseOptions?: Apollo.MutationHookOptions<CasticulateClearStateMutation, CasticulateClearStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CasticulateClearStateMutation, CasticulateClearStateMutationVariables>(CasticulateClearStateDocument, options);
      }
export type CasticulateClearStateMutationHookResult = ReturnType<typeof useCasticulateClearStateMutation>;
export type CasticulateClearStateMutationResult = Apollo.MutationResult<CasticulateClearStateMutation>;
export type CasticulateClearStateMutationOptions = Apollo.BaseMutationOptions<CasticulateClearStateMutation, CasticulateClearStateMutationVariables>;
export const CasticulateSetStateDocument = gql`
    mutation CasticulateSetState($ids: CasticulateIdsInput!, $data: JSONObject!) {
  casticulate_set_state(ids: $ids, data: $data) {
    hasState: has_state
    data
  }
}
    `;
export type CasticulateSetStateMutationFn = Apollo.MutationFunction<CasticulateSetStateMutation, CasticulateSetStateMutationVariables>;

/**
 * __useCasticulateSetStateMutation__
 *
 * To run a mutation, you first call `useCasticulateSetStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCasticulateSetStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [casticulateSetStateMutation, { data, loading, error }] = useCasticulateSetStateMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCasticulateSetStateMutation(baseOptions?: Apollo.MutationHookOptions<CasticulateSetStateMutation, CasticulateSetStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CasticulateSetStateMutation, CasticulateSetStateMutationVariables>(CasticulateSetStateDocument, options);
      }
export type CasticulateSetStateMutationHookResult = ReturnType<typeof useCasticulateSetStateMutation>;
export type CasticulateSetStateMutationResult = Apollo.MutationResult<CasticulateSetStateMutation>;
export type CasticulateSetStateMutationOptions = Apollo.BaseMutationOptions<CasticulateSetStateMutation, CasticulateSetStateMutationVariables>;
export const CasticulateStateDocument = gql`
    query CasticulateState($ids: CasticulateIdsInput!) {
  casticulateViewScreen: casticulate_view_screen(ids: $ids) {
    casticulateState: casticulate_state {
      data
      hasState: has_state
      id
    }
  }
}
    `;

/**
 * __useCasticulateStateQuery__
 *
 * To run a query within a React component, call `useCasticulateStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasticulateStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasticulateStateQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCasticulateStateQuery(baseOptions: Apollo.QueryHookOptions<CasticulateStateQuery, CasticulateStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CasticulateStateQuery, CasticulateStateQueryVariables>(CasticulateStateDocument, options);
      }
export function useCasticulateStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CasticulateStateQuery, CasticulateStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CasticulateStateQuery, CasticulateStateQueryVariables>(CasticulateStateDocument, options);
        }
export type CasticulateStateQueryHookResult = ReturnType<typeof useCasticulateStateQuery>;
export type CasticulateStateLazyQueryHookResult = ReturnType<typeof useCasticulateStateLazyQuery>;
export type CasticulateStateQueryResult = Apollo.QueryResult<CasticulateStateQuery, CasticulateStateQueryVariables>;
export const CasticulateViewScreenDocument = gql`
    query CasticulateViewScreen($ids: CasticulateIdsInput!) {
  casticulateViewScreen: casticulate_view_screen(ids: $ids) {
    id
    casticulateGraph: casticulate_graph {
      id
      name
      nodes {
        id
        slideType: slide_type
        data
        layout {
          id
          html
        }
        isEndNode: is_end_node
      }
      edges {
        id
        data
        fromNode: from_node {
          id
          slideType: slide_type
        }
        toNode: to_node {
          id
          slideType: slide_type
        }
        triggers {
          action
          value
          refId: ref_id
          id
        }
      }
      possibleRoutes: possible_routes {
        id
        slideType: slide_type
        data
      }
    }
  }
}
    `;

/**
 * __useCasticulateViewScreenQuery__
 *
 * To run a query within a React component, call `useCasticulateViewScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCasticulateViewScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCasticulateViewScreenQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCasticulateViewScreenQuery(baseOptions: Apollo.QueryHookOptions<CasticulateViewScreenQuery, CasticulateViewScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CasticulateViewScreenQuery, CasticulateViewScreenQueryVariables>(CasticulateViewScreenDocument, options);
      }
export function useCasticulateViewScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CasticulateViewScreenQuery, CasticulateViewScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CasticulateViewScreenQuery, CasticulateViewScreenQueryVariables>(CasticulateViewScreenDocument, options);
        }
export type CasticulateViewScreenQueryHookResult = ReturnType<typeof useCasticulateViewScreenQuery>;
export type CasticulateViewScreenLazyQueryHookResult = ReturnType<typeof useCasticulateViewScreenLazyQuery>;
export type CasticulateViewScreenQueryResult = Apollo.QueryResult<CasticulateViewScreenQuery, CasticulateViewScreenQueryVariables>;
export const CollectionListScreenDocument = gql`
    query CollectionListScreen($resourceCollectionUuid: String) {
  catalogListScreen: catalog_list_screen(
    resource_collection_uuid: $resourceCollectionUuid
  ) {
    resourceCollection: resource_collection {
      id
      name
    }
    resources {
      id
      uuid
      name
      description
      type
      subtype
      coverUri: cover_uri
      content {
        ... on ResourceContentCourse {
          course_details {
            course {
              uuid
              allowedActions: allowed_actions
              isEnrolled: is_enrolled
              id
            }
          }
        }
        ... on ResourceContentAssessment {
          examTimeslot: exam_timeslot {
            userSubmissions: user_submissions {
              final {
                count
              }
            }
            outline {
              exam {
                timeLimit: time_limit
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCollectionListScreenQuery__
 *
 * To run a query within a React component, call `useCollectionListScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionListScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionListScreenQuery({
 *   variables: {
 *      resourceCollectionUuid: // value for 'resourceCollectionUuid'
 *   },
 * });
 */
export function useCollectionListScreenQuery(baseOptions?: Apollo.QueryHookOptions<CollectionListScreenQuery, CollectionListScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionListScreenQuery, CollectionListScreenQueryVariables>(CollectionListScreenDocument, options);
      }
export function useCollectionListScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionListScreenQuery, CollectionListScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionListScreenQuery, CollectionListScreenQueryVariables>(CollectionListScreenDocument, options);
        }
export type CollectionListScreenQueryHookResult = ReturnType<typeof useCollectionListScreenQuery>;
export type CollectionListScreenLazyQueryHookResult = ReturnType<typeof useCollectionListScreenLazyQuery>;
export type CollectionListScreenQueryResult = Apollo.QueryResult<CollectionListScreenQuery, CollectionListScreenQueryVariables>;
export const CourseActivityCheckerDocument = gql`
    query CourseActivityChecker($courseUuid: ID!, $scheduleUuid: String!) {
  courseProgressScreen: course_progress_screen(
    course_uuid: $courseUuid
    schedule_uuid: $scheduleUuid
  ) {
    outlineProgress: outline_progress {
      title
      blocks {
        title
        status
        resourceType: resource_type
        resourceSubType: resource_subtype
        coverUri: cover_uri
        scoreRaw: score_raw
        scoreMax: score_max
      }
    }
    course {
      title
      description
      coverUri: cover_uri
      hasUserComplete: has_user_completed
      enrollmentInfo: enrollment_info {
        end
      }
      enrolledSchedules: enrolled_schedules {
        status
        uuid
      }
    }
    learnerCourseStatus: learner_course_status {
      courseCertificateUrl: course_certificate_url
      status
      scheduleDetails: schedule_details {
        status
      }
    }
  }
}
    `;

/**
 * __useCourseActivityCheckerQuery__
 *
 * To run a query within a React component, call `useCourseActivityCheckerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseActivityCheckerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseActivityCheckerQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *      scheduleUuid: // value for 'scheduleUuid'
 *   },
 * });
 */
export function useCourseActivityCheckerQuery(baseOptions: Apollo.QueryHookOptions<CourseActivityCheckerQuery, CourseActivityCheckerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseActivityCheckerQuery, CourseActivityCheckerQueryVariables>(CourseActivityCheckerDocument, options);
      }
export function useCourseActivityCheckerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseActivityCheckerQuery, CourseActivityCheckerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseActivityCheckerQuery, CourseActivityCheckerQueryVariables>(CourseActivityCheckerDocument, options);
        }
export type CourseActivityCheckerQueryHookResult = ReturnType<typeof useCourseActivityCheckerQuery>;
export type CourseActivityCheckerLazyQueryHookResult = ReturnType<typeof useCourseActivityCheckerLazyQuery>;
export type CourseActivityCheckerQueryResult = Apollo.QueryResult<CourseActivityCheckerQuery, CourseActivityCheckerQueryVariables>;
export const CourseViewerDocument = gql`
    query CourseViewer($courseUuid: String!, $scheduleUuid: String) {
  courseViewScreen: course_view_screen(
    course_uuid: $courseUuid
    schedule_uuid: $scheduleUuid
  ) {
    id
    course {
      id
      uuid
      coverUri: cover_uri
      description
      title
      outline {
        title
        blocks {
          uuid
          title
          coverUri: cover_uri
          resource {
            id
            type
            description
            uuid
          }
          isAccessible: is_accessible
          certificateBlockStatus: certificate_block_status {
            status
          }
          maxSubmissionsReached: max_submissions_reached
          openDate: open_date
          numberOfDays: number_of_days
          expiryDate: expiry_date
          daysTilExpired: days_til_expired
          userstatus {
            status
          }
          certificateBlockStatusValue: certificate_block_status_value
          prerequisitesCourseBlocks: prerequisites_course_blocks {
            hasUserCompleted: has_user_completed
          }
          scheduleReferenceInfo: schedule_reference_info {
            maxAllowedSubmissions: max_allowed_submissions
            openDate: open_date
            referenceId: reference_id
          }
        }
      }
      styleInfo: style_info {
        base {
          foregroundColor: foreground_color {
            alpha
            blue
            green
            red
          }
          backgroundColor: background_color {
            alpha
            blue
            green
            red
          }
          fontFamily: font_family
        }
        cardHeader: card_header {
          foregroundColor: foreground_color {
            alpha
            blue
            green
            red
          }
          backgroundColor: background_color {
            alpha
            blue
            green
            red
          }
          fontFamily: font_family
        }
      }
      isEnrolled: is_enrolled
      enrollmentInfo: enrollment_info {
        name
        start
        isActive: is_active
        end
      }
    }
    courseProgressMax: course_progress_max
    courseProgressValue: course_progress_value
    nextCourseBlocks: next_course_blocks {
      uuid
      title
      coverUri: cover_uri
      resource {
        uuid
        type
        description
      }
    }
    learnerCourseStatus: learner_course_status {
      status
      courseCertificateEndMessage: course_certificate_end_message
      courseCertificateUrl: course_certificate_url
      scheduleDetails: schedule_details {
        status
      }
    }
    isForumEnabled: is_forum_enabled
  }
}
    `;

/**
 * __useCourseViewerQuery__
 *
 * To run a query within a React component, call `useCourseViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseViewerQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *      scheduleUuid: // value for 'scheduleUuid'
 *   },
 * });
 */
export function useCourseViewerQuery(baseOptions: Apollo.QueryHookOptions<CourseViewerQuery, CourseViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseViewerQuery, CourseViewerQueryVariables>(CourseViewerDocument, options);
      }
export function useCourseViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseViewerQuery, CourseViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseViewerQuery, CourseViewerQueryVariables>(CourseViewerDocument, options);
        }
export type CourseViewerQueryHookResult = ReturnType<typeof useCourseViewerQuery>;
export type CourseViewerLazyQueryHookResult = ReturnType<typeof useCourseViewerLazyQuery>;
export type CourseViewerQueryResult = Apollo.QueryResult<CourseViewerQuery, CourseViewerQueryVariables>;
export const DirectoryViewScreenDocument = gql`
    query DirectoryViewScreen($path: String, $resourcesPath2: String) {
  directory_view_screen {
    directory(path: $path) {
      id
      path
    }
    id
    resources(path: $resourcesPath2) {
      id
      uuid
      name
      type
      subtype
      description
      coverUri: cover_uri
      content {
        ... on ResourceContentCourse {
          id
          courseDetails: course_details {
            course {
              allowedActions: allowed_actions
              uuid
              isEnrolled: is_enrolled
              enrolledSchedules: enrolled_schedules {
                isActive: is_active
                name
                uuid
                status
              }
            }
          }
        }
        ... on ResourceContentVideo {
          id
        }
        ... on ResourceContentPdf {
          id
        }
        ... on ResourceContentEpub {
          id
        }
        ... on ResourceContentBurislide {
          id
        }
        ... on ResourceContentBuribookWithActivity {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useDirectoryViewScreenQuery__
 *
 * To run a query within a React component, call `useDirectoryViewScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryViewScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryViewScreenQuery({
 *   variables: {
 *      path: // value for 'path'
 *      resourcesPath2: // value for 'resourcesPath2'
 *   },
 * });
 */
export function useDirectoryViewScreenQuery(baseOptions?: Apollo.QueryHookOptions<DirectoryViewScreenQuery, DirectoryViewScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryViewScreenQuery, DirectoryViewScreenQueryVariables>(DirectoryViewScreenDocument, options);
      }
export function useDirectoryViewScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryViewScreenQuery, DirectoryViewScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryViewScreenQuery, DirectoryViewScreenQueryVariables>(DirectoryViewScreenDocument, options);
        }
export type DirectoryViewScreenQueryHookResult = ReturnType<typeof useDirectoryViewScreenQuery>;
export type DirectoryViewScreenLazyQueryHookResult = ReturnType<typeof useDirectoryViewScreenLazyQuery>;
export type DirectoryViewScreenQueryResult = Apollo.QueryResult<DirectoryViewScreenQuery, DirectoryViewScreenQueryVariables>;
export const ForumTopicsDocument = gql`
    query ForumTopics($courseUuid: String!) {
  courseViewScreen: course_view_screen(course_uuid: $courseUuid) {
    forumTopics: forum_topics {
      uuid
      title
      createdBy: created_by
      createdByUserDetails: created_by_user_details {
        firstName: first_name
        lastName: last_name
        email
      }
      created
      comments {
        uuid
        isFlagged: is_flagged
      }
      isActive: is_active
      isUserAdmin: is_user_admin
    }
    course {
      isEnrolled: is_enrolled
      title
      coverUri: cover_uri
      styleInfo: style_info {
        base {
          backgroundColor: background_color {
            alpha
            blue
            green
            red
          }
          foregroundColor: foreground_color {
            alpha
            blue
            green
            red
          }
        }
      }
    }
    isUserForumAdmin: is_user_forum_admin
  }
}
    `;

/**
 * __useForumTopicsQuery__
 *
 * To run a query within a React component, call `useForumTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useForumTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForumTopicsQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *   },
 * });
 */
export function useForumTopicsQuery(baseOptions: Apollo.QueryHookOptions<ForumTopicsQuery, ForumTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForumTopicsQuery, ForumTopicsQueryVariables>(ForumTopicsDocument, options);
      }
export function useForumTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForumTopicsQuery, ForumTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForumTopicsQuery, ForumTopicsQueryVariables>(ForumTopicsDocument, options);
        }
export type ForumTopicsQueryHookResult = ReturnType<typeof useForumTopicsQuery>;
export type ForumTopicsLazyQueryHookResult = ReturnType<typeof useForumTopicsLazyQuery>;
export type ForumTopicsQueryResult = Apollo.QueryResult<ForumTopicsQuery, ForumTopicsQueryVariables>;
export const GbfSlideViewDocument = gql`
    query GbfSlideView($resourceDetailsInput: ResourceDetailsInput!) {
  resourceViewScreenV2: resource_view_screen_v2(
    resource_details_input: $resourceDetailsInput
  ) {
    resourceUuid: resource_uuid
    resource {
      id
      uuid
      type
      name
      content {
        __typename
        ... on ResourceContentBurislide {
          id
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            examItemUuid: exam_item_uuid
            examTimeslotUuid: exam_timeslot_uuid
            uris
            text
            imageUri: image_uri
            title
            examItem: exam_item {
              uuid
              title
              text
              type
              subtype
              section
              instructions
              mediaUrl: media_url
              orderId: order_id
              isGraded: is_graded
              shuffleChoices: shuffle_choices
              weight
              value
              hint
              explanation
              required
              maxAllowedResponses: max_allowed_responses
              showResults: show_results
              choices {
                uuid
                item
                shortInput: short_input
                longInput: long_input
                mediaUrl: media_url
                imageUrl: image_url
                audioUrl: audio_url
                orderId: order_id
                isCorrect: is_correct
              }
            }
            examSectionItems: exam_section_items {
              uuid
              title
              text
              type
              subtype
              section
              instructions
              mediaUrl: media_url
              orderId: order_id
              isGraded: is_graded
              shuffleChoices: shuffle_choices
              weight
              value
              hint
              explanation
              required
              maxAllowedResponses: max_allowed_responses
              showResults: show_results
              choices {
                uuid
                item
                shortInput: short_input
                longInput: long_input
                mediaUrl: media_url
                imageUrl: image_url
                audioUrl: audio_url
                orderId: order_id
                isCorrect: is_correct
              }
            }
            appearance {
              base {
                foregroundColor: foreground_color {
                  alpha
                  blue
                  green
                  red
                }
                backgroundColor: background_color {
                  alpha
                  blue
                  green
                  red
                }
                backgroundImage: background_image
                fontFamily: font_family
              }
            }
            examChoiceTriggerFlags: exam_choice_trigger_flags {
              examChoiceUuid: exam_choice_uuid
              flags {
                flagId: flag_id
                value
              }
            }
            examItemRequiredFlags: exam_item_required_flags {
              examItemUuid: exam_item_uuid
              flags {
                flagId: flag_id
                value
              }
            }
            isResultPageShown: is_result_page_shown
            resultPageImageUri: result_page_image_uri
            viewMode: view_mode
          }
          appearance {
            base {
              foregroundColor: foreground_color {
                alpha
                blue
                green
                red
              }
              backgroundColor: background_color {
                alpha
                blue
                green
                red
              }
              backgroundImage: background_image
              fontFamily: font_family
            }
          }
        }
        ... on ResourceContentBuribookWithActivity {
          id
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            examItemUuid: exam_item_uuid
            uris
            text
            imageUri: image_uri
            title
            examItem: exam_item {
              uuid
              title
              text
              type
              subtype
              section
              instructions
              mediaUrl: media_url
              orderId: order_id
              isGraded: is_graded
              shuffleChoices: shuffle_choices
              weight
              value
              hint
              explanation
              required
              maxAllowedResponses: max_allowed_responses
              showResults: show_results
              choices {
                uuid
                item
                shortInput: short_input
                longInput: long_input
                mediaUrl: media_url
                image_url
                audio_url
                orderId: order_id
                isCorrect: is_correct
              }
            }
            examSectionItems: exam_section_items {
              uuid
              title
              text
              type
              subtype
              section
              instructions
              mediaUrl: media_url
              orderId: order_id
              isGraded: is_graded
              shuffleChoices: shuffle_choices
              weight
              value
              hint
              explanation
              required
              maxAllowedResponses: max_allowed_responses
              showResults: show_results
              choices {
                uuid
                item
                shortInput: short_input
                longInput: long_input
                mediaUrl: media_url
                imageUrl: image_url
                audioUrl: audio_url
                orderId: order_id
                isCorrect: is_correct
              }
            }
            appearance {
              base {
                foregroundColor: foreground_color {
                  alpha
                  blue
                  green
                  red
                }
                backgroundColor: background_color {
                  alpha
                  blue
                  green
                  red
                }
                backgroundImage: background_image
                fontFamily: font_family
              }
            }
            examChoiceTriggerFlags: exam_choice_trigger_flags {
              examChoiceUuid: exam_choice_uuid
              flags {
                flagId: flag_id
                value
              }
            }
            examItemRequiredFlags: exam_item_required_flags {
              examItemUuid: exam_item_uuid
              flags {
                flagId: flag_id
                value
              }
            }
            isResultPageShown: is_result_page_shown
            resultPageImageUri: result_page_image_uri
            viewMode: view_mode
          }
          appearance {
            base {
              foregroundColor: foreground_color {
                alpha
                blue
                green
                red
              }
              backgroundColor: background_color {
                alpha
                blue
                green
                red
              }
              backgroundImage: background_image
              fontFamily: font_family
            }
          }
        }
      }
      course_block_uuid
    }
    courseBlock: course_block {
      scheduleReferenceInfo: schedule_reference_info {
        referenceId: reference_id
        schedule
      }
      completeOnFinal: complete_on_final
    }
  }
}
    `;

/**
 * __useGbfSlideViewQuery__
 *
 * To run a query within a React component, call `useGbfSlideViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGbfSlideViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGbfSlideViewQuery({
 *   variables: {
 *      resourceDetailsInput: // value for 'resourceDetailsInput'
 *   },
 * });
 */
export function useGbfSlideViewQuery(baseOptions: Apollo.QueryHookOptions<GbfSlideViewQuery, GbfSlideViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GbfSlideViewQuery, GbfSlideViewQueryVariables>(GbfSlideViewDocument, options);
      }
export function useGbfSlideViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GbfSlideViewQuery, GbfSlideViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GbfSlideViewQuery, GbfSlideViewQueryVariables>(GbfSlideViewDocument, options);
        }
export type GbfSlideViewQueryHookResult = ReturnType<typeof useGbfSlideViewQuery>;
export type GbfSlideViewLazyQueryHookResult = ReturnType<typeof useGbfSlideViewLazyQuery>;
export type GbfSlideViewQueryResult = Apollo.QueryResult<GbfSlideViewQuery, GbfSlideViewQueryVariables>;
export const GetSubmissionUuidDocument = gql`
    mutation GetSubmissionUuid($examTimeslotUuid: String!, $blockUuid: String, $submission: ExamSubmissionInputV2, $courseScheduleUuid: String) {
  assessmentSubmitV2: assessment_submit_v2(
    exam_timeslot_uuid: $examTimeslotUuid
    block_uuid: $blockUuid
    submission: $submission
    course_schedule_uuid: $courseScheduleUuid
  ) {
    courseBlockSubmissionResult: course_block_submission_result {
      uuid
    }
    submissionResult: submission_result {
      uuid
    }
  }
}
    `;
export type GetSubmissionUuidMutationFn = Apollo.MutationFunction<GetSubmissionUuidMutation, GetSubmissionUuidMutationVariables>;

/**
 * __useGetSubmissionUuidMutation__
 *
 * To run a mutation, you first call `useGetSubmissionUuidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionUuidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSubmissionUuidMutation, { data, loading, error }] = useGetSubmissionUuidMutation({
 *   variables: {
 *      examTimeslotUuid: // value for 'examTimeslotUuid'
 *      blockUuid: // value for 'blockUuid'
 *      submission: // value for 'submission'
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useGetSubmissionUuidMutation(baseOptions?: Apollo.MutationHookOptions<GetSubmissionUuidMutation, GetSubmissionUuidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSubmissionUuidMutation, GetSubmissionUuidMutationVariables>(GetSubmissionUuidDocument, options);
      }
export type GetSubmissionUuidMutationHookResult = ReturnType<typeof useGetSubmissionUuidMutation>;
export type GetSubmissionUuidMutationResult = Apollo.MutationResult<GetSubmissionUuidMutation>;
export type GetSubmissionUuidMutationOptions = Apollo.BaseMutationOptions<GetSubmissionUuidMutation, GetSubmissionUuidMutationVariables>;
export const GetGradesDocument = gql`
    query GetGrades($status: String) {
  coursesAndCertificationScreen: courses_and_certification_screen {
    learnerCourseStatuses: learner_course_statuses(status: $status) {
      status
      courseCertificateUrl: course_certificate_url
      courseDetails: course_details {
        coverUri: cover_uri
        title
        uuid
        isEnrolled: is_enrolled
      }
      scheduleDetails: schedule_details {
        uuid
        name
        isActive: is_active
        start
        end
        status
      }
      sectionStatuses: section_statuses {
        blockStatuses: block_statuses {
          blockDetails: block_details {
            title
            requiredForCertificate: required_for_certificate
          }
          status
          scoreMax: score_max
          scoreRaw: score_raw
        }
      }
    }
  }
}
    `;

/**
 * __useGetGradesQuery__
 *
 * To run a query within a React component, call `useGetGradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradesQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetGradesQuery(baseOptions?: Apollo.QueryHookOptions<GetGradesQuery, GetGradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGradesQuery, GetGradesQueryVariables>(GetGradesDocument, options);
      }
export function useGetGradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGradesQuery, GetGradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGradesQuery, GetGradesQueryVariables>(GetGradesDocument, options);
        }
export type GetGradesQueryHookResult = ReturnType<typeof useGetGradesQuery>;
export type GetGradesLazyQueryHookResult = ReturnType<typeof useGetGradesLazyQuery>;
export type GetGradesQueryResult = Apollo.QueryResult<GetGradesQuery, GetGradesQueryVariables>;
export const HomeScreenDocument = gql`
    query HomeScreen {
  home_screen {
    initial_slug
  }
}
    `;

/**
 * __useHomeScreenQuery__
 *
 * To run a query within a React component, call `useHomeScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeScreenQuery(baseOptions?: Apollo.QueryHookOptions<HomeScreenQuery, HomeScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeScreenQuery, HomeScreenQueryVariables>(HomeScreenDocument, options);
      }
export function useHomeScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeScreenQuery, HomeScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeScreenQuery, HomeScreenQueryVariables>(HomeScreenDocument, options);
        }
export type HomeScreenQueryHookResult = ReturnType<typeof useHomeScreenQuery>;
export type HomeScreenLazyQueryHookResult = ReturnType<typeof useHomeScreenLazyQuery>;
export type HomeScreenQueryResult = Apollo.QueryResult<HomeScreenQuery, HomeScreenQueryVariables>;
export const GetLoginScreenDocument = gql`
    query GetLoginScreen($domain: String) {
  loginScreen: login_screen(domain: $domain) {
    castId: cast_id
    bannerUrl: banner_url
    heroUrl: hero_url
    navUrl: nav_url
    clientId: client_id
    faviconUrl: favicon_url
    loginIconUrl: login_icon_url
    cast {
      attributes {
        allowGuestLogin: allow_guest_login
        defaultLoginAsGuest: default_login_as_guest
      }
    }
    isSignupEnabled: is_signup_enabled
  }
}
    `;

/**
 * __useGetLoginScreenQuery__
 *
 * To run a query within a React component, call `useGetLoginScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoginScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoginScreenQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetLoginScreenQuery(baseOptions?: Apollo.QueryHookOptions<GetLoginScreenQuery, GetLoginScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoginScreenQuery, GetLoginScreenQueryVariables>(GetLoginScreenDocument, options);
      }
export function useGetLoginScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoginScreenQuery, GetLoginScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoginScreenQuery, GetLoginScreenQueryVariables>(GetLoginScreenDocument, options);
        }
export type GetLoginScreenQueryHookResult = ReturnType<typeof useGetLoginScreenQuery>;
export type GetLoginScreenLazyQueryHookResult = ReturnType<typeof useGetLoginScreenLazyQuery>;
export type GetLoginScreenQueryResult = Apollo.QueryResult<GetLoginScreenQuery, GetLoginScreenQueryVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const CardBatchStatusDocument = gql`
    query CardBatchStatus($courseUuid: ID!) {
  courseProgressScreen: course_progress_screen(course_uuid: $courseUuid) {
    course {
      enrolledSchedules: enrolled_schedules {
        uuid
        status
      }
    }
  }
}
    `;

/**
 * __useCardBatchStatusQuery__
 *
 * To run a query within a React component, call `useCardBatchStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardBatchStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardBatchStatusQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *   },
 * });
 */
export function useCardBatchStatusQuery(baseOptions: Apollo.QueryHookOptions<CardBatchStatusQuery, CardBatchStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardBatchStatusQuery, CardBatchStatusQueryVariables>(CardBatchStatusDocument, options);
      }
export function useCardBatchStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardBatchStatusQuery, CardBatchStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardBatchStatusQuery, CardBatchStatusQueryVariables>(CardBatchStatusDocument, options);
        }
export type CardBatchStatusQueryHookResult = ReturnType<typeof useCardBatchStatusQuery>;
export type CardBatchStatusLazyQueryHookResult = ReturnType<typeof useCardBatchStatusLazyQuery>;
export type CardBatchStatusQueryResult = Apollo.QueryResult<CardBatchStatusQuery, CardBatchStatusQueryVariables>;
export const LearnerCourseStatusDocument = gql`
    query LearnerCourseStatus($status: String) {
  coursesAndCertificationScreen: courses_and_certification_screen {
    learnerCourseStatuses: learner_course_statuses(status: $status) {
      status
      courseCertificateUrl: course_certificate_url
      courseDetails: course_details {
        coverUri: cover_uri
        title
        uuid
      }
      scheduleDetails: schedule_details {
        uuid
        name
        isActive: is_active
        start
        end
        status
      }
    }
  }
}
    `;

/**
 * __useLearnerCourseStatusQuery__
 *
 * To run a query within a React component, call `useLearnerCourseStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnerCourseStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnerCourseStatusQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useLearnerCourseStatusQuery(baseOptions?: Apollo.QueryHookOptions<LearnerCourseStatusQuery, LearnerCourseStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearnerCourseStatusQuery, LearnerCourseStatusQueryVariables>(LearnerCourseStatusDocument, options);
      }
export function useLearnerCourseStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearnerCourseStatusQuery, LearnerCourseStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearnerCourseStatusQuery, LearnerCourseStatusQueryVariables>(LearnerCourseStatusDocument, options);
        }
export type LearnerCourseStatusQueryHookResult = ReturnType<typeof useLearnerCourseStatusQuery>;
export type LearnerCourseStatusLazyQueryHookResult = ReturnType<typeof useLearnerCourseStatusLazyQuery>;
export type LearnerCourseStatusQueryResult = Apollo.QueryResult<LearnerCourseStatusQuery, LearnerCourseStatusQueryVariables>;
export const CastBlocksDocument = gql`
    query CastBlocks($slug: String!) {
  castBlockScreen: cast_block_screen(slug: $slug) {
    id
    castBlocks: cast_blocks {
      id
      attributes {
        type
        properties {
          ... on CastBlockPropertiesButtonSearch {
            id
            _dummy
            title
            appearance {
              base {
                backgroundColor: background_color {
                  alpha
                  blue
                  green
                  red
                }
                backgroundImage: background_image
                fontFamily: font_family
                foregroundColor: foreground_color {
                  alpha
                  blue
                  green
                  red
                }
              }
            }
          }
          ... on CastBlockPropertiesCarousel {
            id
            items {
              src
              image
              url
            }
          }
          ... on CastBlockPropertiesCatalog {
            id
            uuid
          }
          ... on CastBlockPropertiesDirectory {
            id
            basePath: base_path
            directory {
              id
              path
            }
            resources {
              id
              type
              subtype
              description
              name
              coverUri: cover_uri
              uuid
            }
          }
          ... on CastBlockPropertiesMarkdown {
            id
            content
          }
          ... on CastBlockPropertiesEmbed {
            id
            url
          }
          ... on CastBlockPropertiesCourseStatus {
            id
            heading
          }
          ... on CastBlockPropertiesCategory {
            collectionsUuid: collection_uuids
            collections {
              id
              coverUri: cover_uri
              description
              name
              uuid
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCastBlocksQuery__
 *
 * To run a query within a React component, call `useCastBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCastBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCastBlocksQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCastBlocksQuery(baseOptions: Apollo.QueryHookOptions<CastBlocksQuery, CastBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CastBlocksQuery, CastBlocksQueryVariables>(CastBlocksDocument, options);
      }
export function useCastBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CastBlocksQuery, CastBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CastBlocksQuery, CastBlocksQueryVariables>(CastBlocksDocument, options);
        }
export type CastBlocksQueryHookResult = ReturnType<typeof useCastBlocksQuery>;
export type CastBlocksLazyQueryHookResult = ReturnType<typeof useCastBlocksLazyQuery>;
export type CastBlocksQueryResult = Apollo.QueryResult<CastBlocksQuery, CastBlocksQueryVariables>;
export const SearchSlugDocument = gql`
    query SearchSlug {
  navbar {
    seachSlug: search_slug
  }
}
    `;

/**
 * __useSearchSlugQuery__
 *
 * To run a query within a React component, call `useSearchSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSlugQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchSlugQuery(baseOptions?: Apollo.QueryHookOptions<SearchSlugQuery, SearchSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSlugQuery, SearchSlugQueryVariables>(SearchSlugDocument, options);
      }
export function useSearchSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSlugQuery, SearchSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSlugQuery, SearchSlugQueryVariables>(SearchSlugDocument, options);
        }
export type SearchSlugQueryHookResult = ReturnType<typeof useSearchSlugQuery>;
export type SearchSlugLazyQueryHookResult = ReturnType<typeof useSearchSlugLazyQuery>;
export type SearchSlugQueryResult = Apollo.QueryResult<SearchSlugQuery, SearchSlugQueryVariables>;
export const GetSearchScreenDocument = gql`
    query GetSearchScreen($q: String!, $limit: Int, $offset: Int) {
  search_screen(q: $q, limit: $limit, offset: $offset) {
    resources {
      uuid
      name
      type
      subtype
      cover_uri
      description
    }
  }
}
    `;

/**
 * __useGetSearchScreenQuery__
 *
 * To run a query within a React component, call `useGetSearchScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchScreenQuery({
 *   variables: {
 *      q: // value for 'q'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSearchScreenQuery(baseOptions: Apollo.QueryHookOptions<GetSearchScreenQuery, GetSearchScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchScreenQuery, GetSearchScreenQueryVariables>(GetSearchScreenDocument, options);
      }
export function useGetSearchScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchScreenQuery, GetSearchScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchScreenQuery, GetSearchScreenQueryVariables>(GetSearchScreenDocument, options);
        }
export type GetSearchScreenQueryHookResult = ReturnType<typeof useGetSearchScreenQuery>;
export type GetSearchScreenLazyQueryHookResult = ReturnType<typeof useGetSearchScreenLazyQuery>;
export type GetSearchScreenQueryResult = Apollo.QueryResult<GetSearchScreenQuery, GetSearchScreenQueryVariables>;
export const SearchScreenDocument = gql`
    query SearchScreen($q: String!, $limit: Int, $offset: Int, $resourceType: String) {
  searchScreen: search_screen {
    resources(resource_type: $resourceType, q: $q, limit: $limit, offset: $offset) {
      uuid
      name
      type
      description
      coverUri: cover_uri
    }
  }
}
    `;

/**
 * __useSearchScreenQuery__
 *
 * To run a query within a React component, call `useSearchScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchScreenQuery({
 *   variables: {
 *      q: // value for 'q'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useSearchScreenQuery(baseOptions: Apollo.QueryHookOptions<SearchScreenQuery, SearchScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchScreenQuery, SearchScreenQueryVariables>(SearchScreenDocument, options);
      }
export function useSearchScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchScreenQuery, SearchScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchScreenQuery, SearchScreenQueryVariables>(SearchScreenDocument, options);
        }
export type SearchScreenQueryHookResult = ReturnType<typeof useSearchScreenQuery>;
export type SearchScreenLazyQueryHookResult = ReturnType<typeof useSearchScreenLazyQuery>;
export type SearchScreenQueryResult = Apollo.QueryResult<SearchScreenQuery, SearchScreenQueryVariables>;
export const User_SubscriptionDocument = gql`
    query User_subscription($userSubscriptionId: ID!) {
  subscriptionScreen: subscription_screen {
    userSubscription: user_subscription(user_subscription_id: $userSubscriptionId) {
      uuid
      onTrial: on_trial
      isActive: is_active
      cancelled
      expires
      plan {
        uuid
        name
        trialPeriod: trial_period
        trialUnit: trial_unit
        planPeriod: plan_period
        planUnit: plan_unit
        isRecurring: is_recurring
        isActive: is_active
        product {
          id
          title
          slug
          description
        }
      }
      invoiceReceipts: invoice_receipts {
        uuid
        charge {
          amount
          status
          modified
        }
      }
    }
  }
}
    `;

/**
 * __useUser_SubscriptionQuery__
 *
 * To run a query within a React component, call `useUser_SubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUser_SubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUser_SubscriptionQuery({
 *   variables: {
 *      userSubscriptionId: // value for 'userSubscriptionId'
 *   },
 * });
 */
export function useUser_SubscriptionQuery(baseOptions: Apollo.QueryHookOptions<User_SubscriptionQuery, User_SubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<User_SubscriptionQuery, User_SubscriptionQueryVariables>(User_SubscriptionDocument, options);
      }
export function useUser_SubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<User_SubscriptionQuery, User_SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<User_SubscriptionQuery, User_SubscriptionQueryVariables>(User_SubscriptionDocument, options);
        }
export type User_SubscriptionQueryHookResult = ReturnType<typeof useUser_SubscriptionQuery>;
export type User_SubscriptionLazyQueryHookResult = ReturnType<typeof useUser_SubscriptionLazyQuery>;
export type User_SubscriptionQueryResult = Apollo.QueryResult<User_SubscriptionQuery, User_SubscriptionQueryVariables>;
export const Subscription_PlansDocument = gql`
    query Subscription_plans {
  subscriptionScreen: subscription_screen {
    subscriptionPlans: subscription_plans {
      name
      price
      planPeriod: plan_period
      planUnit: plan_unit
      productId: product_id
      subscriptionPlanId: subscription_plan_id
    }
  }
}
    `;

/**
 * __useSubscription_PlansQuery__
 *
 * To run a query within a React component, call `useSubscription_PlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscription_PlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscription_PlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscription_PlansQuery(baseOptions?: Apollo.QueryHookOptions<Subscription_PlansQuery, Subscription_PlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Subscription_PlansQuery, Subscription_PlansQueryVariables>(Subscription_PlansDocument, options);
      }
export function useSubscription_PlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Subscription_PlansQuery, Subscription_PlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Subscription_PlansQuery, Subscription_PlansQueryVariables>(Subscription_PlansDocument, options);
        }
export type Subscription_PlansQueryHookResult = ReturnType<typeof useSubscription_PlansQuery>;
export type Subscription_PlansLazyQueryHookResult = ReturnType<typeof useSubscription_PlansLazyQuery>;
export type Subscription_PlansQueryResult = Apollo.QueryResult<Subscription_PlansQuery, Subscription_PlansQueryVariables>;
export const Subscription_ChangeDocument = gql`
    mutation Subscription_change($userSubscriptionId: ID!, $subscriptionPlanIdTo: ID!) {
  subscription_change(
    user_subscription_id: $userSubscriptionId
    subscription_plan_id_to: $subscriptionPlanIdTo
  )
}
    `;
export type Subscription_ChangeMutationFn = Apollo.MutationFunction<Subscription_ChangeMutation, Subscription_ChangeMutationVariables>;

/**
 * __useSubscription_ChangeMutation__
 *
 * To run a mutation, you first call `useSubscription_ChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscription_ChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionChangeMutation, { data, loading, error }] = useSubscription_ChangeMutation({
 *   variables: {
 *      userSubscriptionId: // value for 'userSubscriptionId'
 *      subscriptionPlanIdTo: // value for 'subscriptionPlanIdTo'
 *   },
 * });
 */
export function useSubscription_ChangeMutation(baseOptions?: Apollo.MutationHookOptions<Subscription_ChangeMutation, Subscription_ChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Subscription_ChangeMutation, Subscription_ChangeMutationVariables>(Subscription_ChangeDocument, options);
      }
export type Subscription_ChangeMutationHookResult = ReturnType<typeof useSubscription_ChangeMutation>;
export type Subscription_ChangeMutationResult = Apollo.MutationResult<Subscription_ChangeMutation>;
export type Subscription_ChangeMutationOptions = Apollo.BaseMutationOptions<Subscription_ChangeMutation, Subscription_ChangeMutationVariables>;
export const Subscription_CancelDocument = gql`
    mutation Subscription_cancel($userSubscriptionId: ID!) {
  subscription_cancel(user_subscription_id: $userSubscriptionId) {
    uuid
  }
}
    `;
export type Subscription_CancelMutationFn = Apollo.MutationFunction<Subscription_CancelMutation, Subscription_CancelMutationVariables>;

/**
 * __useSubscription_CancelMutation__
 *
 * To run a mutation, you first call `useSubscription_CancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscription_CancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionCancelMutation, { data, loading, error }] = useSubscription_CancelMutation({
 *   variables: {
 *      userSubscriptionId: // value for 'userSubscriptionId'
 *   },
 * });
 */
export function useSubscription_CancelMutation(baseOptions?: Apollo.MutationHookOptions<Subscription_CancelMutation, Subscription_CancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Subscription_CancelMutation, Subscription_CancelMutationVariables>(Subscription_CancelDocument, options);
      }
export type Subscription_CancelMutationHookResult = ReturnType<typeof useSubscription_CancelMutation>;
export type Subscription_CancelMutationResult = Apollo.MutationResult<Subscription_CancelMutation>;
export type Subscription_CancelMutationOptions = Apollo.BaseMutationOptions<Subscription_CancelMutation, Subscription_CancelMutationVariables>;
export const Subscription_UncancelDocument = gql`
    mutation Subscription_uncancel($userSubscriptionId: ID!) {
  subscription_uncancel(user_subscription_id: $userSubscriptionId)
}
    `;
export type Subscription_UncancelMutationFn = Apollo.MutationFunction<Subscription_UncancelMutation, Subscription_UncancelMutationVariables>;

/**
 * __useSubscription_UncancelMutation__
 *
 * To run a mutation, you first call `useSubscription_UncancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscription_UncancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionUncancelMutation, { data, loading, error }] = useSubscription_UncancelMutation({
 *   variables: {
 *      userSubscriptionId: // value for 'userSubscriptionId'
 *   },
 * });
 */
export function useSubscription_UncancelMutation(baseOptions?: Apollo.MutationHookOptions<Subscription_UncancelMutation, Subscription_UncancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Subscription_UncancelMutation, Subscription_UncancelMutationVariables>(Subscription_UncancelDocument, options);
      }
export type Subscription_UncancelMutationHookResult = ReturnType<typeof useSubscription_UncancelMutation>;
export type Subscription_UncancelMutationResult = Apollo.MutationResult<Subscription_UncancelMutation>;
export type Subscription_UncancelMutationOptions = Apollo.BaseMutationOptions<Subscription_UncancelMutation, Subscription_UncancelMutationVariables>;
export const Subscription_ScreenDocument = gql`
    query Subscription_screen {
  subscriptionScreen: subscription_screen {
    subscriptionPlans: subscription_plans {
      name
      price
      planPeriod: plan_period
      planUnit: plan_unit
      productId: product_id
      subscriptionPlanId: subscription_plan_id
    }
    userSubscriptions: user_subscriptions {
      uuid
      onTrial: on_trial
      isActive: is_active
      expires
      cancelled
      plan {
        uuid
        name
        trialPeriod: trial_period
        trialUnit: trial_unit
        planPeriod: plan_period
        planUnit: plan_unit
        isRecurring: is_recurring
        isActive: is_active
        product {
          id
          title
          slug
          description
        }
      }
    }
  }
}
    `;

/**
 * __useSubscription_ScreenQuery__
 *
 * To run a query within a React component, call `useSubscription_ScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscription_ScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscription_ScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscription_ScreenQuery(baseOptions?: Apollo.QueryHookOptions<Subscription_ScreenQuery, Subscription_ScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Subscription_ScreenQuery, Subscription_ScreenQueryVariables>(Subscription_ScreenDocument, options);
      }
export function useSubscription_ScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Subscription_ScreenQuery, Subscription_ScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Subscription_ScreenQuery, Subscription_ScreenQueryVariables>(Subscription_ScreenDocument, options);
        }
export type Subscription_ScreenQueryHookResult = ReturnType<typeof useSubscription_ScreenQuery>;
export type Subscription_ScreenLazyQueryHookResult = ReturnType<typeof useSubscription_ScreenLazyQuery>;
export type Subscription_ScreenQueryResult = Apollo.QueryResult<Subscription_ScreenQuery, Subscription_ScreenQueryVariables>;
export const TopicViewDocument = gql`
    query TopicView($courseUuid: String!, $forumTopicUuid: ID) {
  courseViewScreen: course_view_screen(course_uuid: $courseUuid) {
    forumTopic: forum_topic(forum_topic_uuid: $forumTopicUuid) {
      uuid
      text
      title
    }
  }
}
    `;

/**
 * __useTopicViewQuery__
 *
 * To run a query within a React component, call `useTopicViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicViewQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *      forumTopicUuid: // value for 'forumTopicUuid'
 *   },
 * });
 */
export function useTopicViewQuery(baseOptions: Apollo.QueryHookOptions<TopicViewQuery, TopicViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicViewQuery, TopicViewQueryVariables>(TopicViewDocument, options);
      }
export function useTopicViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicViewQuery, TopicViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicViewQuery, TopicViewQueryVariables>(TopicViewDocument, options);
        }
export type TopicViewQueryHookResult = ReturnType<typeof useTopicViewQuery>;
export type TopicViewLazyQueryHookResult = ReturnType<typeof useTopicViewLazyQuery>;
export type TopicViewQueryResult = Apollo.QueryResult<TopicViewQuery, TopicViewQueryVariables>;
export const UserUuidDocument = gql`
    query UserUuid {
  accountAndUserDetailsScreen: account_and_user_details_screen {
    userProfile: user_profile {
      givenName: given_name
      familyName: family_name
    }
  }
}
    `;

/**
 * __useUserUuidQuery__
 *
 * To run a query within a React component, call `useUserUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUuidQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserUuidQuery(baseOptions?: Apollo.QueryHookOptions<UserUuidQuery, UserUuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserUuidQuery, UserUuidQueryVariables>(UserUuidDocument, options);
      }
export function useUserUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserUuidQuery, UserUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserUuidQuery, UserUuidQueryVariables>(UserUuidDocument, options);
        }
export type UserUuidQueryHookResult = ReturnType<typeof useUserUuidQuery>;
export type UserUuidLazyQueryHookResult = ReturnType<typeof useUserUuidLazyQuery>;
export type UserUuidQueryResult = Apollo.QueryResult<UserUuidQuery, UserUuidQueryVariables>;
export const CompletedDomainsDocument = gql`
    query CompletedDomains {
  tisScreen: tis_screen {
    completedBlockIndicator: completed_block_indicator {
      domains {
        children {
          totalPoints: total_points
          name
          indicators {
            name
            points
            displayUnitName: display_unit_name
          }
        }
        indicators {
          name
          points
          displayUnitName: display_unit_name
        }
        name
        totalPoints: total_points
      }
      totalPoints: total_points
    }
  }
}
    `;

/**
 * __useCompletedDomainsQuery__
 *
 * To run a query within a React component, call `useCompletedDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompletedDomainsQuery(baseOptions?: Apollo.QueryHookOptions<CompletedDomainsQuery, CompletedDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedDomainsQuery, CompletedDomainsQueryVariables>(CompletedDomainsDocument, options);
      }
export function useCompletedDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedDomainsQuery, CompletedDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedDomainsQuery, CompletedDomainsQueryVariables>(CompletedDomainsDocument, options);
        }
export type CompletedDomainsQueryHookResult = ReturnType<typeof useCompletedDomainsQuery>;
export type CompletedDomainsLazyQueryHookResult = ReturnType<typeof useCompletedDomainsLazyQuery>;
export type CompletedDomainsQueryResult = Apollo.QueryResult<CompletedDomainsQuery, CompletedDomainsQueryVariables>;
export const CertificateViewScreenDocument = gql`
    query CertificateViewScreen($courseUuid: String!, $scheduleUuid: String) {
  courseViewScreen: course_view_screen(
    course_uuid: $courseUuid
    schedule_uuid: $scheduleUuid
  ) {
    learnerCourseStatus: learner_course_status {
      courseCertificateEndMessage: course_certificate_end_message
      courseCertificateUrl: course_certificate_url
      status
    }
  }
}
    `;

/**
 * __useCertificateViewScreenQuery__
 *
 * To run a query within a React component, call `useCertificateViewScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateViewScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateViewScreenQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *      scheduleUuid: // value for 'scheduleUuid'
 *   },
 * });
 */
export function useCertificateViewScreenQuery(baseOptions: Apollo.QueryHookOptions<CertificateViewScreenQuery, CertificateViewScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CertificateViewScreenQuery, CertificateViewScreenQueryVariables>(CertificateViewScreenDocument, options);
      }
export function useCertificateViewScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CertificateViewScreenQuery, CertificateViewScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CertificateViewScreenQuery, CertificateViewScreenQueryVariables>(CertificateViewScreenDocument, options);
        }
export type CertificateViewScreenQueryHookResult = ReturnType<typeof useCertificateViewScreenQuery>;
export type CertificateViewScreenLazyQueryHookResult = ReturnType<typeof useCertificateViewScreenLazyQuery>;
export type CertificateViewScreenQueryResult = Apollo.QueryResult<CertificateViewScreenQuery, CertificateViewScreenQueryVariables>;
export const ResourceViewScreenDocument = gql`
    query resourceViewScreen($resourceUuid: ID!) {
  resourceViewScreen: resource_view_screen(resource_uuid: $resourceUuid) {
    resource_uuid
    resource {
      uuid
      type
      subtype
      name
      content {
        ... on ResourceContentXApi {
          uri
        }
        ... on ResourceContentLink {
          uri
        }
        ... on ResourceContentText {
          text
        }
        ... on ResourceContentEmbed {
          uri
        }
        ... on ResourceContentVideo {
          uri
          hlsUri: hls_uri
          dashUri: dash_uri
          tracks {
            uri
          }
          contentType: content_type
          videoDescription: video_description
          subtitleClass: subtitle_class
        }
        ... on ResourceContentAssessment {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
        }
        ... on ResourceContentCourse {
          courseDetails: course_details {
            courseUuid: course_uuid
          }
        }
        ... on ResourceContentBurislide {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
        }
        ... on ResourceContentBuribookWithActivity {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
        }
        ... on ResourceContentYoutube {
          uri
          videoId: video_id
        }
        ... on ResourceContentAudio {
          uri
          contentType: content_type
        }
        ... on ResourceContentEpub {
          uri
        }
        ... on ResourceContentFile {
          uri
          previewGraphicUri: preview_graphic_uri
        }
        ... on ResourceContentPdf {
          uri
          contentType: content_type
          previewGraphicUri: preview_graphic_uri
        }
      }
    }
  }
}
    `;

/**
 * __useResourceViewScreenQuery__
 *
 * To run a query within a React component, call `useResourceViewScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewScreenQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *   },
 * });
 */
export function useResourceViewScreenQuery(baseOptions: Apollo.QueryHookOptions<ResourceViewScreenQuery, ResourceViewScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewScreenQuery, ResourceViewScreenQueryVariables>(ResourceViewScreenDocument, options);
      }
export function useResourceViewScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewScreenQuery, ResourceViewScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewScreenQuery, ResourceViewScreenQueryVariables>(ResourceViewScreenDocument, options);
        }
export type ResourceViewScreenQueryHookResult = ReturnType<typeof useResourceViewScreenQuery>;
export type ResourceViewScreenLazyQueryHookResult = ReturnType<typeof useResourceViewScreenLazyQuery>;
export type ResourceViewScreenQueryResult = Apollo.QueryResult<ResourceViewScreenQuery, ResourceViewScreenQueryVariables>;
export const ResourceStartDocument = gql`
    mutation ResourceStart($resourceUuid: ID!, $courseBlockUuid: String, $courseScheduleUuid: String) {
  resource_start(
    resource_uuid: $resourceUuid
    course_block_uuid: $courseBlockUuid
    course_schedule_uuid: $courseScheduleUuid
  )
}
    `;
export type ResourceStartMutationFn = Apollo.MutationFunction<ResourceStartMutation, ResourceStartMutationVariables>;

/**
 * __useResourceStartMutation__
 *
 * To run a mutation, you first call `useResourceStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResourceStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resourceStartMutation, { data, loading, error }] = useResourceStartMutation({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *      courseBlockUuid: // value for 'courseBlockUuid'
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useResourceStartMutation(baseOptions?: Apollo.MutationHookOptions<ResourceStartMutation, ResourceStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResourceStartMutation, ResourceStartMutationVariables>(ResourceStartDocument, options);
      }
export type ResourceStartMutationHookResult = ReturnType<typeof useResourceStartMutation>;
export type ResourceStartMutationResult = Apollo.MutationResult<ResourceStartMutation>;
export type ResourceStartMutationOptions = Apollo.BaseMutationOptions<ResourceStartMutation, ResourceStartMutationVariables>;
export const ResourceEndDocument = gql`
    mutation ResourceEnd($resourceUuid: ID!, $courseBlockUuid: String, $courseScheduleUuid: String) {
  resource_end(
    resource_uuid: $resourceUuid
    course_block_uuid: $courseBlockUuid
    course_schedule_uuid: $courseScheduleUuid
  ) {
    next_course_blocks {
      uuid
      title
      resource {
        uuid
      }
      coverUri: cover_uri
    }
  }
}
    `;
export type ResourceEndMutationFn = Apollo.MutationFunction<ResourceEndMutation, ResourceEndMutationVariables>;

/**
 * __useResourceEndMutation__
 *
 * To run a mutation, you first call `useResourceEndMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResourceEndMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resourceEndMutation, { data, loading, error }] = useResourceEndMutation({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *      courseBlockUuid: // value for 'courseBlockUuid'
 *      courseScheduleUuid: // value for 'courseScheduleUuid'
 *   },
 * });
 */
export function useResourceEndMutation(baseOptions?: Apollo.MutationHookOptions<ResourceEndMutation, ResourceEndMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResourceEndMutation, ResourceEndMutationVariables>(ResourceEndDocument, options);
      }
export type ResourceEndMutationHookResult = ReturnType<typeof useResourceEndMutation>;
export type ResourceEndMutationResult = Apollo.MutationResult<ResourceEndMutation>;
export type ResourceEndMutationOptions = Apollo.BaseMutationOptions<ResourceEndMutation, ResourceEndMutationVariables>;
export const RecipeCookDocument = gql`
    mutation RecipeCook($ingredient: RecipeIngredients) {
  recipe_cook(ingredient: $ingredient)
}
    `;
export type RecipeCookMutationFn = Apollo.MutationFunction<RecipeCookMutation, RecipeCookMutationVariables>;

/**
 * __useRecipeCookMutation__
 *
 * To run a mutation, you first call `useRecipeCookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecipeCookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recipeCookMutation, { data, loading, error }] = useRecipeCookMutation({
 *   variables: {
 *      ingredient: // value for 'ingredient'
 *   },
 * });
 */
export function useRecipeCookMutation(baseOptions?: Apollo.MutationHookOptions<RecipeCookMutation, RecipeCookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecipeCookMutation, RecipeCookMutationVariables>(RecipeCookDocument, options);
      }
export type RecipeCookMutationHookResult = ReturnType<typeof useRecipeCookMutation>;
export type RecipeCookMutationResult = Apollo.MutationResult<RecipeCookMutation>;
export type RecipeCookMutationOptions = Apollo.BaseMutationOptions<RecipeCookMutation, RecipeCookMutationVariables>;
export const RecipeCookMultipleDocument = gql`
    mutation RecipeCookMultiple($ingredients: [RecipeIngredients]) {
  recipe_cook_multiple(ingredients: $ingredients)
}
    `;
export type RecipeCookMultipleMutationFn = Apollo.MutationFunction<RecipeCookMultipleMutation, RecipeCookMultipleMutationVariables>;

/**
 * __useRecipeCookMultipleMutation__
 *
 * To run a mutation, you first call `useRecipeCookMultipleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecipeCookMultipleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recipeCookMultipleMutation, { data, loading, error }] = useRecipeCookMultipleMutation({
 *   variables: {
 *      ingredients: // value for 'ingredients'
 *   },
 * });
 */
export function useRecipeCookMultipleMutation(baseOptions?: Apollo.MutationHookOptions<RecipeCookMultipleMutation, RecipeCookMultipleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecipeCookMultipleMutation, RecipeCookMultipleMutationVariables>(RecipeCookMultipleDocument, options);
      }
export type RecipeCookMultipleMutationHookResult = ReturnType<typeof useRecipeCookMultipleMutation>;
export type RecipeCookMultipleMutationResult = Apollo.MutationResult<RecipeCookMultipleMutation>;
export type RecipeCookMultipleMutationOptions = Apollo.BaseMutationOptions<RecipeCookMultipleMutation, RecipeCookMultipleMutationVariables>;
export const ResourceViewScreenWithReferenceInfoAndUserStatusDocument = gql`
    query resourceViewScreenWithReferenceInfoAndUserStatus($resourceUuid: ID!, $courseBlockUuid: String) {
  resourceViewScreen: resource_view_screen(
    resource_uuid: $resourceUuid
    course_block_uuid: $courseBlockUuid
  ) {
    resourceUuid: resource_uuid
    resource {
      uuid
      type
      subtype
      name
      content {
        ... on ResourceContentXApi {
          uri
        }
        ... on ResourceContentLink {
          uri
        }
        ... on ResourceContentText {
          text
        }
        ... on ResourceContentEmbed {
          uri
        }
        ... on ResourceContentVideo {
          uri
          hlsUri: hls_uri
          dashUri: dash_uri
          tracks {
            uri
          }
          contentType: content_type
          videoDescription: video_description
          subtitleClass: subtitle_class
        }
        ... on ResourceContentAssessment {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
          examTimeslot: exam_timeslot {
            outline {
              exam {
                timeLimit: time_limit
              }
            }
            maxAllowedSubmissions: max_allowed_submissions
            userSubmissions: user_submissions {
              totalCount: total_count
            }
          }
        }
        ... on ResourceContentCourse {
          courseDetails: course_details {
            courseUuid: course_uuid
          }
        }
        ... on ResourceContentBurislide {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
        }
        ... on ResourceContentBuribookWithActivity {
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
        }
        ... on ResourceContentYoutube {
          uri
          videoId: video_id
        }
        ... on ResourceContentAudio {
          uri
          contentType: content_type
        }
        ... on ResourceContentEpub {
          uri
        }
        ... on ResourceContentFile {
          uri
          previewGraphicUri: preview_graphic_uri
        }
        ... on ResourceContentPdf {
          uri
          contentType: content_type
          previewGraphicUri: preview_graphic_uri
        }
      }
    }
    courseBlock: course_block {
      referenceInfo: reference_info {
        referenceId: reference_id
        customPassingMark: custom_passing_mark
        maxAllowedSubmissions: max_allowed_submissions
        passOnSubmit: pass_on_submit
      }
      userstatus {
        is_complete
        status
        grade_percent
        score_raw
        score_min
        score_max
      }
      maxSubmissionsReached: max_submissions_reached
      title
    }
  }
}
    `;

/**
 * __useResourceViewScreenWithReferenceInfoAndUserStatusQuery__
 *
 * To run a query within a React component, call `useResourceViewScreenWithReferenceInfoAndUserStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewScreenWithReferenceInfoAndUserStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewScreenWithReferenceInfoAndUserStatusQuery({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *      courseBlockUuid: // value for 'courseBlockUuid'
 *   },
 * });
 */
export function useResourceViewScreenWithReferenceInfoAndUserStatusQuery(baseOptions: Apollo.QueryHookOptions<ResourceViewScreenWithReferenceInfoAndUserStatusQuery, ResourceViewScreenWithReferenceInfoAndUserStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewScreenWithReferenceInfoAndUserStatusQuery, ResourceViewScreenWithReferenceInfoAndUserStatusQueryVariables>(ResourceViewScreenWithReferenceInfoAndUserStatusDocument, options);
      }
export function useResourceViewScreenWithReferenceInfoAndUserStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewScreenWithReferenceInfoAndUserStatusQuery, ResourceViewScreenWithReferenceInfoAndUserStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewScreenWithReferenceInfoAndUserStatusQuery, ResourceViewScreenWithReferenceInfoAndUserStatusQueryVariables>(ResourceViewScreenWithReferenceInfoAndUserStatusDocument, options);
        }
export type ResourceViewScreenWithReferenceInfoAndUserStatusQueryHookResult = ReturnType<typeof useResourceViewScreenWithReferenceInfoAndUserStatusQuery>;
export type ResourceViewScreenWithReferenceInfoAndUserStatusLazyQueryHookResult = ReturnType<typeof useResourceViewScreenWithReferenceInfoAndUserStatusLazyQuery>;
export type ResourceViewScreenWithReferenceInfoAndUserStatusQueryResult = Apollo.QueryResult<ResourceViewScreenWithReferenceInfoAndUserStatusQuery, ResourceViewScreenWithReferenceInfoAndUserStatusQueryVariables>;
export const CheckIfXapiCompleteV1Document = gql`
    query CheckIfXapiCompleteV1($resourceUuid: ID!, $courseBlockUuid: String) {
  resource_view_screen(
    resource_uuid: $resourceUuid
    course_block_uuid: $courseBlockUuid
  ) {
    course_block {
      has_user_completed
    }
  }
}
    `;

/**
 * __useCheckIfXapiCompleteV1Query__
 *
 * To run a query within a React component, call `useCheckIfXapiCompleteV1Query` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfXapiCompleteV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfXapiCompleteV1Query({
 *   variables: {
 *      resourceUuid: // value for 'resourceUuid'
 *      courseBlockUuid: // value for 'courseBlockUuid'
 *   },
 * });
 */
export function useCheckIfXapiCompleteV1Query(baseOptions: Apollo.QueryHookOptions<CheckIfXapiCompleteV1Query, CheckIfXapiCompleteV1QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfXapiCompleteV1Query, CheckIfXapiCompleteV1QueryVariables>(CheckIfXapiCompleteV1Document, options);
      }
export function useCheckIfXapiCompleteV1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfXapiCompleteV1Query, CheckIfXapiCompleteV1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfXapiCompleteV1Query, CheckIfXapiCompleteV1QueryVariables>(CheckIfXapiCompleteV1Document, options);
        }
export type CheckIfXapiCompleteV1QueryHookResult = ReturnType<typeof useCheckIfXapiCompleteV1Query>;
export type CheckIfXapiCompleteV1LazyQueryHookResult = ReturnType<typeof useCheckIfXapiCompleteV1LazyQuery>;
export type CheckIfXapiCompleteV1QueryResult = Apollo.QueryResult<CheckIfXapiCompleteV1Query, CheckIfXapiCompleteV1QueryVariables>;
export const CheckIfXapiCompleteDocument = gql`
    query CheckIfXapiComplete($resourceDetailsInput: ResourceDetailsInput!) {
  resourceViewScreenV2: resource_view_screen_v2(
    resource_details_input: $resourceDetailsInput
  ) {
    courseBlock: course_block {
      hasUserComplete: has_user_completed
    }
  }
}
    `;

/**
 * __useCheckIfXapiCompleteQuery__
 *
 * To run a query within a React component, call `useCheckIfXapiCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfXapiCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfXapiCompleteQuery({
 *   variables: {
 *      resourceDetailsInput: // value for 'resourceDetailsInput'
 *   },
 * });
 */
export function useCheckIfXapiCompleteQuery(baseOptions: Apollo.QueryHookOptions<CheckIfXapiCompleteQuery, CheckIfXapiCompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfXapiCompleteQuery, CheckIfXapiCompleteQueryVariables>(CheckIfXapiCompleteDocument, options);
      }
export function useCheckIfXapiCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfXapiCompleteQuery, CheckIfXapiCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfXapiCompleteQuery, CheckIfXapiCompleteQueryVariables>(CheckIfXapiCompleteDocument, options);
        }
export type CheckIfXapiCompleteQueryHookResult = ReturnType<typeof useCheckIfXapiCompleteQuery>;
export type CheckIfXapiCompleteLazyQueryHookResult = ReturnType<typeof useCheckIfXapiCompleteLazyQuery>;
export type CheckIfXapiCompleteQueryResult = Apollo.QueryResult<CheckIfXapiCompleteQuery, CheckIfXapiCompleteQueryVariables>;
export const ResourceAccessibilityDocument = gql`
    query ResourceAccessibility($resourceDetailsInput: ResourceDetailsInput!) {
  resourceViewScreenV2: resource_view_screen_v2(
    resource_details_input: $resourceDetailsInput
  ) {
    courseBlock: course_block {
      isAccessible: is_accessible
      userstatus {
        status
      }
      resource {
        type
      }
    }
  }
}
    `;

/**
 * __useResourceAccessibilityQuery__
 *
 * To run a query within a React component, call `useResourceAccessibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceAccessibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceAccessibilityQuery({
 *   variables: {
 *      resourceDetailsInput: // value for 'resourceDetailsInput'
 *   },
 * });
 */
export function useResourceAccessibilityQuery(baseOptions: Apollo.QueryHookOptions<ResourceAccessibilityQuery, ResourceAccessibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceAccessibilityQuery, ResourceAccessibilityQueryVariables>(ResourceAccessibilityDocument, options);
      }
export function useResourceAccessibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceAccessibilityQuery, ResourceAccessibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceAccessibilityQuery, ResourceAccessibilityQueryVariables>(ResourceAccessibilityDocument, options);
        }
export type ResourceAccessibilityQueryHookResult = ReturnType<typeof useResourceAccessibilityQuery>;
export type ResourceAccessibilityLazyQueryHookResult = ReturnType<typeof useResourceAccessibilityLazyQuery>;
export type ResourceAccessibilityQueryResult = Apollo.QueryResult<ResourceAccessibilityQuery, ResourceAccessibilityQueryVariables>;
export const ResourceViewV2Document = gql`
    query ResourceViewV2($resourceDetailsInput: ResourceDetailsInput!) {
  resourceViewScreenV2: resource_view_screen_v2(
    resource_details_input: $resourceDetailsInput
  ) {
    resourceUuid: resource_uuid
    resource {
      id
      uuid
      type
      subtype
      name
      content {
        ... on ResourceContentXApi {
          id
          uri
        }
        ... on ResourceContentLink {
          id
          uri
        }
        ... on ResourceContentText {
          id
          text
        }
        ... on ResourceContentEmbed {
          id
          uri
        }
        ... on ResourceContentVideo {
          id
          uri
          hlsUri: hls_uri
          dashUri: dash_uri
          tracks {
            uri
          }
          contentType: content_type
          videoDescription: video_description
          subtitleClass: subtitle_class
        }
        ... on ResourceContentAssessment {
          id
          examDetails: exam_details {
            examTimeslotUuid: exam_timeslot_uuid
            maxAllowedSubmissions: max_allowed_submissions
            examItemSet: exam_item_set {
              outline {
                exam {
                  title
                  timeLimit: time_limit
                  sections {
                    title
                    items {
                      uuid
                      text
                      type
                      subtype
                      required
                      showResults: show_results
                      choices {
                        isCorrect: is_correct
                        longInput: long_input
                        imageUrl: image_url
                        shortInput: short_input
                        audioUrl: audio_url
                        item
                        uuid
                        orderId: order_id
                        createdAt: created_at
                        modifiedAt: modified_at
                      }
                      draftValue: draft_value {
                        item
                        longInput: long_input
                        shortInput: short_input
                        choices {
                          uuid
                          shortInput: short_input
                          longInput: long_input
                        }
                      }
                      mediaUrl: media_url
                      isGraded: is_graded
                    }
                  }
                }
              }
              submission {
                uuid
              }
            }
          }
        }
        ... on ResourceContentCourse {
          id
          courseDetails: course_details {
            courseUuid: course_uuid
          }
        }
        ... on ResourceContentBurislide {
          id
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            uris
            imageUri: image_uri
            title
          }
        }
        ... on ResourceContentBuribookWithActivity {
          id
          examDetails: exam_details {
            examUuid: exam_uuid
            examTimeslotUuid: exam_timeslot_uuid
          }
          spreads {
            uri
            spreadType: spread_type
            leftUri: left_uri
            rightUri: right_uri
            uris
            imageUri: image_uri
            title
          }
        }
        ... on ResourceContentYoutube {
          id
          uri
          videoId: video_id
        }
        ... on ResourceContentAudio {
          id
          uri
          contentType: content_type
        }
        ... on ResourceContentEpub {
          id
          uri
        }
        ... on ResourceContentFile {
          id
          uri
          previewGraphicUri: preview_graphic_uri
        }
        ... on ResourceContentPdf {
          id
          uri
          contentType: content_type
          previewGraphicUri: preview_graphic_uri
        }
        ... on ResourceContentCasticulate {
          id
          casticulateUuid: casticulate_uuid
        }
      }
    }
    courseBlock: course_block {
      isAccessible: is_accessible
      referenceInfo: reference_info {
        referenceId: reference_id
        customPassingMark: custom_passing_mark
        maxAllowedSubmissions: max_allowed_submissions
        passOnSubmit: pass_on_submit
      }
      scheduleReferenceInfo: schedule_reference_info {
        referenceId: reference_id
        maxAllowedSubmissions: max_allowed_submissions
      }
      userstatus {
        isComplete: is_complete
        status
        gradePercent: grade_percent
        scoreRaw: score_raw
        scoreMin: score_min
        scoreMax: score_max
        submissionCount: submission_count
      }
      maxSubmissionsReached: max_submissions_reached
      title
      requiredForCertificate: required_for_certificate
      nextBlocksJoined: next_blocks_joined {
        coverUri: cover_uri
        title
        resource {
          id
        }
        uuid
      }
      completeOnFinal: complete_on_final
    }
  }
}
    `;

/**
 * __useResourceViewV2Query__
 *
 * To run a query within a React component, call `useResourceViewV2Query` and pass it any options that fit your needs.
 * When your component renders, `useResourceViewV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceViewV2Query({
 *   variables: {
 *      resourceDetailsInput: // value for 'resourceDetailsInput'
 *   },
 * });
 */
export function useResourceViewV2Query(baseOptions: Apollo.QueryHookOptions<ResourceViewV2Query, ResourceViewV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceViewV2Query, ResourceViewV2QueryVariables>(ResourceViewV2Document, options);
      }
export function useResourceViewV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceViewV2Query, ResourceViewV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceViewV2Query, ResourceViewV2QueryVariables>(ResourceViewV2Document, options);
        }
export type ResourceViewV2QueryHookResult = ReturnType<typeof useResourceViewV2Query>;
export type ResourceViewV2LazyQueryHookResult = ReturnType<typeof useResourceViewV2LazyQuery>;
export type ResourceViewV2QueryResult = Apollo.QueryResult<ResourceViewV2Query, ResourceViewV2QueryVariables>;
export const ScheduleBlockStatusTrainingInfoDocument = gql`
    query ScheduleBlockStatusTrainingInfo($courseUuid: String!, $scheduleUuid: String, $courseBlockUuid: String) {
  courseViewScreen: course_view_screen(
    course_uuid: $courseUuid
    schedule_uuid: $scheduleUuid
  ) {
    scheduleBlockStatus: schedule_block_status(course_block_uuid: $courseBlockUuid) {
      trainingInfo: training_info {
        totalPoints: total_points
        domains {
          uuid
          name
          totalPoints: total_points
          description
          indicators {
            name
            uuid
            displayUnitName: display_unit_name
          }
          children {
            name
            totalPoints: total_points
            uuid
            description
            indicators {
              displayUnitName: display_unit_name
              name
              uuid
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useScheduleBlockStatusTrainingInfoQuery__
 *
 * To run a query within a React component, call `useScheduleBlockStatusTrainingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleBlockStatusTrainingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleBlockStatusTrainingInfoQuery({
 *   variables: {
 *      courseUuid: // value for 'courseUuid'
 *      scheduleUuid: // value for 'scheduleUuid'
 *      courseBlockUuid: // value for 'courseBlockUuid'
 *   },
 * });
 */
export function useScheduleBlockStatusTrainingInfoQuery(baseOptions: Apollo.QueryHookOptions<ScheduleBlockStatusTrainingInfoQuery, ScheduleBlockStatusTrainingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleBlockStatusTrainingInfoQuery, ScheduleBlockStatusTrainingInfoQueryVariables>(ScheduleBlockStatusTrainingInfoDocument, options);
      }
export function useScheduleBlockStatusTrainingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleBlockStatusTrainingInfoQuery, ScheduleBlockStatusTrainingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleBlockStatusTrainingInfoQuery, ScheduleBlockStatusTrainingInfoQueryVariables>(ScheduleBlockStatusTrainingInfoDocument, options);
        }
export type ScheduleBlockStatusTrainingInfoQueryHookResult = ReturnType<typeof useScheduleBlockStatusTrainingInfoQuery>;
export type ScheduleBlockStatusTrainingInfoLazyQueryHookResult = ReturnType<typeof useScheduleBlockStatusTrainingInfoLazyQuery>;
export type ScheduleBlockStatusTrainingInfoQueryResult = Apollo.QueryResult<ScheduleBlockStatusTrainingInfoQuery, ScheduleBlockStatusTrainingInfoQueryVariables>;